import { jsx, jsxs, Fragment as Fragment$1 } from "react/jsx-runtime";
import * as React from "react";
import React__default, { useCallback, isValidElement, useState, useRef, useEffect, createElement, Fragment, useMemo, forwardRef, createContext, useContext, Children } from "react";
import { clsx } from "clsx";
import { twMerge } from "/app/node_modules/.pnpm/tailwind-merge@2.5.2/node_modules/tailwind-merge/dist/bundle-mjs.mjs";
import { useTranslation } from "react-i18next";
import { AnimatePresence, motion } from "motion/react";
import { XIcon, ChevronDown, CheckIcon } from "lucide-react";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";
import { MagnifyingGlassIcon, ChevronRightIcon, CheckIcon as CheckIcon$1, DotFilledIcon, DividerHorizontalIcon, DotsHorizontalIcon, ChevronDownIcon } from "@radix-ui/react-icons";
import { Command as Command$1 } from "cmdk";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import * as SeparatorPrimitive from "@radix-ui/react-separator";
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import * as AlertDialogPrimitive from "@radix-ui/react-alert-dialog";
import * as AvatarPrimitive from "@radix-ui/react-avatar";
import { DayPicker } from "react-day-picker";
import * as RechartsPrimitive from "recharts";
import * as ContextMenuPrimitive from "@radix-ui/react-context-menu";
import * as LabelPrimitive from "@radix-ui/react-label";
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import * as SwitchPrimitives from "@radix-ui/react-switch";
import * as TabsPrimitive from "@radix-ui/react-tabs";
import { useSensors, useSensor, PointerSensor, KeyboardSensor, DndContext, closestCenter } from "@dnd-kit/core";
import { sortableKeyboardCoordinates, SortableContext, verticalListSortingStrategy, useSortable, arrayMove } from "@dnd-kit/sortable";
import { restrictToParentElement, restrictToWindowEdges } from "@dnd-kit/modifiers";
import { CSS } from "@dnd-kit/utilities";
import { isFragment } from "react-is";
import * as ProgressPrimitive from "@radix-ui/react-progress";
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";
import * as ToastPrimitives from "@radix-ui/react-toast";
import * as VisuallyHiddenPrimative from "@radix-ui/react-visually-hidden";
function cn(...inputs) {
  return twMerge(clsx(inputs));
}
function createComponentDisplayNameFilter(name) {
  return (child) => isValidElement(child) && typeof child.type === "function" && child.type.displayName === name;
}
const mergeRefs = (...refs) => {
  return (node) => {
    refs.forEach((ref) => {
      if (typeof ref === "function") {
        ref(node);
      } else if (ref) {
        ref.current = node;
      }
    });
  };
};
function useDefaultTranslation() {
  const { t } = useTranslation();
  const defaultT = useCallback(
    (tid, fallback, values) => tid !== void 0 ? t(tid, values) : fallback,
    [t]
  );
  return {
    t: defaultT
  };
}
const ICON_LIST = [
  "ar-cube-1",
  "archive",
  "arrow-box-right",
  "arrow-corner-down-left",
  "arrow-down",
  "arrow-inbox",
  "arrow-left-right",
  "arrow-left-up-circle",
  "arrow-left-x",
  "arrow-left",
  "arrow-out-of-box",
  "arrow-right",
  "arrow-rotate-clockwise-right",
  "arrow-rotate-right-left",
  "arrow-share-right",
  "arrow-top-bottom",
  "arrow-triangle-bottom",
  "arrow-triangle-top",
  "arrow-up-down-left-right",
  "arrow-up-right",
  "arrow-up",
  "arrow-up",
  "at",
  "avocado",
  "bag-2",
  "bank",
  "bars-three",
  "basket-1",
  "bell-2",
  "bezier-curve",
  "boolean-group-intersect-3",
  "book",
  "brackets-1",
  "brackets-2",
  "broken-chain-link-3",
  "bubble-5",
  "bubble-heart",
  "bullet-list",
  "calculator",
  "calendar-1",
  "calendar-3",
  "camera-1",
  "cat",
  "chain-link-1",
  "chain-link-4",
  "checkmark-2-small",
  "checkmark-2",
  "chevron-bottom",
  "chevron-down-small",
  "chevron-grabber-vertical",
  "chevron-left",
  "chevron-right",
  "chevron-top",
  "circle-check",
  "circle-info",
  "circle-plus",
  "circle-questionmark",
  "circle-x",
  "circle",
  "circles-three",
  "clipboard-2",
  "cloud-simple-download",
  "cloud-simple-upload",
  "cloudy-sun",
  "cmd-box",
  "code-brackets",
  "code",
  "color-palette",
  "color-swatch",
  "colors",
  "column-wide-add",
  "column-wide-remove",
  "console",
  "cross-large",
  "cross-small",
  "cursor-click",
  "cursor-list",
  "date-repeat",
  "divider-line",
  "dossier",
  "dot-grid-1x3-horizontal",
  "dot-grid-1x3-vertical",
  "drop",
  "earth",
  "edit-small-2",
  "electrocardiogram",
  "email-2",
  "email",
  "emoji-smile",
  "eye-open",
  "eye-slash",
  "file-bend",
  "file-download",
  "file-text",
  "files",
  "filter-1",
  "filter-2",
  "filter-asc",
  "filter-ascending",
  "filter-desc",
  "filter-descending",
  "fire-1",
  "focus-flash",
  "folder-2",
  "folder-add-left",
  "folder-open",
  "folder-paper",
  "folder-upload",
  "gift-1",
  "git-pull-request",
  "globus",
  "group-1",
  "growth",
  "hand-5-finger",
  "haptic",
  "hashtag",
  "hat-bunny",
  "heart",
  "history",
  "home-line",
  "hourglass",
  "imac",
  "key-2",
  "layout-column",
  "layout-grid-2",
  "layers-three",
  "light-bulb",
  "lightning",
  "live-activity",
  "live-full",
  "loader",
  "lock",
  "magic-wand-2",
  "magnifying-glass",
  "make-it-pop",
  "map-pin-flat",
  "minus-small",
  "newspaper",
  "numbered-list",
  "page-text-add",
  "page-text-search",
  "page-text",
  "pencil",
  "people-add-2",
  "people-circle-circle",
  "people-like",
  "people-remove-2",
  "people",
  "pets",
  "pin",
  "play",
  "plus-large",
  "plus-small",
  "postcard-2",
  "rainy-light",
  "reorder",
  "rocket",
  "school",
  "scissors-2",
  "settings-gear-2",
  "settings-slider-three",
  "settings-toggle-1",
  "shield-check",
  "shovel",
  "sidebar-left-arrow",
  "sidebar",
  "summary",
  "sparkles-soft",
  "square-arrow-top-right",
  "square-behind-square-1",
  "square-checklist-bell",
  "square-grid-circle",
  "step-back",
  "stop",
  "sunrise",
  "sword",
  "table",
  "text-1",
  "title-case",
  "toolbox",
  "translate",
  "trash-can-2",
  "trash-paper",
  "trending-4",
  "triangle-exclamation",
  "truck",
  "unicorn",
  "vector-logo"
];
const CUSTOM_LIST = [
  "analytics",
  "app",
  "arrow-box-left",
  "arrow-up",
  "assign",
  "at",
  "blur",
  "brain",
  "broom-cleaning",
  "commit",
  "copy-squares",
  "chat-plus",
  "check",
  "chevron-bottom-small",
  "data-clip",
  "date-weekly",
  "dot-grid-2-3",
  "dots-grid-2x3",
  "expand-simple",
  "expand",
  "external-link",
  "first-available",
  "flatfile-logo",
  "flower",
  "focus-square",
  "help-circle",
  "high-priority",
  "layout-window",
  "library",
  "list",
  "list-sparkle",
  "list-bullets",
  "list-sparkle",
  "low-priority",
  "magic-book",
  "medium-priority",
  "merge",
  "minimize",
  "paperclip",
  "pause",
  "prepare-vector",
  "refresh",
  "save",
  "sidebar-right-arrow",
  "sidebar-right-arrow-thin",
  "single-value",
  "sparkles-three",
  "split",
  "split-down",
  "square-behind-square",
  "status-checkmark-circle",
  "status-circle",
  "status-dotted-circle",
  "status-half-circle",
  "status-warning-circle",
  "status-warning-triangle",
  "status-x-circle",
  "stop-circle",
  "three-dots-horizontal",
  "wrench",
  "sidebar-left",
  "chat-square",
  "transform-wand"
];
const nameMap = {
  email: "email-2",
  checkmark: "checkmark-2"
};
const sizeMap = {
  8: "size-2 text-[12px]",
  10: "size-2.5 text-[12px]",
  12: "size-3 text-[12px]",
  16: "size-4 text-[16px]",
  20: "size-5 text-[20px]",
  24: "size-6 text-[24px]",
  32: "size-8 text-[32px]"
};
const Icon = ({
  name,
  color = "",
  weight = "normal",
  variant = "outline",
  size = 16,
  className,
  ...props
}) => {
  const mappedName = nameMap[name] ?? name;
  const isCustom = CUSTOM_LIST.includes(name);
  const mergedClassName = cn(
    `flex items-center justify-center icon`,
    {
      [`icon-${mappedName}-${variant}-${weight}`]: !isCustom,
      [`icon-${mappedName}`]: isCustom
    },
    sizeMap[size],
    className
  );
  const colorOverride = color ? `text-${color}` : "";
  return /* @__PURE__ */ jsx("i", { className: `${mergedClassName} ${colorOverride}`, ...props });
};
const SubmitButton = ({ disabled, ...props }) => {
  return /* @__PURE__ */ jsx(
    "button",
    {
      className: cn(
        "flex size-7 items-center justify-center rounded border shrink-0 transition-colors",
        {
          "border-transparent bg-black-opacity-1 text-base-white": !disabled,
          "border-input text-input bg-inherit": disabled
        }
      ),
      ...props,
      children: /* @__PURE__ */ jsx(Icon, { name: "arrow-up", size: 12 })
    }
  );
};
const NON_BREAKING_SPACE = " ";
const valueToHTML = (value) => {
  const html = value.split("\n").reduce((memo, text, index, arr) => {
    memo.push(text.replace(/(\s+)$/g, NON_BREAKING_SPACE));
    if (index !== arr.length - 1) {
      memo.push(/* @__PURE__ */ jsx("br", {}));
    }
    return memo;
  }, []);
  if (html.length === 1 && html[0] === "") {
    return [NON_BREAKING_SPACE];
  }
  return html;
};
function MessageInput({
  tidPlaceholder,
  actionSlot,
  onSubmit
}) {
  const { t } = useDefaultTranslation();
  const [htmlValue, setHTMLValue] = useState([
    NON_BREAKING_SPACE
  ]);
  const [height, setHeight] = useState(null);
  const ref = useRef(null);
  const cloneRef = useRef(null);
  const [value, setValue] = useState("");
  const handleSubmit = (e) => {
    e == null ? void 0 : e.preventDefault();
    if (value.trim()) {
      onSubmit(value.trim());
      setValue("");
      setHTMLValue([NON_BREAKING_SPACE]);
    }
  };
  const onKeyDown = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      handleSubmit();
    }
  };
  const onChange = (event) => {
    const newValue = event.target.value;
    const newHTMLValue = valueToHTML(newValue);
    setHTMLValue(newHTMLValue);
    setValue(newValue);
  };
  useEffect(() => {
    if (cloneRef.current) {
      const ro = new ResizeObserver((entries) => {
        const entry = entries[0];
        setHeight(entry.borderBoxSize[0].blockSize);
      });
      ro.observe(cloneRef.current);
      return () => ro.disconnect();
    }
  }, []);
  return /* @__PURE__ */ jsx("form", { onSubmit: handleSubmit, className: "w-full", children: /* @__PURE__ */ jsxs(
    "div",
    {
      className: cn("bg-base-white w-full", {
        "flex flex-col gap-2": actionSlot
      }),
      children: [
        /* @__PURE__ */ jsxs("div", { className: "flex items-end gap-3", children: [
          /* @__PURE__ */ jsx(
            "textarea",
            {
              ref,
              className: "w-80 grow resize-none overflow-hidden border-none bg-inherit text-md outline-none transition-all",
              placeholder: t(tidPlaceholder, "Add your comment here…"),
              value,
              onChange,
              onKeyDown,
              style: {
                height: `${height}px`
              }
            }
          ),
          /* @__PURE__ */ jsx(
            "div",
            {
              ref: cloneRef,
              className: "pointer-events-none invisible absolute w-80 overflow-hidden py-1.5 pl-1.5 text-md",
              children: createElement(Fragment, {}, ...htmlValue)
            }
          ),
          !actionSlot && /* @__PURE__ */ jsx(SubmitButton, { disabled: !value.trim() })
        ] }),
        actionSlot && /* @__PURE__ */ jsxs("div", { className: "flex items-end gap-2", children: [
          /* @__PURE__ */ jsx("div", { className: "grow", children: actionSlot }),
          /* @__PURE__ */ jsx(SubmitButton, { disabled: !value.trim() })
        ] })
      ]
    }
  ) });
}
const ChatInput = ({
  className,
  tidPlaceholder,
  onSubmit,
  context,
  onRemoveContext
}) => {
  const actions = useMemo(() => {
    return /* @__PURE__ */ jsxs("div", { className: "flex gap-2", children: [
      /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "icon-md", icon: "paperclip" }),
      /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "icon-md", icon: "at" })
    ] });
  }, []);
  const contextSlot = useMemo(() => {
    if (!context) return null;
    return /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2 bg-background-90 px-3 py-2", children: [
      /* @__PURE__ */ jsx(Icon, { name: "cursor-list", className: "shrink-0" }),
      /* @__PURE__ */ jsx(Text$1, { variant: "callout", className: "grow truncate", children: context }),
      /* @__PURE__ */ jsx(
        "button",
        {
          onClick: onRemoveContext,
          className: "shrink-0 rounded-full text-muted hover:text-foreground",
          children: /* @__PURE__ */ jsx(Icon, { name: "circle-x", variant: "outline" })
        }
      )
    ] });
  }, [context, onRemoveContext]);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: cn(
        "flex flex-col items-end rounded-lg border border-border bg-base-white overflow-hidden",
        className
      ),
      children: [
        /* @__PURE__ */ jsx(AnimatePresence, { children: contextSlot && /* @__PURE__ */ jsx(
          motion.div,
          {
            className: "w-full",
            initial: slideDownInitial,
            animate: slideDownAnimate,
            exit: slideDownInitial,
            children: contextSlot
          }
        ) }),
        /* @__PURE__ */ jsx("div", { className: "w-full bg-base-white p-2", children: /* @__PURE__ */ jsx(
          MessageInput,
          {
            tidPlaceholder,
            onSubmit,
            actionSlot: actions
          }
        ) })
      ]
    }
  );
};
const slideDownInitial = {
  // opacity: 0,
  height: 0
};
const slideDownAnimate = {
  // opacity: 1,
  height: "auto"
};
const spinnerVariants = cva("", {
  variants: {
    size: {
      8: "size-2 text-8",
      10: "size-2.5 text-10",
      12: "size-3 text-12",
      16: "size-4 text-16",
      20: "size-5 text-20",
      24: "size-6 text-24",
      32: "size-8 text-32"
    },
    variant: {
      primary: "fill-primary text-foreground-80",
      destructive: "fill-destructive text-destructive-80"
    }
  },
  defaultVariants: {
    size: 16,
    variant: "primary"
  }
});
const Spinner = ({ className, variant, size = 24 }) => {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      className: cn(spinnerVariants({ size }), "animate-spin", className),
      "data-testid": "spinner-icon",
      role: "img",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx("title", { children: "Loading spinner" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            className: "fill-neutral-gray-4",
            fillRule: "evenodd",
            d: "M12 19a7 7 0 100-14 7 7 0 000 14zm0 3c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
            clipRule: "evenodd",
            opacity: "0.5"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            className: cn(spinnerVariants({ variant })),
            d: "M2 12C2 6.477 6.477 2 12 2v3a7 7 0 00-7 7H2z"
          }
        )
      ]
    }
  );
};
const variantStyles$1 = {
  primary: "hover:bg-primary-90 text-primary-foreground-100 disabled:bg-primary-10 disabled:text-muted-foreground-80 border disabled:hover:bg-primary-10",
  destructive: "bg-destructive-90 text-primary-foreground-100 border border-gray-1 hover:bg-destructive-100 disabled:bg-background-80 disabled:text-destructive-80 disabled:border-destructive-80 disabled:hover:bg-background-80",
  warning: "bg-amber-9 disabled:bg-amber-3 hover:bg-amber-7 disabled:hover:bg-amber-3",
  outline: "bg-transparent border border-input hover:bg-muted-40 disabled:text-muted-foreground-80 disabled:border-input disabled:bg-muted-50 disabled:hover:bg-muted-50 disabled:hover:border-input",
  "outline-destructive": "text-destructive-foreground-100 border border-black-opacity-7 hover:bg-muted-40 disabled:text-destructive-80 disabled:border-destructive-50 disabled:hover:bg-transparent disabled:hover:border-destructive-50",
  secondary: "bg-secondary text-primary border hover:bg-secondary-90 disabled:bg-secondary-80 disabled:text-muted-foreground-80 disabled:hover:bg-secondary-80 disabled:hover:border",
  ghost: "text-muted-foreground border-none hover:bg-muted-40 disabled:text-muted-foreground-80 disabled:hover:bg-transparent",
  "ghost-destructive": "text-destructive-foreground-100 hover:bg-transparent disabled:text-destructive-80",
  "ghost-affirmative": "text-green-9 hover:bg-transparent disabled:text-green-5",
  link: "text-primary underline-offset-4 hover:underline disabled:hover:no-underline"
};
const buttonSizes = {
  md: "gap-2 rounded-sm px-3.5 py-1.5 text-base font-medium",
  sm: "gap-2 rounded-sm px-3 py-1 text-base font-medium",
  lg: "gap-2 rounded-md px-3 py-2.5 text-base font-medium",
  "icon-sm": "size-4 border-transparent rounded-xs flex-shrink-0",
  "icon-md": "size-7 border-transparent rounded-sm flex-shrink-0",
  "icon-lg": "size-8 border-transparent rounded-sm flex-shrink-0",
  "icon-xl": "size-10 border-transparent rounded-sm flex-shrink-0"
};
const activeStyles = {
  true: "",
  false: ""
};
const buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring",
  {
    variants: {
      variant: variantStyles$1,
      size: buttonSizes,
      active: activeStyles
    },
    compoundVariants: [
      {
        variant: "primary",
        active: true,
        class: "bg-primary-90"
      },
      {
        variant: "primary",
        active: false,
        class: "bg-primary"
      },
      {
        variant: "destructive",
        active: true,
        class: "bg-destructive"
      },
      {
        variant: "destructive",
        active: false,
        class: "bg-destructive-90"
      },
      {
        variant: "warning",
        active: true,
        class: "bg-amber-7"
      },
      {
        variant: "warning",
        active: false,
        class: "bg-amber-9"
      },
      {
        variant: "outline",
        active: true,
        class: "border-transparent bg-muted-40"
      },
      {
        variant: "outline",
        active: false,
        class: "bg-transparent"
      },
      {
        variant: "outline-destructive",
        active: true,
        class: "bg-muted-40"
      },
      {
        variant: "outline-destructive",
        active: false,
        class: ""
      },
      {
        variant: "secondary",
        active: true,
        class: "border-transparent bg-secondary-80"
      },
      {
        variant: "secondary",
        active: false,
        class: "bg-secondary"
      },
      {
        variant: "ghost",
        active: true,
        class: "bg-accent text-muted-foreground"
      }
    ],
    defaultVariants: {
      variant: "primary",
      size: "md",
      active: void 0
    }
  }
);
const iconSizeMap = {
  md: 16,
  sm: 16,
  lg: 20,
  "icon-sm": 10,
  "icon-md": 16,
  "icon-lg": 16,
  "icon-xl": 20
};
const Button = React.forwardRef(
  ({
    active = false,
    asChild = false,
    children,
    className,
    icon,
    iconPlacement = "left",
    iconProps,
    loading,
    size,
    slotLeft,
    slotRight,
    variant,
    disableTheming,
    ...props
  }, ref) => {
    const Comp = asChild ? Slot : "button";
    const buttonSize = size ?? "md";
    const rightIcon = icon && iconPlacement === "right";
    const leftIcon = icon && iconPlacement === "left";
    const overrideTargetId = `ff_baseline_${variant ?? "primary"}_button`;
    return /* @__PURE__ */ jsxs(
      Comp,
      {
        "data-override-targetid": overrideTargetId,
        className: cn(
          buttonVariants({ variant, size, className, active }),
          "disabled:pointer-events-auto",
          disableTheming && "theme-static"
        ),
        ref,
        ...props,
        children: [
          leftIcon && /* @__PURE__ */ jsx(
            Icon,
            {
              className: cn(
                "pointer-events-none",
                disableTheming && "theme-static"
              ),
              name: icon,
              variant: "outline",
              size: iconSizeMap[buttonSize],
              ...iconProps
            }
          ),
          loading && leftIcon && /* @__PURE__ */ jsx(Spinner, { size: iconSizeMap[buttonSize], variant }),
          slotLeft,
          children,
          slotRight,
          rightIcon && !loading && /* @__PURE__ */ jsx(
            Icon,
            {
              className: cn(
                "pointer-events-none",
                disableTheming && "theme-static"
              ),
              name: icon,
              variant: "outline",
              size: iconSizeMap[buttonSize],
              ...iconProps
            }
          ),
          loading && !leftIcon && /* @__PURE__ */ jsx(
            Spinner,
            {
              className: cn(disableTheming && "theme-static"),
              size: iconSizeMap[buttonSize],
              variant
            }
          )
        ]
      }
    );
  }
);
Button.displayName = "Button";
const variantStyles = {
  largeTitle: "text-3xl",
  title1: "text-2xl",
  title2: "text-xl",
  title3: "text-lg",
  headline: "text-base",
  body: "text-base",
  callout: "text-sm",
  subheadline: "text-xs",
  footnote: "text-xxs",
  caption1: "text-xxs",
  caption2: "text-xxs",
  link: "text-base underline"
};
const textVariants = cva("font-sans", {
  variants: {
    variant: variantStyles,
    emphasized: {
      false: "font-normal",
      true: ""
    }
  },
  compoundVariants: [
    {
      variant: "largeTitle",
      emphasized: true,
      class: "font-bold"
    },
    {
      variant: "title1",
      emphasized: true,
      class: "font-bold"
    },
    {
      variant: "title2",
      emphasized: true,
      class: "font-bold"
    },
    {
      variant: "title3",
      emphasized: true,
      class: "font-medium"
    },
    {
      variant: "headline",
      emphasized: true,
      class: "font-bold"
    },
    {
      variant: "body",
      emphasized: true,
      class: "font-medium"
    },
    {
      variant: "callout",
      emphasized: true,
      class: "font-medium"
    },
    {
      variant: "subheadline",
      emphasized: true,
      class: "font-medium"
    },
    {
      variant: "footnote",
      emphasized: true,
      class: "font-medium"
    },
    {
      variant: "caption1",
      emphasized: true,
      class: "font-medium"
    },
    {
      variant: "caption2",
      emphasized: false,
      class: "font-medium"
    },
    {
      variant: "caption2",
      emphasized: true,
      class: "font-bold"
    }
  ],
  defaultVariants: {
    variant: "body"
  }
});
const Text$1 = React.forwardRef(
  ({
    as = "span",
    children,
    className,
    color,
    emphasized = false,
    tid,
    values,
    variant,
    ...props
  }, ref) => {
    const Comp = as;
    const { t } = useDefaultTranslation();
    const colorOverride = color ? `text-${color}` : "";
    return /* @__PURE__ */ jsx(
      Comp,
      {
        ref,
        className: cn(
          textVariants({ variant, className, emphasized }),
          colorOverride
        ),
        ...props,
        children: t(tid, children, values)
      }
    );
  }
);
Text$1.displayName = "Text";
const Dialog = DialogPrimitive.Root;
const DialogPortal = DialogPrimitive.Portal;
const DialogClose = DialogPrimitive.Close;
const DialogCloseButton = React.forwardRef(({ className, children, ...props }, ref) => /* @__PURE__ */ jsx(DialogClose, { asChild: true, ref, children: /* @__PURE__ */ jsx(Button, { variant: "secondary", ...props, children: children || "Close" }) }));
DialogCloseButton.displayName = "DialogCloseButton";
const DialogTrigger = React.forwardRef(({ children }, ref) => /* @__PURE__ */ jsx(DialogPrimitive.Trigger, { ref, asChild: true, children }));
DialogTrigger.displayName = DialogPrimitive.Trigger.displayName;
const DialogOverlay = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  DialogPrimitive.Overlay,
  {
    ref,
    className: cn(
      className,
      !(className == null ? void 0 : className.includes("absolute")) && "fixed",
      "inset-0 z-50 backdrop-blur data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0"
    ),
    ...props
  }
));
DialogOverlay.displayName = DialogPrimitive.Overlay.displayName;
const DialogContent = React.forwardRef(
  ({
    className,
    children,
    disablePortal = false,
    fullscreen = false,
    ...props
  }, ref) => {
    const regularAnimationClasses = "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%]";
    const fullscreenAnimationClasses = "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-right-full";
    const content = /* @__PURE__ */ jsxs(Fragment$1, { children: [
      /* @__PURE__ */ jsx(
        DialogOverlay,
        {
          className: cn(
            disablePortal && "absolute",
            fullscreen && "bg-popover"
          )
        }
      ),
      /* @__PURE__ */ jsx(
        DialogPrimitive.Content,
        {
          ref,
          className: cn(
            "shadow-dialog break-word-legacy fixed z-50 grid gap-4 border border-neutral-gray-3 bg-popover p-6 duration-200",
            fullscreen ? fullscreenAnimationClasses : regularAnimationClasses,
            fullscreen ? "inset-0 w-full h-full border-0 shadow-none" : "min-w-0 left-[50%] top-[50%] w-full max-w-lg translate-x-[-50%] translate-y-[-50%] sm:rounded-lg",
            // Regular dialog styles
            "focus:outline-none",
            className
          ),
          ...props,
          children
        }
      )
    ] });
    return disablePortal ? content : /* @__PURE__ */ jsx(DialogPortal, { children: content });
  }
);
DialogContent.displayName = DialogPrimitive.Content.displayName;
const DialogHeader = ({
  className,
  ...props
}) => /* @__PURE__ */ jsx("div", { className: cn("flex flex-col space-y-1.5", className), ...props });
DialogHeader.displayName = "DialogHeader";
const DialogFooter = ({
  className,
  ...props
}) => /* @__PURE__ */ jsx(
  "div",
  {
    className: cn(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
      className
    ),
    ...props
  }
);
DialogFooter.displayName = "DialogFooter";
const DialogTitle = React.forwardRef(({ ...props }, ref) => /* @__PURE__ */ jsx(DialogPrimitive.Title, { ref, children: /* @__PURE__ */ jsx(Text$1, { variant: "title3", emphasized: true, ...props }) }));
DialogTitle.displayName = DialogPrimitive.Title.displayName;
const DialogDescription = React.forwardRef(({ ...props }, ref) => /* @__PURE__ */ jsx(DialogPrimitive.Description, { ref, children: /* @__PURE__ */ jsx(Text$1, { variant: "body", className: "text-gray-11", ...props }) }));
DialogDescription.displayName = DialogPrimitive.Description.displayName;
const BoundedDialogContainer = React.forwardRef(({ children, className, ...props }, ref) => /* @__PURE__ */ jsx("div", { ref, className: cn("relative h-full", className), ...props, children }));
BoundedDialogContainer.displayName = "BoundedDialogContainer";
const Command = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  Command$1,
  {
    ref,
    className: cn(
      "flex h-full w-full flex-col overflow-hidden rounded-md bg-popover text-popover-foreground",
      className
    ),
    ...props
  }
));
Command.displayName = Command$1.displayName;
const CommandInput = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsxs("div", { className: "flex items-center border-b px-3", "cmdk-input-wrapper": "", children: [
  /* @__PURE__ */ jsx(MagnifyingGlassIcon, { className: "mr-2 size-4 shrink-0 opacity-50" }),
  /* @__PURE__ */ jsx(
    Command$1.Input,
    {
      ref,
      className: cn(
        "flex h-10 w-full rounded-md bg-transparent py-3 text-sm outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
        className
      ),
      ...props
    }
  )
] }));
CommandInput.displayName = Command$1.Input.displayName;
const CommandList = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  Command$1.List,
  {
    ref,
    className: cn("max-h-[300px] overflow-y-auto overflow-x-hidden", className),
    ...props
  }
));
CommandList.displayName = Command$1.List.displayName;
const CommandEmpty = React.forwardRef((props, ref) => /* @__PURE__ */ jsx(
  Command$1.Empty,
  {
    ref,
    className: "py-6 text-center text-sm",
    ...props
  }
));
CommandEmpty.displayName = Command$1.Empty.displayName;
const CommandGroup = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  Command$1.Group,
  {
    ref,
    className: cn(
      "overflow-hidden p-1 text-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground",
      className
    ),
    ...props
  }
));
CommandGroup.displayName = Command$1.Group.displayName;
const CommandSeparator = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  Command$1.Separator,
  {
    ref,
    className: cn("-mx-1 h-px bg-border", className),
    ...props
  }
));
CommandSeparator.displayName = Command$1.Separator.displayName;
const CommandItem = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  Command$1.Item,
  {
    ref,
    className: cn(
      "relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none data-[disabled=true]:pointer-events-none data-[selected=true]:bg-accent data-[selected=true]:text-accent-foreground data-[disabled=true]:opacity-50",
      className
    ),
    ...props
  }
));
CommandItem.displayName = Command$1.Item.displayName;
const Popover = PopoverPrimitive.Root;
const PopoverTrigger = PopoverPrimitive.Trigger;
const PopoverAnchor = PopoverPrimitive.Anchor;
const PopoverContent = React.forwardRef(({ className, align = "center", sideOffset = 4, ...props }, ref) => /* @__PURE__ */ jsx(PopoverPrimitive.Portal, { children: /* @__PURE__ */ jsx(
  PopoverPrimitive.Content,
  {
    ref,
    align,
    sideOffset,
    className: cn(
      "z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 max-h-[80vh] overflow-y-auto",
      className
    ),
    ...props
  }
) }));
PopoverContent.displayName = PopoverPrimitive.Content.displayName;
const Separator = React.forwardRef(
  ({ className, orientation = "horizontal", decorative = true, ...props }, ref) => /* @__PURE__ */ jsx(
    SeparatorPrimitive.Root,
    {
      ref,
      decorative,
      orientation,
      className: cn(
        "shrink-0 bg-border",
        orientation === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
        className
      ),
      ...props
    }
  )
);
Separator.displayName = SeparatorPrimitive.Root.displayName;
const useTriggerWidth = (isPopoverOpen, ref) => {
  const [popoverWidth, setPopoverWidth] = useState(0);
  useEffect(() => {
    if (isPopoverOpen && ref.current) {
      setPopoverWidth(ref.current.offsetWidth);
    }
  }, [isPopoverOpen]);
  return { width: popoverWidth };
};
const DropdownInput = React.forwardRef(
  ({
    options,
    onValueChange,
    defaultValue = [],
    defaultOpen = false,
    placeholder = "Select option",
    modalPopover = true,
    asChild = false,
    className,
    value,
    matchTriggerWidth = true,
    controls = false,
    disableClear = false,
    disableSearch = false,
    variant = "default",
    icon,
    label,
    ...props
  }, ref) => {
    const rendered = React.useRef(false);
    const buttonRef = React.useRef(null);
    const mergedRef = mergeRefs(buttonRef, ref);
    const isGhost = variant === "ghost";
    const [selectedValues, setSelectedValues] = React.useState(defaultValue);
    const [isPopoverOpen, setIsPopoverOpen] = React.useState(defaultOpen);
    const popoverStyle = useTriggerWidth(isPopoverOpen, buttonRef);
    React.useEffect(() => {
      const valueToSet = Array.isArray(value) ? value[0] : value;
      if (valueToSet) {
        setSelectedValues([valueToSet]);
      } else if (rendered.current) {
        setSelectedValues([]);
      }
    }, [value]);
    React.useEffect(() => {
      rendered.current = true;
    }, []);
    const handleInputKeyDown = (event) => {
      if (event.key === "Enter") {
        setIsPopoverOpen(true);
      } else if (event.key === "Backspace" && !event.currentTarget.value) {
        const newSelectedValues = [...selectedValues];
        newSelectedValues.pop();
        setSelectedValues(newSelectedValues);
        onValueChange(newSelectedValues);
      }
    };
    const toggleOption = (option) => {
      setSelectedValues([option]);
      onValueChange([option]);
      setIsPopoverOpen(false);
    };
    const handleClear = () => {
      setSelectedValues([]);
      onValueChange([]);
    };
    const handleTogglePopover = () => {
      setIsPopoverOpen((prev) => !prev);
    };
    return /* @__PURE__ */ jsxs(
      Popover,
      {
        open: isPopoverOpen,
        onOpenChange: setIsPopoverOpen,
        modal: modalPopover,
        children: [
          /* @__PURE__ */ jsx(PopoverTrigger, { asChild: true, children: /* @__PURE__ */ jsx(
            Button,
            {
              ref: mergedRef,
              ...props,
              onClick: handleTogglePopover,
              variant: "secondary",
              icon,
              className: cn(
                "flex w-full px-2.5 py-2 rounded-md border min-h-10 h-auto items-center justify-between bg-inherit hover:bg-inherit",
                { "border-none": isGhost },
                { "pl-3": icon },
                className
              ),
              children: selectedValues.length > 0 && !label ? /* @__PURE__ */ jsxs("div", { className: "flex w-full items-center justify-between", children: [
                /* @__PURE__ */ jsx("div", { className: "flex flex-wrap items-center", children: selectedValues.slice(0, 1).map((value2, index) => {
                  const option = options.find((o) => o.value === value2);
                  return /* @__PURE__ */ jsx(
                    "span",
                    {
                      className: "mx-2 text-foreground",
                      children: option == null ? void 0 : option.label
                    },
                    `${value2}-${index}`
                  );
                }) }),
                /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between", children: [
                  !disableClear && /* @__PURE__ */ jsxs(Fragment$1, { children: [
                    /* @__PURE__ */ jsx(
                      "div",
                      {
                        role: "button",
                        "aria-label": "clear",
                        onClick: (event) => {
                          event.stopPropagation();
                          handleClear();
                        },
                        children: /* @__PURE__ */ jsx(XIcon, { className: "mx-2 h-4 cursor-pointer text-foreground" })
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      Separator,
                      {
                        orientation: "vertical",
                        className: "flex h-full min-h-6"
                      }
                    )
                  ] }),
                  /* @__PURE__ */ jsx(ChevronDown, { className: "mx-2 h-4 cursor-pointer text-foreground" })
                ] })
              ] }) : /* @__PURE__ */ jsxs("div", { className: "mx-auto flex w-full items-center justify-between", children: [
                /* @__PURE__ */ jsx("span", { className: "mx-3 text-sm text-muted", children: label ?? placeholder }),
                /* @__PURE__ */ jsx(ChevronDown, { className: "mx-2 h-4 cursor-pointer text-foreground" })
              ] })
            }
          ) }),
          /* @__PURE__ */ jsx(
            PopoverContent,
            {
              className: "w-auto p-0",
              align: "start",
              onEscapeKeyDown: () => setIsPopoverOpen(false),
              style: matchTriggerWidth ? popoverStyle : void 0,
              children: /* @__PURE__ */ jsxs(Command, { children: [
                !disableSearch && /* @__PURE__ */ jsx(
                  CommandInput,
                  {
                    placeholder: "Search...",
                    onKeyDown: handleInputKeyDown
                  }
                ),
                /* @__PURE__ */ jsxs(CommandList, { children: [
                  /* @__PURE__ */ jsx(CommandEmpty, { children: "No results found." }),
                  /* @__PURE__ */ jsx(CommandGroup, { children: options.map((option) => {
                    const isSelected = selectedValues.includes(option.value);
                    return /* @__PURE__ */ jsxs(
                      CommandItem,
                      {
                        onSelect: () => toggleOption(option.value),
                        className: "cursor-pointer",
                        "data-testid": `option-${option.label}`,
                        children: [
                          /* @__PURE__ */ jsx(
                            "div",
                            {
                              className: cn(
                                "mr-2 flex h-4 w-4 items-center justify-center",
                                isSelected ? "" : "opacity-50 [&_svg]:invisible"
                              ),
                              children: /* @__PURE__ */ jsx(CheckIcon, { className: "size-4" })
                            }
                          ),
                          /* @__PURE__ */ jsx("span", { children: option.label })
                        ]
                      },
                      option.value.toString()
                    );
                  }) }),
                  controls && /* @__PURE__ */ jsxs(Fragment$1, { children: [
                    /* @__PURE__ */ jsx(CommandSeparator, {}),
                    /* @__PURE__ */ jsx(CommandGroup, { children: /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between", children: [
                      selectedValues.length > 0 && /* @__PURE__ */ jsxs(Fragment$1, { children: [
                        /* @__PURE__ */ jsx(
                          CommandItem,
                          {
                            onSelect: handleClear,
                            className: "flex-1 cursor-pointer justify-center",
                            children: "Clear"
                          }
                        ),
                        /* @__PURE__ */ jsx(
                          Separator,
                          {
                            orientation: "vertical",
                            className: "flex h-full min-h-6"
                          }
                        )
                      ] }),
                      /* @__PURE__ */ jsx(
                        CommandItem,
                        {
                          onSelect: () => setIsPopoverOpen(false),
                          className: "max-w-full flex-1 cursor-pointer justify-center",
                          children: "Close"
                        }
                      )
                    ] }) })
                  ] })
                ] })
              ] })
            }
          )
        ]
      }
    );
  }
);
DropdownInput.displayName = "DropdownInput";
const badgeVariantOptions = {
  default: "bg-primary text-primary-foreground-90 border-transparent shadow",
  secondary: "bg-gray-3 text-gray-12 border-transparent",
  destructive: "bg-destructive text-primary-foreground-90 border-transparent shadow",
  outline: "text-foreground",
  "outline-success": "text-green-9 border-green-5 bg-white-opacity-1"
};
const badgeRadiusOptions = {
  default: "rounded-sm",
  full: "rounded-full"
};
const badgeVariants = cva(
  "inline-flex h-5 items-center border px-2.5 py-0.5 text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2",
  {
    variants: {
      variant: badgeVariantOptions,
      radius: badgeRadiusOptions
    },
    defaultVariants: {
      variant: "default",
      radius: "default"
    }
  }
);
function Badge({ className, variant, radius, ...props }) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: cn(badgeVariants({ variant, radius }), className),
      ...props
    }
  );
}
const MultiSelect = React.forwardRef(
  ({
    options,
    onValueChange,
    defaultValue = [],
    defaultOpen = false,
    placeholder = "Select options",
    maxCount = 3,
    modalPopover = true,
    asChild = false,
    className,
    values,
    matchTriggerWidth = true,
    disableSelectAll = false,
    tidClear,
    tidClose,
    tidPlaceholder,
    tidSelectAll,
    tidMore,
    tidNoResults,
    tidSearch,
    onClose,
    disableSearch = false,
    icon,
    ...props
  }, ref) => {
    const { t } = useTranslation();
    const [selectedValues, setSelectedValues] = React.useState(defaultValue);
    const [isPopoverOpen, setIsPopoverOpenState] = React.useState(defaultOpen);
    const setIsPopoverOpen = (isOpen) => {
      setIsPopoverOpenState(isOpen);
      if (!isOpen) {
        onClose == null ? void 0 : onClose(selectedValues);
      }
    };
    const buttonRef = React.useRef(null);
    const mergedRef = mergeRefs(buttonRef, ref);
    const popoverStyle = useTriggerWidth(isPopoverOpen, buttonRef);
    React.useEffect(() => {
      if (values) {
        setSelectedValues(values);
      } else {
        setSelectedValues([]);
      }
    }, [values]);
    const handleInputKeyDown = (event) => {
      if (event.key === "Enter") {
        setIsPopoverOpen(true);
      } else if (event.key === "Backspace" && !event.currentTarget.value) {
        const newSelectedValues = [...selectedValues];
        newSelectedValues.pop();
        setSelectedValues(newSelectedValues);
        onValueChange == null ? void 0 : onValueChange(newSelectedValues);
      }
    };
    const toggleOption = (option) => {
      const newSelectedValues = selectedValues.includes(option) ? selectedValues.filter((value) => value !== option) : [...selectedValues, option];
      setSelectedValues(newSelectedValues);
      onValueChange == null ? void 0 : onValueChange(newSelectedValues);
    };
    const handleClear = () => {
      setSelectedValues([]);
      onValueChange == null ? void 0 : onValueChange([]);
    };
    const handleTogglePopover = () => {
      setIsPopoverOpen(!isPopoverOpen);
    };
    const clearExtraOptions = () => {
      const newSelectedValues = selectedValues.slice(0, maxCount);
      setSelectedValues(newSelectedValues);
      onValueChange == null ? void 0 : onValueChange(newSelectedValues);
    };
    const toggleAll = () => {
      if (selectedValues.length === options.length) {
        handleClear();
      } else {
        const allValues = options.map((option) => option.value);
        setSelectedValues(allValues);
        onValueChange == null ? void 0 : onValueChange(allValues);
      }
    };
    return /* @__PURE__ */ jsxs(
      Popover,
      {
        open: isPopoverOpen,
        onOpenChange: setIsPopoverOpen,
        modal: modalPopover,
        children: [
          /* @__PURE__ */ jsx(PopoverTrigger, { asChild: true, children: /* @__PURE__ */ jsx(
            Button,
            {
              ref: mergedRef,
              ...props,
              onClick: handleTogglePopover,
              variant: "secondary",
              icon,
              className: cn(
                "flex w-full p-1 rounded-md border min-h-10 h-auto items-center justify-between bg-inherit hover:bg-inherit hover:border-inherit",
                { "pl-3": icon },
                className
              ),
              children: selectedValues.length > 0 ? /* @__PURE__ */ jsxs("div", { className: "flex w-full items-center justify-between", children: [
                /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center", children: [
                  selectedValues.slice(0, maxCount).map((value) => {
                    const option = options.find((o) => o.value === value);
                    return /* @__PURE__ */ jsxs(
                      Badge,
                      {
                        className: cn(
                          "border-foreground/1 bg-transparent text-foreground",
                          "m-1 bg-card border-foreground/10 text-foreground"
                        ),
                        children: [
                          option == null ? void 0 : option.label,
                          /* @__PURE__ */ jsx(
                            "button",
                            {
                              onClick: (event) => {
                                event.stopPropagation();
                                toggleOption(value);
                              },
                              children: /* @__PURE__ */ jsx(Icon, { name: "cross-small", size: 16 })
                            }
                          )
                        ]
                      },
                      value.toString()
                    );
                  }),
                  selectedValues.length > maxCount && /* @__PURE__ */ jsxs(
                    Badge,
                    {
                      className: cn(
                        "border-foreground/1 bg-transparent text-foreground",
                        "m-1 bg-card border-foreground/10 text-foreground"
                      ),
                      children: [
                        `+ ${selectedValues.length - maxCount} more`,
                        /* @__PURE__ */ jsx(
                          "button",
                          {
                            onClick: (event) => {
                              event.stopPropagation();
                              clearExtraOptions();
                            },
                            children: /* @__PURE__ */ jsx(Icon, { name: "cross-small", size: 16 })
                          }
                        )
                      ]
                    }
                  )
                ] }),
                /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between", children: [
                  /* @__PURE__ */ jsx(
                    "button",
                    {
                      onClick: (event) => {
                        event.stopPropagation();
                        handleClear();
                      },
                      children: /* @__PURE__ */ jsx(XIcon, { className: "mx-2 h-4 cursor-pointer text-foreground" })
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    Separator,
                    {
                      orientation: "vertical",
                      className: "flex h-full min-h-6"
                    }
                  ),
                  /* @__PURE__ */ jsx(ChevronDown, { className: "mx-2 h-4 cursor-pointer text-foreground" })
                ] })
              ] }) : /* @__PURE__ */ jsxs("div", { className: "mx-auto flex w-full items-center justify-between", children: [
                /* @__PURE__ */ jsx("span", { className: "mx-3 text-sm text-muted", children: tidPlaceholder ? t(tidPlaceholder) : placeholder }),
                /* @__PURE__ */ jsx(ChevronDown, { className: "mx-2 h-4 cursor-pointer text-foreground" })
              ] })
            }
          ) }),
          /* @__PURE__ */ jsx(
            PopoverContent,
            {
              className: "w-auto p-0",
              align: "start",
              onEscapeKeyDown: () => setIsPopoverOpen(false),
              style: matchTriggerWidth ? popoverStyle : void 0,
              children: /* @__PURE__ */ jsxs(Command, { children: [
                !disableSearch && /* @__PURE__ */ jsx(
                  CommandInput,
                  {
                    placeholder: tidSearch ? t(tidSearch) : "Search...",
                    onKeyDown: handleInputKeyDown
                  }
                ),
                /* @__PURE__ */ jsxs(CommandList, { children: [
                  /* @__PURE__ */ jsx(CommandEmpty, { children: "No results found." }),
                  /* @__PURE__ */ jsxs(CommandGroup, { children: [
                    !disableSelectAll && /* @__PURE__ */ jsxs(
                      CommandItem,
                      {
                        onSelect: toggleAll,
                        className: "cursor-pointer",
                        children: [
                          /* @__PURE__ */ jsx(
                            "div",
                            {
                              className: cn(
                                "mr-2 flex h-4 w-4 items-center justify-center rounded-sm border border-primary",
                                selectedValues.length === options.length ? "bg-primary text-primary-foreground" : "opacity-50 [&_svg]:invisible"
                              ),
                              children: /* @__PURE__ */ jsx(CheckIcon, { color: "white", className: "size-4" })
                            }
                          ),
                          /* @__PURE__ */ jsxs("span", { children: [
                            "(",
                            tidSelectAll ? t(tidSelectAll) : "Select All",
                            ")"
                          ] })
                        ]
                      },
                      "all"
                    ),
                    options.map((option) => {
                      const isSelected = selectedValues.includes(option.value);
                      return /* @__PURE__ */ jsxs(
                        CommandItem,
                        {
                          onSelect: () => toggleOption(option.value),
                          className: "cursor-pointer",
                          children: [
                            /* @__PURE__ */ jsx(
                              "div",
                              {
                                className: cn(
                                  "mr-2 flex h-4 w-4 items-center justify-center rounded-sm border border-primary",
                                  isSelected ? "bg-primary text-primary-foreground" : "opacity-50 [&_svg]:invisible"
                                ),
                                children: /* @__PURE__ */ jsx(CheckIcon, { color: "white", className: "size-4" })
                              }
                            ),
                            /* @__PURE__ */ jsx("span", { children: option.label })
                          ]
                        },
                        option.value.toString()
                      );
                    })
                  ] }),
                  /* @__PURE__ */ jsx(CommandSeparator, {}),
                  /* @__PURE__ */ jsx(CommandGroup, { children: /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between", children: [
                    selectedValues.length > 0 && /* @__PURE__ */ jsxs(Fragment$1, { children: [
                      /* @__PURE__ */ jsx(
                        CommandItem,
                        {
                          onSelect: handleClear,
                          className: "flex-1 cursor-pointer justify-center",
                          children: tidClear ? t(tidClear) : "Clear"
                        }
                      ),
                      /* @__PURE__ */ jsx(
                        Separator,
                        {
                          orientation: "vertical",
                          className: "flex h-full min-h-6"
                        }
                      )
                    ] }),
                    /* @__PURE__ */ jsx(
                      CommandItem,
                      {
                        onSelect: () => setIsPopoverOpen(false),
                        className: "max-w-full flex-1 cursor-pointer justify-center",
                        children: tidClose ? t(tidClose) : "Close"
                      }
                    )
                  ] }) })
                ] })
              ] })
            }
          )
        ]
      }
    );
  }
);
MultiSelect.displayName = "MultiSelect";
const DropdownMenu = DropdownMenuPrimitive.Root;
const DropdownMenuTrigger = DropdownMenuPrimitive.Trigger;
const DropdownMenuGroup = DropdownMenuPrimitive.Group;
const DropdownMenuPortal = DropdownMenuPrimitive.Portal;
const DropdownMenuSub = DropdownMenuPrimitive.Sub;
const DropdownMenuRadioGroup = DropdownMenuPrimitive.RadioGroup;
const DropdownMenuArrow = DropdownMenuPrimitive.Arrow;
const DropdownMenuSubTrigger = React.forwardRef(
  ({
    className,
    inset,
    tid,
    values,
    showIconOnHover = false,
    children,
    ...props
  }, ref) => {
    const { t } = useTranslation();
    return /* @__PURE__ */ jsxs(
      DropdownMenuPrimitive.SubTrigger,
      {
        ref,
        className: cn(
          "flex cursor-pointer select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent data-[state=open]:bg-accent",
          inset && "pl-8",
          showIconOnHover && "group",
          className
        ),
        ...props,
        children: [
          tid ? t(tid, values) : children,
          showIconOnHover ? /* @__PURE__ */ jsx("div", { className: "ml-auto w-0 overflow-hidden transition-all duration-200 ease-in-out group-hover:w-4", children: /* @__PURE__ */ jsx(ChevronRightIcon, { className: "size-4 text-foreground" }) }) : /* @__PURE__ */ jsx(ChevronRightIcon, { className: "ml-auto size-4" })
        ]
      }
    );
  }
);
DropdownMenuSubTrigger.displayName = DropdownMenuPrimitive.SubTrigger.displayName;
const DropdownMenuSubContent = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  DropdownMenuPrimitive.SubContent,
  {
    ref,
    className: cn(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      className
    ),
    ...props
  }
));
DropdownMenuSubContent.displayName = DropdownMenuPrimitive.SubContent.displayName;
const DropdownMenuContent = React.forwardRef(({ className, sideOffset = 4, ...props }, ref) => /* @__PURE__ */ jsx(DropdownMenuPrimitive.Portal, { children: /* @__PURE__ */ jsx(
  DropdownMenuPrimitive.Content,
  {
    ref,
    sideOffset,
    className: cn(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      className
    ),
    ...props
  }
) }));
DropdownMenuContent.displayName = DropdownMenuPrimitive.Content.displayName;
const DropdownMenuItem = React.forwardRef(({ className, inset, tid, values, children, ...props }, ref) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsx(
    DropdownMenuPrimitive.Item,
    {
      ref,
      className: cn(
        "relative flex cursor-pointer select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 data-[highlighted]:bg-neutral-gray-alpha-2 ",
        inset && "pl-8",
        className
      ),
      ...props,
      children: tid ? t(tid, values) : children
    }
  );
});
DropdownMenuItem.displayName = DropdownMenuPrimitive.Item.displayName;
const DropdownMenuCheckboxItem = React.forwardRef(({ className, children, checked, ...props }, ref) => /* @__PURE__ */ jsxs(
  DropdownMenuPrimitive.CheckboxItem,
  {
    ref,
    className: cn(
      "relative flex cursor-pointer select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      className
    ),
    checked,
    ...props,
    children: [
      /* @__PURE__ */ jsx("span", { className: "absolute left-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ jsx(DropdownMenuPrimitive.ItemIndicator, { children: /* @__PURE__ */ jsx(CheckIcon$1, { className: "size-4" }) }) }),
      children
    ]
  }
));
DropdownMenuCheckboxItem.displayName = DropdownMenuPrimitive.CheckboxItem.displayName;
const DropdownMenuRadioItem = React.forwardRef(({ className, children, ...props }, ref) => /* @__PURE__ */ jsxs(
  DropdownMenuPrimitive.RadioItem,
  {
    ref,
    className: cn(
      "relative flex cursor-pointer select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      className
    ),
    ...props,
    children: [
      /* @__PURE__ */ jsx("span", { className: "absolute left-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ jsx(DropdownMenuPrimitive.ItemIndicator, { children: /* @__PURE__ */ jsx(DotFilledIcon, { className: "size-4 fill-current" }) }) }),
      children
    ]
  }
));
DropdownMenuRadioItem.displayName = DropdownMenuPrimitive.RadioItem.displayName;
const DropdownMenuLabel = React.forwardRef(({ className, inset, ...props }, ref) => /* @__PURE__ */ jsx(
  DropdownMenuPrimitive.Label,
  {
    ref,
    className: cn(
      "px-2 py-1.5 text-sm font-semibold",
      inset && "pl-8",
      className
    ),
    ...props
  }
));
DropdownMenuLabel.displayName = DropdownMenuPrimitive.Label.displayName;
const DropdownMenuSeparator = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  DropdownMenuPrimitive.Separator,
  {
    ref,
    className: cn("-mx-1 my-1 h-px bg-neutral-gray-5", className),
    ...props
  }
));
DropdownMenuSeparator.displayName = DropdownMenuPrimitive.Separator.displayName;
const DropdownMenuShortcut = ({
  className,
  ...props
}) => {
  return /* @__PURE__ */ jsx(
    "span",
    {
      className: cn("ml-auto text-xs tracking-widest opacity-60", className),
      ...props
    }
  );
};
DropdownMenuShortcut.displayName = "DropdownMenuShortcut";
const Tooltip = TooltipPrimitive.Root;
const TooltipProvider = TooltipPrimitive.Provider;
const TooltipTrigger = TooltipPrimitive.Trigger;
const TooltipArrow = TooltipPrimitive.Arrow;
const TooltipContent = React.forwardRef(({ className, sideOffset = 4, ...props }, ref) => /* @__PURE__ */ jsx(TooltipPrimitive.Portal, { children: /* @__PURE__ */ jsx(
  TooltipPrimitive.Content,
  {
    ref,
    sideOffset,
    className: cn(
      "rounded-sm max-w-48 max-h-24 px-2 overflow-y-auto bg-neutral-gray-alpha-12",
      "data-[state=delayed-open]:animate-in data-[state=closed]:animate-out",
      "data-[state=delayed-open]:fade-in data-[state=closed]:fade-out",
      "transition-opacity duration-200 text-base-white",
      className
    ),
    ...props
  }
) }));
TooltipContent.displayName = TooltipPrimitive.Content.displayName;
const DropdownSearchContent = ({
  className,
  options,
  onOptionSelect,
  onValueChange,
  placeholder = "Search...",
  tidPlaceholder,
  tidNoOptionsFound
}) => {
  const { t } = useDefaultTranslation();
  const inputRef = useRef(null);
  const listRef = useRef(null);
  const [inputValue, setInputValue] = useState("");
  const [focusedIndex, setFocusedIndex] = useState(-1);
  const [isListFocused, setIsListFocused] = useState(false);
  const filteredOptions = useMemo(() => {
    if (!inputValue.trim()) return options;
    const searchLower = inputValue.toLowerCase();
    return options.filter((option) => {
      if (option.searchValue) {
        return option.searchValue.toLowerCase().includes(searchLower);
      }
      if (option.value.toLowerCase().includes(searchLower)) {
        return true;
      }
      if (typeof option.label === "string") {
        return option.label.toLowerCase().includes(searchLower);
      }
      return false;
    });
  }, [options, inputValue]);
  useEffect(() => {
    setTimeout(() => {
      var _a;
      return (_a = inputRef.current) == null ? void 0 : _a.focus();
    }, 0);
    setFocusedIndex(-1);
    setIsListFocused(false);
  }, []);
  useEffect(() => {
    if (focusedIndex >= 0 && listRef.current) {
      const listItems = listRef.current.querySelectorAll('[role="option"]');
      if (listItems[focusedIndex]) {
        listItems[focusedIndex].scrollIntoView({ block: "nearest" });
      }
    }
  }, [focusedIndex]);
  useEffect(() => {
    var _a;
    if (isListFocused) {
      (_a = listRef.current) == null ? void 0 : _a.focus();
    }
  }, [isListFocused]);
  const handleChange = useCallback(
    (e) => {
      const value = e.target.value;
      setInputValue(value);
      onValueChange == null ? void 0 : onValueChange(value);
      setFocusedIndex(-1);
    },
    [onValueChange]
  );
  const handleOptionSelect = useCallback(
    (option) => {
      var _a;
      onOptionSelect(option);
      setInputValue("");
      setFocusedIndex(-1);
      setIsListFocused(false);
      (_a = inputRef.current) == null ? void 0 : _a.focus();
    },
    [onOptionSelect]
  );
  const handleInputKeyDown = useCallback(
    (e) => {
      if (filteredOptions.length === 0) return;
      if (e.key === "Tab" && !e.shiftKey || e.key === "ArrowDown") {
        e.preventDefault();
        setIsListFocused(true);
        setFocusedIndex(0);
      }
    },
    [filteredOptions.length]
  );
  const handleListKeyDown = useCallback(
    (e) => {
      var _a, _b;
      switch (e.key) {
        case "ArrowDown":
          e.preventDefault();
          setFocusedIndex(
            (prev) => Math.min(prev + 1, filteredOptions.length - 1)
          );
          break;
        case "ArrowUp":
          e.preventDefault();
          setFocusedIndex((prev) => {
            var _a2;
            if (prev <= 0) {
              setIsListFocused(false);
              (_a2 = inputRef.current) == null ? void 0 : _a2.focus();
              return -1;
            }
            return prev - 1;
          });
          break;
        case "Enter":
          e.preventDefault();
          if (focusedIndex >= 0 && focusedIndex < filteredOptions.length) {
            handleOptionSelect(filteredOptions[focusedIndex]);
          }
          break;
        case "Escape":
          e.preventDefault();
          setIsListFocused(false);
          setFocusedIndex(-1);
          (_a = inputRef.current) == null ? void 0 : _a.focus();
          break;
        case "Tab":
          if (e.shiftKey) {
            e.preventDefault();
            setIsListFocused(false);
            setFocusedIndex(-1);
            (_b = inputRef.current) == null ? void 0 : _b.focus();
          }
          break;
      }
    },
    [focusedIndex, filteredOptions, handleOptionSelect]
  );
  const handleClearInput = useCallback(
    (e) => {
      var _a;
      e.stopPropagation();
      setInputValue("");
      onValueChange == null ? void 0 : onValueChange("");
      setFocusedIndex(-1);
      (_a = inputRef.current) == null ? void 0 : _a.focus();
    },
    [onValueChange]
  );
  const handleListBlur = useCallback((e) => {
    if (!e.currentTarget.contains(e.relatedTarget)) {
      setIsListFocused(false);
      setFocusedIndex(-1);
    }
  }, []);
  return /* @__PURE__ */ jsxs("div", { className: cn("w-full", className), children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-center border-b", children: [
      /* @__PURE__ */ jsx(
        "input",
        {
          ref: inputRef,
          className: "grow bg-transparent pl-2 text-[13px] leading-9 outline-none",
          type: "text",
          placeholder: t(tidPlaceholder, placeholder),
          onChange: handleChange,
          onKeyDown: handleInputKeyDown,
          value: inputValue
        }
      ),
      /* @__PURE__ */ jsx(
        "button",
        {
          className: "h-full border-0 bg-transparent px-2 text-muted-80 hover:text-foreground",
          onClick: handleClearInput,
          type: "button",
          children: /* @__PURE__ */ jsx(Icon, { name: "cross-small" })
        }
      )
    ] }),
    /* @__PURE__ */ jsx(
      "div",
      {
        ref: listRef,
        className: "max-h-60 overflow-auto py-1 outline-none",
        role: "listbox",
        tabIndex: 0,
        onKeyDown: handleListKeyDown,
        onBlur: handleListBlur,
        children: filteredOptions.length > 0 ? filteredOptions.map(
          (option, index) => /* @__PURE__ */ jsx(
            OptionWithTooltip,
            {
              option,
              index,
              focusedIndex,
              handleOptionSelect
            },
            option.key
          )
        ) : /* @__PURE__ */ jsx("div", { className: "p-2 text-center text-sm text-muted-foreground", children: /* @__PURE__ */ jsx(Text$1, { tid: tidNoOptionsFound, children: "No options found" }) })
      }
    )
  ] });
};
const OptionWithTooltip = ({
  option,
  index,
  focusedIndex,
  handleOptionSelect
}) => {
  var _a, _b;
  const ref = useRef(null);
  const tooltipContent = option.disabled ? (_a = option.tooltip) == null ? void 0 : _a.disabled : (_b = option.tooltip) == null ? void 0 : _b.active;
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!option.disabled) {
      handleOptionSelect(option);
    }
  };
  return /* @__PURE__ */ jsxs(Tooltip, { children: [
    /* @__PURE__ */ jsx(TooltipTrigger, { asChild: true, children: /* @__PURE__ */ jsx(
      "div",
      {
        ref,
        role: "option",
        "aria-selected": focusedIndex === index,
        "aria-disabled": option.disabled,
        className: cn(
          "flex items-center gap-2 px-2 py-1.5 text-sm outline-none",
          !option.disabled && "cursor-pointer hover:bg-neutral-gray-alpha-2",
          option.disabled && "text-muted-foreground",
          focusedIndex === index && "bg-neutral-gray-alpha-2"
        ),
        onClick: (e) => handleClick(e),
        children: option.label
      },
      option.key
    ) }),
    tooltipContent && /* @__PURE__ */ jsx(TooltipContent, { side: "right", children: /* @__PURE__ */ jsx(Text$1, { color: "base-white", children: tooltipContent }) })
  ] });
};
const DropdownSubmenuContent = ({
  submenu,
  onOptionSelect,
  tidNoOptionsFound
}) => {
  var _a, _b;
  if (submenu.type === "search") {
    return /* @__PURE__ */ jsx(
      DropdownSearchContent,
      {
        options: submenu.options,
        onOptionSelect,
        tidNoOptionsFound,
        placeholder: (_a = submenu.searchProps) == null ? void 0 : _a.placeholder,
        tidPlaceholder: (_b = submenu.searchProps) == null ? void 0 : _b.tidPlaceholder
      }
    );
  }
  return /* @__PURE__ */ jsx(
    DropdownListContent,
    {
      options: submenu.options,
      onOptionSelect,
      tidNoOptionsFound,
      isOpen: true
    }
  );
};
const DropdownListContent = ({
  className,
  options,
  onOptionSelect,
  tidNoOptionsFound
}) => {
  const handleOptionSelect = useCallback(
    (option) => {
      onOptionSelect(option);
    },
    [onOptionSelect]
  );
  const renderOption = (option) => {
    if (option.submenu) {
      return /* @__PURE__ */ jsxs(DropdownMenuSub, { children: [
        /* @__PURE__ */ jsx(
          DropdownMenuSubTrigger,
          {
            className: "flex items-center gap-2 px-2 py-1.5 text-sm",
            children: option.label
          }
        ),
        /* @__PURE__ */ jsx(DropdownMenuPortal, { children: /* @__PURE__ */ jsx(DropdownMenuSubContent, { className: "min-w-[200px]", children: /* @__PURE__ */ jsx(
          DropdownSubmenuContent,
          {
            submenu: option.submenu,
            onOptionSelect: handleOptionSelect,
            tidNoOptionsFound
          }
        ) }) })
      ] }, option.key);
    }
    return /* @__PURE__ */ jsxs(
      DropdownMenuItem,
      {
        className: "flex items-center justify-between gap-2 px-2 py-1.5",
        onSelect: () => handleOptionSelect(option),
        children: [
          option.label,
          option.icon && /* @__PURE__ */ jsx(Icon, { size: 12, color: "muted-foreground", name: option.icon })
        ]
      },
      option.key
    );
  };
  return /* @__PURE__ */ jsx("div", { className: cn("w-full", className), tabIndex: 0, children: /* @__PURE__ */ jsx("div", { className: "max-h-60 overflow-auto py-1", children: options.length > 0 ? options.map((option) => renderOption(option)) : /* @__PURE__ */ jsx("div", { className: "p-2 text-center text-muted-foreground", children: /* @__PURE__ */ jsx(Text$1, { tid: tidNoOptionsFound, children: "No options found" }) }) }) });
};
const Checkbox = React.forwardRef(({ className, checked, ...props }, ref) => {
  return /* @__PURE__ */ jsx(
    CheckboxPrimitive.Root,
    {
      ref,
      className: cn(
        "peer h-4 w-4 shrink-0 rounded-sm border border-muted-80 shadow focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-5 data-[state=checked]:bg-foreground-100 data-[state=checked]:text-gray-1 self-start",
        className
      ),
      checked,
      ...props,
      children: /* @__PURE__ */ jsxs(
        CheckboxPrimitive.Indicator,
        {
          className: cn("flex items-center justify-center"),
          children: [
            checked === "indeterminate" && /* @__PURE__ */ jsx(DividerHorizontalIcon, {}),
            checked === true && /* @__PURE__ */ jsx(CheckIcon$1, { className: "translate-y-[-0.5px]" })
          ]
        }
      )
    }
  );
});
Checkbox.displayName = CheckboxPrimitive.Root.displayName;
const FilterByValueItem = forwardRef(
  ({
    activeIndex,
    index,
    onOptionChange,
    onOptionHover,
    option,
    selectedOptions,
    offsetIndex = 0,
    single = false,
    disabled = false
  }, ref) => {
    const onCheckedChange = useCallback(
      (checked) => onOptionChange(option, checked),
      [onOptionChange, option.key]
    );
    const onMouseEnter = useCallback(() => {
      onOptionHover(index + offsetIndex);
    }, [onOptionHover, index, offsetIndex]);
    const isChecked = !!selectedOptions.find(
      (selectedOption) => selectedOption.key === option.key
    );
    const onClick = useCallback(() => {
      if (single && !disabled) {
        onOptionChange(option, !isChecked);
      }
    }, [onOptionChange, option, isChecked, single, disabled]);
    return /* @__PURE__ */ jsxs(
      Text$1,
      {
        ref,
        as: "label",
        className: cn("flex items-center gap-2 p-2 text-base rounded-sm", {
          "bg-accent": activeIndex === index + offsetIndex,
          "text-muted cursor-not-allowed": disabled
        }),
        onClick,
        onMouseEnter,
        children: [
          single ? /* @__PURE__ */ jsx(Fragment$1, { children: isChecked && /* @__PURE__ */ jsx(Icon, { name: "checkmark-2" }) }) : /* @__PURE__ */ jsx(
            Checkbox,
            {
              checked: isChecked,
              value: option.key,
              onCheckedChange
            }
          ),
          option.label
        ]
      },
      option.key
    );
  }
);
FilterByValueItem.displayName = "FilterByValueItem";
const OPTION_PADDING = 4;
const useKeepOptionsInView = (optionsRef, activeIndex, offsetIndex = 0) => {
  useEffect(() => {
    var _a;
    if (optionsRef.current) {
      const initialScrollTop = optionsRef.current.scrollTop;
      (_a = optionsRef.current.children.item(activeIndex - offsetIndex)) == null ? void 0 : _a.scrollIntoView({
        behavior: "instant",
        block: "nearest",
        inline: "nearest"
      });
      if (initialScrollTop < optionsRef.current.scrollTop) {
        optionsRef.current.scrollBy(0, OPTION_PADDING);
      } else if (initialScrollTop > optionsRef.current.scrollTop) {
        optionsRef.current.scrollBy(0, -OPTION_PADDING);
      }
    }
  }, [activeIndex, offsetIndex]);
};
const FilterByValue = forwardRef(
  ({
    autoFocus,
    className,
    fetchingOptions,
    disabledOptions = [],
    onOpen,
    onClose,
    onOptionSelect,
    onValueChange,
    onAddOptionSelect,
    openOnFocus,
    options,
    selectedOptions,
    value = "",
    single = false,
    addOptions = false,
    tidPlaceholder,
    tidNoValuesFound,
    tidValues,
    tidValuesCount,
    tidFirstFifty,
    tidSelectedValues
  }, parentRef) => {
    const { t } = useDefaultTranslation();
    const rootRef = useRef(null);
    const firstOptionRef = useRef(null);
    const [optionContainerMaxHeight, setOptionContainerMaxHeight] = useState(0);
    const [activeIndex, setActiveIndex] = useState(-1);
    const selectedOptionsRef = useRef(null);
    const unselectedOptionsRef = useRef(null);
    const onChange = useCallback(
      (event) => onValueChange(event.target.value),
      [onValueChange]
    );
    const [optionsOpen, setOptionsOpen] = useState(!openOnFocus);
    const onInputFocus = useCallback(() => {
      if (openOnFocus) {
        setOptionsOpen(true);
        onOpen == null ? void 0 : onOpen(selectedOptions);
        setActiveIndex(-1);
      }
    }, [openOnFocus, onOpen, options]);
    const onOptionHover = useCallback(
      (index) => setActiveIndex(index),
      []
    );
    const autoFocusRef = useCallback(
      (input) => {
        if (autoFocus && input) {
          input.focus();
          onInputFocus();
        }
      },
      [autoFocus, onInputFocus]
    );
    const ref = mergeRefs(parentRef, autoFocusRef);
    const onClearInputClick = useCallback(
      () => onValueChange(""),
      [onValueChange]
    );
    const unselectedOptions = useMemo(
      () => options.filter(
        (option) => !selectedOptions.find(
          (selectedOption) => selectedOption.key === option.key
        )
      ),
      [options, selectedOptions]
    );
    const onKeyDown = useCallback(
      (event) => {
        if (event.key === "ArrowDown") {
          setActiveIndex(
            (prev) => Math.min(
              prev + 1,
              selectedOptions.length + unselectedOptions.length - 1
            )
          );
          event.preventDefault();
        }
        if (event.key === "ArrowUp") {
          setActiveIndex((prev) => Math.max(prev - 1, -1));
          event.preventDefault();
        }
        if ((event.code === "Space" || event.key === "Enter") && activeIndex >= 0) {
          if (activeIndex < selectedOptions.length) {
            onOptionSelect(
              selectedOptions[activeIndex],
              !selectedOptions.find(
                (option) => option.key === selectedOptions[activeIndex].key
              )
            );
          } else {
            onOptionSelect(
              unselectedOptions[activeIndex - selectedOptions.length],
              !selectedOptions.find(
                (option) => option.key === unselectedOptions[activeIndex - selectedOptions.length].key
              )
            );
          }
          if (event.key === "Enter") {
            onClose == null ? void 0 : onClose(selectedOptions);
          }
          event.preventDefault();
        }
      },
      [
        activeIndex,
        unselectedOptions,
        selectedOptions,
        onOptionSelect,
        setActiveIndex
      ]
    );
    useKeepOptionsInView(selectedOptionsRef, activeIndex);
    useKeepOptionsInView(
      unselectedOptionsRef,
      activeIndex,
      selectedOptions.length
    );
    const onClickOutside = useCallback(
      (event) => {
        if (rootRef.current && event.target.isConnected && !rootRef.current.contains(event.target)) {
          setOptionsOpen(false);
          onClose == null ? void 0 : onClose(selectedOptions);
        }
      },
      [onClose, selectedOptions]
    );
    useEffect(() => {
      document.addEventListener("click", onClickOutside);
      return () => document.removeEventListener("click", onClickOutside);
    }, [onClickOutside]);
    useEffect(() => {
      if (firstOptionRef.current) {
        const { height } = firstOptionRef.current.getBoundingClientRect();
        if (height) {
          setOptionContainerMaxHeight(height * 6.5 + OPTION_PADDING);
        }
      }
    }, [optionsOpen]);
    const valuesByline = useMemo(() => {
      if (fetchingOptions) {
        return /* @__PURE__ */ jsx(Spinner, { size: 16 });
      }
      if (options.length >= 50) {
        return /* @__PURE__ */ jsx(Text$1, { className: "text-muted", tid: tidFirstFifty, children: "Showing first 50 options" });
      }
      if (unselectedOptions.length === 0) {
        return /* @__PURE__ */ jsx(Text$1, { className: "text-muted-80", tid: tidNoValuesFound, children: "No values found" });
      }
      return /* @__PURE__ */ jsxs(
        Text$1,
        {
          className: "text-muted-80",
          values: { count: unselectedOptions.length },
          tid: tidValuesCount,
          children: [
            "Showing ",
            unselectedOptions.length,
            " option",
            unselectedOptions.length === 1 ? "" : "s"
          ]
        }
      );
    }, [options, value, fetchingOptions, unselectedOptions]);
    return /* @__PURE__ */ jsxs("div", { className: cn("flex flex-col", className), ref: rootRef, children: [
      /* @__PURE__ */ jsxs("div", { className: "flex h-9 items-center px-1", children: [
        /* @__PURE__ */ jsx(
          "input",
          {
            ref,
            className: "grow bg-transparent pl-2 text-[13px] leading-9 outline-none",
            type: "text",
            placeholder: t(tidPlaceholder, "Search…"),
            onChange,
            onKeyDown,
            value,
            onFocus: onInputFocus
          }
        ),
        /* @__PURE__ */ jsx(
          "button",
          {
            className: "h-full border-0 bg-transparent px-2 text-muted-80 hover:text-foreground",
            onClick: onClearInputClick,
            children: /* @__PURE__ */ jsx(Icon, { name: "cross-small" })
          }
        )
      ] }),
      /* @__PURE__ */ jsxs("div", { className: cn("border-t", { hidden: !optionsOpen }), children: [
        selectedOptions.length > 0 && !value && /* @__PURE__ */ jsxs(Fragment$1, { children: [
          tidSelectedValues && /* @__PURE__ */ jsx("div", { className: "flex h-7 items-center justify-between px-3 text-xs text-muted", children: /* @__PURE__ */ jsx(Text$1, { tid: tidSelectedValues, children: "Selected values" }) }),
          /* @__PURE__ */ jsx(
            "div",
            {
              ref: selectedOptionsRef,
              className: "flex flex-col overflow-y-auto p-1",
              style: { maxHeight: optionContainerMaxHeight },
              children: selectedOptions.map((option, index) => /* @__PURE__ */ jsx(
                FilterByValueItem,
                {
                  option,
                  activeIndex,
                  onOptionHover,
                  selectedOptions,
                  onOptionChange: onOptionSelect,
                  index,
                  single
                },
                option.key
              ))
            }
          )
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "flex h-7 items-center justify-between px-3 text-xs text-muted", children: [
          /* @__PURE__ */ jsx(Text$1, { tid: tidValues, children: "Values" }),
          valuesByline
        ] }),
        unselectedOptions.length > 0 && /* @__PURE__ */ jsx(
          "div",
          {
            ref: unselectedOptionsRef,
            className: "flex flex-col overflow-y-auto p-1",
            style: { maxHeight: optionContainerMaxHeight },
            children: unselectedOptions.map((option, index) => /* @__PURE__ */ jsx(
              FilterByValueItem,
              {
                ref: index === 0 ? firstOptionRef : null,
                option,
                activeIndex,
                onOptionHover,
                selectedOptions,
                onOptionChange: onOptionSelect,
                index,
                offsetIndex: selectedOptions.length,
                single,
                disabled: disabledOptions.includes(option.value)
              },
              option.key
            ))
          }
        ),
        addOptions && value && options.length === 0 && onAddOptionSelect && /* @__PURE__ */ jsx("div", { className: "flex flex-col overflow-y-auto p-1", children: /* @__PURE__ */ jsx(
          FilterByValueItem,
          {
            option: {
              key: value,
              value,
              label: `Add New Field: ${value}`
            },
            activeIndex: 0,
            onOptionHover,
            selectedOptions,
            onOptionChange: onAddOptionSelect,
            index: 0,
            offsetIndex: 0,
            single
          },
          "add-option"
        ) })
      ] })
    ] });
  }
);
FilterByValue.displayName = "FilterByValue";
const noop = () => {
};
const initialContext = {
  getTransformedValue: () => "",
  insertFragment: noop,
  setValue: noop,
  activeSearch: "",
  inputElement: null,
  setInputElement: noop,
  selectItem: noop,
  executeActionCallback: noop,
  setActiveItemIndex: noop,
  opened: null,
  index: 0,
  loading: false,
  results: [],
  closeAutocomplete: noop,
  openAutocomplete: noop,
  onBeforeChanges: noop,
  onKeyDown: noop,
  onChanges: noop,
  fixed: true,
  setPositionFixed: noop,
  configs: []
};
const RichMentionsContext = createContext(initialContext);
const extractMentionsFromDefaultValue = (htmlString) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");
  const mentionElements = doc.querySelectorAll("[data-rich-mentions]");
  const mentions = Array.from(mentionElements).map(
    (el) => el.getAttribute("data-rich-mentions") || ""
  );
  return mentions.filter((mention) => mention);
};
function RichMentionsInput({
  defaultValue,
  autoFocus,
  onMentionChange,
  placeholder,
  ...divAttributes
}) {
  const ref = useRef(null);
  const {
    inputElement,
    setInputElement,
    onBeforeChanges,
    onKeyDown,
    onChanges,
    getInitialHTML
  } = useContext(RichMentionsContext);
  const [mentions, setMentions] = useState(() => {
    if (defaultValue && getInitialHTML) {
      const html = getInitialHTML(defaultValue);
      return extractMentionsFromDefaultValue(html);
    }
    return [];
  });
  if (ref.current === null && defaultValue && getInitialHTML) {
    const html = getInitialHTML(defaultValue);
    ref.current = html;
  }
  const mergeOnKeyDown = (event) => {
    onKeyDown(event);
    if (divAttributes.onKeyDown) {
      divAttributes.onKeyDown(event);
    }
  };
  const onInput = (event) => {
    if (divAttributes.onInput) {
      divAttributes.onInput(event);
    }
    onChanges(event);
  };
  const onBeforeInput = (event) => {
    onBeforeChanges(event);
    if (divAttributes.onBeforeInput) {
      divAttributes.onBeforeInput(event);
    }
  };
  React__default.useEffect(() => {
    if (inputElement && autoFocus) {
      const range2 = document.createRange();
      range2.selectNodeContents(inputElement);
      range2.collapse(false);
      const selection = window.getSelection();
      if (selection) {
        selection.removeAllRanges();
        selection.addRange(range2);
      }
      inputElement.focus();
    }
  }, [inputElement, autoFocus]);
  React__default.useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          var _a, _b, _c, _d;
          if ((_b = (_a = node == null ? void 0 : node.parentNode) == null ? void 0 : _a.dataset) == null ? void 0 : _b.richMentions) {
            const ref2 = (_d = (_c = node == null ? void 0 : node.parentNode) == null ? void 0 : _c.dataset) == null ? void 0 : _d.richMentions;
            if (ref2) {
              setMentions((prevMentions) => [...prevMentions, ref2]);
            }
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            if (node == null ? void 0 : node.hasAttribute("data-rich-mentions")) {
              const ref2 = node == null ? void 0 : node.getAttribute("data-rich-mentions");
              if (ref2) {
                setMentions((prevMentions) => [...prevMentions, ref2]);
              }
            }
          }
        });
        mutation.removedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const element = node;
            if (element.hasAttribute("data-rich-mentions")) {
              const ref2 = element.getAttribute("data-rich-mentions");
              if (ref2) {
                setMentions(
                  (prevMentions) => prevMentions.filter((mention) => mention !== ref2)
                );
              }
            }
          }
        });
      });
    });
    const config = { childList: true, subtree: true };
    if (inputElement) {
      observer.observe(inputElement, config);
    }
    return () => observer.disconnect();
  }, [inputElement]);
  React__default.useEffect(() => {
    if (onMentionChange) {
      onMentionChange(mentions);
    }
  }, [mentions, onMentionChange]);
  return /* @__PURE__ */ jsx(
    "div",
    {
      ref: setInputElement,
      ...divAttributes,
      "data-testid": "input",
      contentEditable: true,
      onBeforeInput,
      onKeyDown: mergeOnKeyDown,
      onInput,
      dangerouslySetInnerHTML: { __html: ref.current || "" },
      placeholder
    }
  );
}
function setCursorPosition(element, position) {
  const selection = document.getSelection();
  const range2 = document.createRange();
  range2.setStart(element, position);
  range2.collapse(true);
  if (selection) {
    selection.removeAllRanges();
    selection.addRange(range2);
  }
}
function deleteSelection(selection, event) {
  let deleted = false;
  let lastDeletedRange = null;
  for (let i = 0; i < selection.rangeCount; ++i) {
    const range2 = selection.getRangeAt(i);
    if (range2.startContainer !== range2.endContainer || range2.startOffset !== range2.endOffset) {
      deleted = true;
      lastDeletedRange = range2;
      range2.deleteContents();
    }
  }
  if ((event == null ? void 0 : event.data) && lastDeletedRange) {
    const textNode = document.createTextNode(event.data);
    lastDeletedRange.insertNode(textNode);
    setCursorPosition(textNode, 1);
    event.preventDefault();
  }
  return deleted;
}
function nodeToHtmlElement(node) {
  return node.nodeType === Node.TEXT_NODE ? node.parentElement : node;
}
function escapeFragmentWithValue(element, text, position = "after") {
  const textNode = document.createTextNode(text.replace(/\s/g, " "));
  const parent = element.parentElement;
  if (parent) {
    if (position === "after") {
      parent.insertBefore(textNode, element.nextSibling);
    } else {
      parent.insertBefore(textNode, element);
    }
    setCursorPosition(textNode, text.length);
  }
}
function fixCursorInsertion(event, selection) {
  if (event.defaultPrevented) {
    return;
  }
  const insertion = event.data;
  const container = event.currentTarget;
  for (let i = 0; i < selection.rangeCount; i++) {
    const range2 = selection.getRangeAt(i);
    if (range2.startContainer === range2.endContainer) {
      const element = nodeToHtmlElement(range2.startContainer);
      if (!container.contains(element)) {
        continue;
      }
      if (range2.startContainer instanceof Text && range2.startOffset === 0) {
        const previousChild = range2.startContainer.previousSibling;
        const previousElement = range2.startContainer.previousElementSibling;
        if (previousChild && previousElement && previousChild === previousElement && previousElement.hasAttribute("data-rich-mentions") && !previousElement.hasAttribute("data-integrity")) {
          previousElement.appendChild(document.createTextNode(insertion));
          event.preventDefault();
          continue;
        }
      }
      if (!element || container === element || !element.hasAttribute("data-rich-mentions")) {
        continue;
      }
      if (range2.endOffset === 0) {
        escapeFragmentWithValue(element, insertion, "before");
        event.preventDefault();
        continue;
      }
      const isFinal = element.hasAttribute("data-integrity");
      const text = element.textContent || "";
      if (isFinal && range2.startOffset === text.length) {
        escapeFragmentWithValue(element, insertion, "after");
        event.preventDefault();
        continue;
      }
    }
  }
}
function transformFinalFragment(span, ref, config, item) {
  const displayContent = (item == null ? void 0 : item.displayText) || ref.replace(config.match, config.matchDisplay).replace(/\s/g, " ");
  span.textContent = displayContent;
  span.setAttribute("data-rich-mentions", ref);
  span.setAttribute("spellcheck", "false");
  if (item == null ? void 0 : item.type) {
    span.setAttribute("data-type", item.type);
  }
  if (item == null ? void 0 : item.groupName) {
    span.setAttribute("data-group-name", item.groupName);
  }
  if (item == null ? void 0 : item.groupId) {
    span.setAttribute("data-group-id", item.groupId);
  }
  if (process.env.NODE_ENV !== "production") {
    span.setAttribute("data-testid", "final");
  }
  if (config.customizeFragment) {
    config.customizeFragment(span, true);
  }
  span.setAttribute("data-integrity", span.innerHTML);
  if (span.parentElement) {
    const textNode = document.createTextNode(" ");
    span.parentElement.insertBefore(textNode, span.nextSibling);
    setCursorPosition(textNode, 1);
  }
}
function replaceSpacesWithInsecableSpaces(text) {
  const div = document.createElement("div");
  div.innerHTML = text;
  function recursiveSpaceReplacer(element) {
    Array.from(element.childNodes).forEach((element2) => {
      if (element2 instanceof Text && element2.nodeValue) {
        element2.nodeValue = element2.nodeValue.replace(/( |\t)/g, " ");
      } else if (element2 instanceof HTMLElement) {
        recursiveSpaceReplacer(element2);
        if (element2.hasAttribute("data-rich-mentions") && !element2.hasAttribute("data-integrity")) {
          element2.setAttribute("data-integrity", element2.innerHTML);
        }
      }
    });
  }
  recursiveSpaceReplacer(div);
  return div.innerHTML;
}
function getConfigsInitialValue(configs) {
  return (text) => {
    const formattedTextWithHtml = configs.reduce((acc, config) => {
      return acc.replace(config.match, ($0) => {
        const span = document.createElement("span");
        transformFinalFragment(span, $0, config);
        return span.outerHTML;
      });
    }, text);
    return replaceSpacesWithInsecableSpaces(formattedTextWithHtml);
  };
}
function getFragment(node) {
  const element = nodeToHtmlElement(node);
  return (element == null ? void 0 : element.hasAttribute("data-rich-mentions")) ? element : null;
}
function getTransformedValue(inputElement) {
  if (!inputElement || inputElement.innerHTML === "<br>") {
    return "";
  }
  const brCharacter = `_br_${Date.now()}_`;
  const brMatcher = new RegExp(`\\n?${brCharacter}\\n?`, "g");
  const processedContent = Array.from(inputElement.childNodes).map((el) => {
    const content = getNodeContent(el, brCharacter);
    return content;
  }).join("");
  const result = processedContent.replace(/\u00A0/g, " ").replace(/\n{2,}/g, "\n").replace(brMatcher, "\n").trim();
  return result;
}
function getNodeContent(element, brCharacter) {
  if (element instanceof Text) {
    return element.textContent || "";
  }
  if (element instanceof HTMLBRElement) {
    return brCharacter;
  }
  if (element instanceof Element) {
    const richValue = element.getAttribute("data-rich-mentions");
    if (richValue) {
      return richValue;
    }
    const char = element instanceof HTMLDivElement ? "\n" : "";
    const children = Array.from(element.childNodes).map((node) => getNodeContent(node, brCharacter)).join("");
    return char + children + char;
  }
  return "";
}
function handleFragmentCreation(event, selection, configs, ctx) {
  const { anchorNode, anchorOffset } = selection;
  if (event.defaultPrevented || !anchorNode || getFragment(anchorNode)) {
    return;
  }
  const insertion = event.data;
  const fragmentText = anchorNode.textContent || "";
  const text = fragmentText.substr(0, anchorOffset) + insertion + fragmentText.substr(anchorOffset);
  const config = configs.find((cfg) => text.match(cfg.query));
  if (!config) {
    return;
  }
  const matches = text.match(config.query);
  const index = matches.index || 0;
  const textBeforeQuery = text.substr(0, index);
  if (textBeforeQuery.length && !/\W$/.test(textBeforeQuery) || anchorOffset < index || anchorOffset >= index + matches[0].length) {
    return;
  }
  anchorNode.textContent = textBeforeQuery;
  const fragment = document.createElement("span");
  const textQuery = matches[0].substr(
    0,
    anchorOffset - index + insertion.length
  );
  const afterInsertion = text.substr(index + textQuery.length);
  fragment.setAttribute("data-rich-mentions", "");
  fragment.setAttribute("spellcheck", "false");
  if (process.env.NODE_ENV !== "production") {
    fragment.setAttribute("data-testid", "pending");
  }
  fragment.textContent = textQuery;
  if (config.customizeFragment) {
    config.customizeFragment(fragment, false);
  }
  const after = document.createTextNode(
    /^\s/.test(afterInsertion) ? afterInsertion : " " + afterInsertion
  );
  const isContainer = event.currentTarget === anchorNode;
  const parent = isContainer ? anchorNode : anchorNode.parentElement;
  if (parent) {
    if (isContainer) {
      parent.appendChild(fragment);
      parent.appendChild(after);
    } else {
      parent.insertBefore(after, anchorNode.nextSibling);
      parent.insertBefore(fragment, anchorNode.nextSibling);
    }
  }
  event.preventDefault();
  if (!fragment.childNodes[0]) {
    return;
  }
  setCursorPosition(
    fragment.childNodes[0],
    anchorOffset - textBeforeQuery.length + 1
  );
  ctx.openAutocomplete(fragment, textQuery, config);
}
const removeIfFinalFragment = (node, container) => {
  const element = nodeToHtmlElement(node);
  if (!container.contains(element) || container === element) {
    return;
  }
  if (element && element.hasAttribute("data-integrity")) {
    container.removeChild(element);
  }
};
function handleFragmentDeletion(event, selection) {
  if (event.defaultPrevented) {
    return;
  }
  const container = event.currentTarget;
  for (let i = 0; i < selection.rangeCount; i++) {
    const range2 = selection.getRangeAt(i);
    removeIfFinalFragment(range2.startContainer, container);
    removeIfFinalFragment(range2.endContainer, container);
  }
}
function removeBrokenFragments(inputElement, configs) {
  Array.from(inputElement.children).forEach(
    function fixBrokenElement(element, index) {
      const parent = element.parentElement;
      if (element instanceof HTMLBRElement) {
        if (parent.children.length !== 1 && index !== parent.children.length - 1) {
          const div = document.createElement("div");
          parent.insertBefore(div, element);
          div.appendChild(element);
        }
        return;
      }
      if (element instanceof HTMLDivElement && !element.attributes.length) {
        Array.from(element.children).forEach(fixBrokenElement);
        return;
      }
      const text = element.textContent || "";
      if (!(element instanceof Text) && !element.hasAttribute("data-rich-mentions")) {
        parent.insertBefore(document.createTextNode(text), element);
        parent.removeChild(element);
        return;
      }
      if (element.hasAttribute("data-integrity")) {
        if (element.getAttribute("data-integrity") !== element.innerHTML) {
          const parentNode = element.parentNode;
          if (parentNode) {
            let targetNode = element.previousSibling;
            let position = 0;
            if (targetNode && targetNode.nodeType === Node.TEXT_NODE) {
              position = targetNode.length;
              setCursorPosition(targetNode, position);
            } else if (!targetNode && parentNode.firstChild) {
              setCursorPosition(parentNode.firstChild, 0);
            } else {
              setCursorPosition(parentNode, 0);
            }
            parentNode.removeChild(element);
          }
        }
        return;
      }
      const isValid = configs.some((cfg) => text.match(cfg.query));
      if (!isValid) {
        parent.insertBefore(document.createTextNode(text), element.nextSibling);
        parent.removeChild(element);
      }
    }
  );
}
const isSpace = (char) => /(\u00A0|\s)/.test(char);
const needSpaceBefore = (text, offset, node, defaultValue) => {
  if (offset > 0) {
    return !isSpace(text.charAt(offset - 1));
  }
  if (["DIV", "BR"].includes(node.nodeName)) {
    return false;
  }
  if (node.previousSibling) {
    const prevText = node.previousSibling.textContent || "";
    return !!prevText.length && !isSpace(prevText.charAt(prevText.length - 1));
  }
  return defaultValue;
};
const needSpaceAfter = (text, offset, node) => {
  if (offset < text.length) {
    return !isSpace(text.charAt(text.length - 1));
  }
  if (!node.nextSibling) {
    return true;
  }
  const nextText = node.nextSibling.textContent || "";
  return !nextText.length || !isSpace(nextText.charAt(0));
};
function insertFragment(ref, customFragment, configs, inputElement) {
  var _a, _b, _c, _d, _e, _f;
  const config = configs.find((cfg) => ref.match(cfg.match));
  if (!inputElement || !config && !customFragment) {
    return;
  }
  let insertAfterNode = null;
  let insertBeforeNode = null;
  let addSpaceBefore = false;
  let addSpaceAfter = false;
  const selection = document.getSelection();
  if (selection && selection.anchorNode && inputElement.contains(selection.anchorNode)) {
    let { anchorNode: node, anchorOffset: offset } = selection;
    let fragment = getFragment(node);
    deleteSelection(selection);
    if (fragment && offset === (node.textContent || "").length) {
      if (!fragment.nextSibling) {
        inputElement.insertBefore(document.createTextNode(""), null);
      }
      node = fragment.nextSibling;
      offset = 0;
      fragment = null;
    }
    if (fragment) {
      if (fragment.hasAttribute("data-integrity")) {
        insertBeforeNode = fragment.nextSibling;
        (_a = fragment.parentElement) == null ? void 0 : _a.removeChild(fragment);
      } else {
        const text = node.textContent || "";
        if (offset > 0 && offset < text.length) {
          const firstPart = text.substr(0, offset);
          const secondPart = text.substr(offset);
          const subFragment = document.createTextNode(secondPart);
          inputElement.insertBefore(subFragment, fragment.nextSibling);
          node.textContent = firstPart;
          addSpaceBefore = true;
          insertBeforeNode = subFragment;
        }
        addSpaceBefore = needSpaceBefore(text, offset, node, addSpaceBefore);
        addSpaceAfter = needSpaceAfter(text, offset, node);
      }
    } else {
      let text = node.textContent || "";
      if (offset > 0) {
        insertAfterNode = node;
      } else {
        const element = node;
        if (!text && element.nodeName === "DIV" && !element.attributes.length && element.childNodes.length === 1 && element.firstElementChild instanceof HTMLBRElement) {
          if (element.previousSibling instanceof HTMLDivElement) {
            insertBeforeNode = node;
            element.removeChild(element.firstElementChild);
          } else {
            insertAfterNode = node;
            element.removeChild(element.firstElementChild);
          }
        } else {
          insertBeforeNode = node;
        }
      }
      if (offset > 0 && offset < text.length) {
        const firstPart = text.substr(0, offset);
        const secondPart = text.substr(offset);
        text = firstPart;
        node.textContent = firstPart;
        (_b = node.parentElement) == null ? void 0 : _b.insertBefore(
          document.createTextNode(secondPart),
          node.nextSibling
        );
      }
      addSpaceBefore = needSpaceBefore(text, offset, node, addSpaceBefore);
      addSpaceAfter = needSpaceAfter(text, offset, node);
    }
  } else {
    const text = inputElement.textContent || "";
    addSpaceAfter = true;
    addSpaceBefore = !isSpace(text.charAt(text.length - 1));
  }
  const span = document.createElement("span");
  if (config) {
    transformFinalFragment(span, ref, config);
  } else if (customFragment) {
    span.appendChild(customFragment);
    span.setAttribute("data-rich-mentions", ref);
    span.setAttribute("data-integrity", span.innerHTML);
    span.setAttribute("spellcheck", "false");
    if (process.env.NODE_ENV !== "production") {
      span.setAttribute("data-testid", "final");
    }
  }
  if (insertAfterNode && insertAfterNode !== inputElement) {
    (_c = insertAfterNode.parentElement) == null ? void 0 : _c.insertBefore(
      span,
      insertAfterNode.nextSibling
    );
  } else if (insertBeforeNode && insertBeforeNode !== inputElement) {
    (_d = insertBeforeNode.parentElement) == null ? void 0 : _d.insertBefore(span, insertBeforeNode);
  } else {
    inputElement.appendChild(span);
  }
  if (addSpaceBefore) {
    const space = document.createTextNode(" ");
    (_e = span.parentElement) == null ? void 0 : _e.insertBefore(space, span);
  }
  if (addSpaceAfter) {
    const space = document.createTextNode(" ");
    (_f = span.parentElement) == null ? void 0 : _f.insertBefore(space, span.nextSibling);
  }
  if (span.nextSibling) {
    setCursorPosition(span.nextSibling, addSpaceAfter ? 1 : 0);
  }
  removeBrokenFragments(inputElement, configs);
}
function markFragmentAsStale(element) {
  var _a;
  element.classList.remove("pending");
  element.classList.add("stale");
  element.removeAttribute("data-rich-mentions");
  if (element.nextSibling) {
    setCursorPosition(element.nextSibling, 0);
  } else {
    const textNode = document.createTextNode(" ");
    (_a = element.parentNode) == null ? void 0 : _a.appendChild(textNode);
    setCursorPosition(textNode, 1);
  }
}
function RichMentionsProvider({
  children,
  configs,
  getContext,
  getInitialHTML = getConfigsInitialValue(configs)
}) {
  const ref = useRef({
    // @ts-ignore
    ...initialContext,
    configs,
    getInitialHTML,
    setPositionFixed,
    setInputElement,
    selectItem,
    executeActionCallback,
    onBeforeChanges,
    onChanges,
    onKeyDown,
    closeAutocomplete,
    openAutocomplete,
    setActiveItemIndex,
    getTransformedValue: getTransformedValue$1,
    insertFragment: insertFragment$1,
    setValue
  });
  const [__ctx__, setState] = useState(ref.current);
  const updateState = (data) => {
    ref.current = {
      ...ref.current,
      ...data
    };
    setState(ref.current);
  };
  useEffect(() => {
    document.addEventListener("selectionchange", onSelectionChange, false);
    return () => {
      document.removeEventListener("selectionchange", onSelectionChange, false);
    };
  }, []);
  useEffect(() => {
    if (typeof getContext === "function") {
      getContext(__ctx__);
    } else if (typeof getContext === "object") {
      getContext.current = __ctx__;
    }
  }, [getContext, __ctx__]);
  useEffect(() => {
    updateState({
      configs,
      results: [],
      // Clear any cached results
      index: 0,
      loading: false
    });
    if (ref.current.opened) {
      const text = ref.current.opened.element.textContent || "";
      const config = configs.find((cfg) => text.match(cfg.query));
      if (config) {
        openAutocomplete(ref.current.opened.element, text, config);
      }
    }
  }, [configs]);
  function setPositionFixed(fixed) {
    updateState({ fixed });
  }
  function setInputElement(inputElement) {
    updateState({ inputElement });
  }
  function selectItem(item) {
    const opened = ref.current.opened;
    if (opened == null ? void 0 : opened.element) {
      transformFinalFragment(opened.element, item.ref, opened.config, item);
      if (ref.current.inputElement) {
        const inputEvent = new Event("input", {
          bubbles: true,
          cancelable: true
        });
        ref.current.inputElement.dispatchEvent(inputEvent);
      }
    }
    updateState({
      index: 0,
      results: [],
      opened: null,
      loading: false,
      activeSearch: ""
    });
  }
  function executeActionCallback(item) {
    if (item.callback) {
      item.callback();
      const { opened } = ref.current;
      if (opened == null ? void 0 : opened.element) {
        opened.element.remove();
      }
      updateState({
        index: 0,
        results: [],
        opened: null,
        loading: false,
        activeSearch: ""
      });
    }
  }
  function onBeforeChanges(event) {
    let selection = document.getSelection();
    if (!selection || !selection.anchorNode) {
      return;
    }
    if (deleteSelection(selection, event)) {
      selection = document.getSelection();
      if (!selection || !selection.anchorNode) {
        return;
      }
    }
    fixCursorInsertion(event, selection);
    handleFragmentDeletion(event, selection);
    handleFragmentCreation(event, selection, configs, ref.current);
    removeBrokenFragments(event.currentTarget, configs);
  }
  function onSelectionChange() {
    const { inputElement, opened, closeAutocomplete: closeAutocomplete2, openAutocomplete: openAutocomplete2 } = ref.current;
    const selection = document.getSelection();
    const fragment = (selection == null ? void 0 : selection.anchorNode) && (getFragment(selection.anchorNode) || selection.anchorOffset === 0 && selection.anchorNode.previousSibling && getFragment(selection.anchorNode.previousSibling));
    const shouldOpened = fragment && !fragment.hasAttribute("data-integrity") && inputElement && inputElement.contains(fragment);
    if (opened && !shouldOpened) {
      closeAutocomplete2();
    } else if (shouldOpened && fragment && (!opened || opened.element !== fragment)) {
      const text = fragment.textContent || "";
      const config = configs.find((cfg) => text.match(cfg.query));
      if (config) {
        openAutocomplete2(fragment, text, config);
      }
    }
  }
  function onChanges() {
    const { inputElement, openAutocomplete: openAutocomplete2, closeAutocomplete: closeAutocomplete2 } = ref.current;
    const selection = document.getSelection();
    if (inputElement) {
      removeBrokenFragments(inputElement, configs);
    }
    const fragment = (selection == null ? void 0 : selection.anchorNode) && getFragment(selection.anchorNode);
    if (fragment && !fragment.hasAttribute("data-integrity")) {
      const text = fragment.textContent || "";
      const config = configs.find((cfg) => text.match(cfg.query));
      if (config) {
        openAutocomplete2(fragment, text, config);
      }
    } else if (ref.current.opened) {
      closeAutocomplete2();
    }
  }
  function onKeyDown(event) {
    const { opened, results, index, selectItem: selectItem2, closeAutocomplete: closeAutocomplete2 } = ref.current;
    if (!opened || !results.length) {
      return;
    }
    switch (event.keyCode) {
      case 40:
        event.preventDefault();
        updateState({
          index: index + 1 < results.length ? index + 1 : 0
          // Loop to the top if at the bottom
        });
        break;
      case 38:
        event.preventDefault();
        updateState({
          index: index - 1 >= 0 ? index - 1 : results.length - 1
          // Loop to the bottom if at the top
        });
        break;
      case 9:
      // tab
      case 13:
        if (results[index]) {
          event.preventDefault();
          event.stopPropagation();
          if (results[index].type === "no_results") {
            if (opened == null ? void 0 : opened.element) {
              markFragmentAsStale(opened.element);
            }
          } else if (results[index].type === "action" && typeof results[index].callback === "function") {
            executeActionCallback(results[index]);
          } else {
            selectItem2(results[index]);
          }
        }
        break;
      case 32:
        if (opened && results.length === 1 && results[0].type === "no_results") {
          event.preventDefault();
          markFragmentAsStale(opened.element);
          updateState({
            index: 0,
            results: [],
            opened: null,
            loading: false,
            activeSearch: ""
          });
          return;
        }
        break;
      case 27:
        markFragmentAsStale(opened.element);
        closeAutocomplete2();
        break;
    }
  }
  function closeAutocomplete() {
    updateState({
      opened: null,
      loading: false,
      results: [],
      index: 0,
      activeSearch: ""
    });
  }
  function openAutocomplete(node, text, config) {
    const fixed = ref.current.fixed;
    const rect = { top: 0, right: 0, bottom: 0, left: 0 };
    const nodeRect = node.getBoundingClientRect();
    rect.top = nodeRect.top;
    rect.right = nodeRect.right;
    rect.bottom = nodeRect.bottom;
    rect.left = nodeRect.left;
    if (!fixed && node.offsetParent) {
      const parentRect = node.offsetParent.getBoundingClientRect();
      rect.top -= parentRect.top;
      rect.right = rect.right - parentRect.right + parentRect.width;
      rect.left -= parentRect.left;
      rect.bottom = rect.bottom - parentRect.bottom + parentRect.height;
    }
    const ELEMENT_WIDTH = 200;
    const ELEMENT_HEIGHT = 300;
    const overflowX = nodeRect.left + 10 + ELEMENT_WIDTH - window.innerWidth;
    const overflowY = nodeRect.bottom + ELEMENT_HEIGHT - window.innerHeight;
    const x = overflowX > 0 ? rect.right + 15 : rect.left - 3;
    const y = overflowY > 0 ? rect.top - 3 : rect.bottom + 3;
    updateState({
      loading: true,
      index: 0,
      results: [],
      opened: {
        config,
        fixed,
        bottom: overflowY > 0,
        right: overflowX > 0,
        element: node,
        x,
        y
      },
      activeSearch: text
    });
    const currentConfig = ref.current.configs.find(
      (cfg) => cfg.query.toString() === config.query.toString()
    ) || config;
    const onResolve = (results = []) => {
      var _a;
      if (((_a = ref.current.opened) == null ? void 0 : _a.element) === node) {
        updateState({
          results,
          loading: false
        });
      }
    };
    const p = currentConfig.onMention(text, onResolve);
    if (p instanceof Promise) {
      p.then(onResolve, onResolve);
    } else if (p instanceof Array) {
      onResolve(p);
    }
  }
  function setActiveItemIndex(index) {
    updateState({ index });
  }
  function getTransformedValue$1() {
    return getTransformedValue(ref.current.inputElement);
  }
  function insertFragment$1(code, element = null) {
    insertFragment(code, element, configs, ref.current.inputElement);
  }
  function setValue(text) {
    const { inputElement, closeAutocomplete: closeAutocomplete2 } = ref.current;
    if (inputElement) {
      inputElement.innerHTML = getInitialHTML(text);
      removeBrokenFragments(inputElement, configs);
    }
    closeAutocomplete2();
  }
  return /* @__PURE__ */ jsx(RichMentionsContext.Provider, { value: __ctx__, children });
}
function RichMentionsAutocomplete({
  fixed = true,
  menuDirectionDown = false
}) {
  const {
    opened,
    index,
    //loading,
    results,
    setActiveItemIndex,
    selectItem,
    setPositionFixed,
    executeActionCallback
  } = useContext(RichMentionsContext);
  const listRef = useRef(null);
  const onSelectItem = (item) => () => {
    if (item.type === "action" && item.callback) {
      executeActionCallback(item);
    } else {
      selectItem(item);
    }
  };
  const onHoverOrFocusItem = (index2) => () => setActiveItemIndex(index2);
  const divAttributes = process.env.NODE_ENV !== "production" ? { "data-testid": "autocomplete" } : {};
  const itemAttributes = process.env.NODE_ENV !== "production" ? { "data-testid": "autocomplete_item" } : {};
  useEffect(() => {
    setPositionFixed(fixed);
  }, [fixed]);
  useEffect(() => {
    var _a;
    if (listRef.current && opened) {
      const selectableItems = listRef.current.querySelectorAll(".autocomplete-item");
      if (selectableItems.length > 0 && index < selectableItems.length) {
        let elementToScroll = selectableItems[index];
        const isGroupStart = index === 0 || ((_a = elementToScroll.previousElementSibling) == null ? void 0 : _a.classList.contains(
          "autocomplete-group-name"
        ));
        if (isGroupStart && elementToScroll.previousElementSibling) {
          elementToScroll = elementToScroll.previousElementSibling;
        }
        elementToScroll.scrollIntoView({ block: "nearest" });
      }
    }
  }, [index, opened]);
  const OFFSET = 3;
  return opened && results.length ? /* @__PURE__ */ jsx(
    "div",
    {
      ...divAttributes,
      className: "autocomplete",
      style: {
        position: fixed ? "fixed" : "absolute",
        left: opened.x + OFFSET + "px",
        ...menuDirectionDown ? {
          top: opened.y + "px"
        } : {
          bottom: `calc(100vh - ${opened.y}px)`,
          top: "auto"
        }
      },
      children: /* @__PURE__ */ jsx(
        "div",
        {
          ref: listRef,
          className: "autocomplete-list",
          style: {
            bottom: opened.bottom ? "0px" : "auto",
            right: opened.right ? "0px" : "auto"
          },
          children: results.map((item, i) => {
            const isGroupStart = i === 0 || item.groupName !== results[i - 1].groupName;
            const type = item.type;
            const isMention = item.type === "mention";
            return /* @__PURE__ */ jsxs(React__default.Fragment, { children: [
              isGroupStart && item.groupName && /* @__PURE__ */ jsx("div", { className: "autocomplete-group-name", children: item.groupName }),
              /* @__PURE__ */ jsxs(
                "button",
                {
                  className: `autocomplete-item autocomplete-item-${type} ${i === index ? "autocomplete-item-selected" : ""}`,
                  type: "button",
                  onClick: onSelectItem(item),
                  onMouseOver: onHoverOrFocusItem(i),
                  onFocus: onHoverOrFocusItem(i),
                  ...itemAttributes,
                  children: [
                    /* @__PURE__ */ jsx("span", { className: "autocomplete-item-name", children: item.name }),
                    isMention && /* @__PURE__ */ jsx("span", { className: "autocomplete-item-ref", children: item.display })
                  ]
                }
              )
            ] }, item.ref);
          })
        }
      )
    }
  ) : null;
}
function processMentionsInHTML(htmlContent) {
  const tempElement = document.createElement("div");
  tempElement.innerHTML = htmlContent;
  const mentionSpans = tempElement.querySelectorAll("span[data-rich-mentions]");
  mentionSpans.forEach((span) => {
    var _a;
    const encodedMention = span.getAttribute("data-rich-mentions");
    if (encodedMention) {
      const textNode = document.createTextNode(encodedMention);
      (_a = span.parentNode) == null ? void 0 : _a.replaceChild(textNode, span);
    }
  });
  const result = tempElement.innerText;
  return result;
}
const alertVariants = cva(
  "relative w-full rounded-lg border py-6 pl-6 pr-8 text-sm",
  {
    variants: {
      variant: {
        outline: "bg-gray-1 text-foreground",
        destructive: "bg-destructive text-gray-1"
      }
    },
    defaultVariants: {
      variant: "outline"
    }
  }
);
const Alert = React.forwardRef(({ className, variant, ...props }, ref) => /* @__PURE__ */ jsx(
  "div",
  {
    ref,
    role: "alert",
    className: cn(alertVariants({ variant }), className),
    ...props
  }
));
Alert.displayName = "Alert";
const AlertTitle = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  "h5",
  {
    ref,
    className: cn(
      "mb-1 font-medium text-lg leading-none tracking-tight",
      className
    ),
    ...props
  }
));
AlertTitle.displayName = "AlertTitle";
const AlertDescription = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  "div",
  {
    ref,
    className: cn("text-sm [&_p]:leading-relaxed", className),
    ...props
  }
));
AlertDescription.displayName = "AlertDescription";
const AlertDialog = AlertDialogPrimitive.Root;
const AlertDialogTrigger = AlertDialogPrimitive.Trigger;
const AlertDialogPortal = AlertDialogPrimitive.Portal;
const AlertDialogOverlay = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  AlertDialogPrimitive.Overlay,
  {
    className: cn(
      "fixed inset-0 z-50 bg-black/80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      className
    ),
    ...props,
    ref
  }
));
AlertDialogOverlay.displayName = AlertDialogPrimitive.Overlay.displayName;
const AlertDialogContent = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsxs(AlertDialogPortal, { children: [
  /* @__PURE__ */ jsx(AlertDialogOverlay, {}),
  /* @__PURE__ */ jsx(
    AlertDialogPrimitive.Content,
    {
      ref,
      className: cn(
        "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-popover p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg",
        className
      ),
      ...props
    }
  )
] }));
AlertDialogContent.displayName = AlertDialogPrimitive.Content.displayName;
const AlertDialogHeader = ({
  className,
  ...props
}) => /* @__PURE__ */ jsx(
  "div",
  {
    className: cn(
      "flex flex-col space-y-2 text-center sm:text-left",
      className
    ),
    ...props
  }
);
AlertDialogHeader.displayName = "AlertDialogHeader";
const AlertDialogFooter = ({
  className,
  ...props
}) => /* @__PURE__ */ jsx(
  "div",
  {
    className: cn(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
      className
    ),
    ...props
  }
);
AlertDialogFooter.displayName = "AlertDialogFooter";
const AlertDialogTitle = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  AlertDialogPrimitive.Title,
  {
    ref,
    className: cn("text-lg font-semibold", className),
    ...props
  }
));
AlertDialogTitle.displayName = AlertDialogPrimitive.Title.displayName;
const AlertDialogDescription = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  AlertDialogPrimitive.Description,
  {
    ref,
    className: cn("text-sm text-muted-foreground", className),
    ...props
  }
));
AlertDialogDescription.displayName = AlertDialogPrimitive.Description.displayName;
const AlertDialogAction = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  AlertDialogPrimitive.Action,
  {
    ref,
    className: cn(buttonVariants(), className),
    ...props
  }
));
AlertDialogAction.displayName = AlertDialogPrimitive.Action.displayName;
const AlertDialogCancel = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  AlertDialogPrimitive.Cancel,
  {
    ref,
    className: cn(
      buttonVariants({ variant: "outline" }),
      "mt-2 sm:mt-0",
      className
    ),
    ...props
  }
));
AlertDialogCancel.displayName = AlertDialogPrimitive.Cancel.displayName;
const avatarVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap rounded-sm text-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      size: {
        sm: "size-7",
        md: "size-8",
        lg: "size-10"
      }
    },
    defaultVariants: {
      size: "lg"
    }
  }
);
const Avatar = React.forwardRef(({ className, size, ...props }, ref) => {
  return /* @__PURE__ */ jsx(
    AvatarPrimitive.Root,
    {
      ref,
      className: cn(
        "relative flex shrink-0 overflow-hidden rounded-sm border",
        avatarVariants({ size }),
        className
      ),
      ...props
    }
  );
});
Avatar.displayName = AvatarPrimitive.Root.displayName;
const AvatarImage = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  AvatarPrimitive.Image,
  {
    ref,
    className: cn("aspect-square h-full rounded-sm", className),
    ...props
  }
));
AvatarImage.displayName = AvatarPrimitive.Image.displayName;
const AvatarFallback = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  AvatarPrimitive.Fallback,
  {
    ref,
    className: cn(
      "h-full w-full flex items-center justify-center rounded-sm bg-gray-3",
      className
    ),
    ...props
  }
));
AvatarFallback.displayName = AvatarPrimitive.Fallback.displayName;
const Breadcrumb = React.forwardRef(({ ...props }, ref) => /* @__PURE__ */ jsx("nav", { ref, "aria-label": "breadcrumb", ...props }));
Breadcrumb.displayName = "Breadcrumb";
const BreadcrumbList = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  "ol",
  {
    ref,
    className: cn(
      "flex flex-wrap items-center gap-1.5 break-words text-sm text-muted-foreground sm:gap-2.5",
      className
    ),
    ...props
  }
));
BreadcrumbList.displayName = "BreadcrumbList";
const BreadcrumbItem = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  "li",
  {
    ref,
    className: cn("inline-flex items-center gap-1.5", className),
    ...props
  }
));
BreadcrumbItem.displayName = "BreadcrumbItem";
const BreadcrumbLink = React.forwardRef(({ asChild, className, iconName, isActive, children, ...props }, ref) => {
  const Comp = asChild ? Slot : "a";
  return /* @__PURE__ */ jsxs(
    Comp,
    {
      ref,
      className: cn(
        "transition-colors hover:text-foreground flex items-center gap-1.5",
        isActive ? "text-foreground" : "text-muted-foreground",
        className
      ),
      ...props,
      children: [
        iconName && /* @__PURE__ */ jsx(Icon, { name: iconName }),
        children
      ]
    }
  );
});
BreadcrumbLink.displayName = "BreadcrumbLink";
const BreadcrumbPage = React.forwardRef(({ className, iconName, isActive, children, ...props }, ref) => /* @__PURE__ */ jsxs(
  "span",
  {
    ref,
    role: "link",
    "aria-disabled": "true",
    "aria-current": "page",
    className: cn(
      "font-normal flex items-center gap-1.5",
      isActive ? "text-foreground" : "text-muted-foreground",
      className
    ),
    ...props,
    children: [
      iconName && /* @__PURE__ */ jsx(Icon, { name: iconName }),
      children
    ]
  }
));
BreadcrumbPage.displayName = "BreadcrumbPage";
const BreadcrumbSeparator = ({
  children,
  className,
  ...props
}) => /* @__PURE__ */ jsx(
  "li",
  {
    role: "presentation",
    "aria-hidden": "true",
    className: cn("[&>svg]:size-3.5", className),
    ...props,
    children: children ?? /* @__PURE__ */ jsx(ChevronRightIcon, {})
  }
);
BreadcrumbSeparator.displayName = "BreadcrumbSeparator";
const BreadcrumbEllipsis = ({
  className,
  ...props
}) => /* @__PURE__ */ jsxs(
  "span",
  {
    role: "presentation",
    "aria-hidden": "true",
    className: cn("flex h-9 w-9 items-center justify-center", className),
    ...props,
    children: [
      /* @__PURE__ */ jsx(DotsHorizontalIcon, { className: "size-4" }),
      /* @__PURE__ */ jsx("span", { className: "sr-only", children: "More" })
    ]
  }
);
BreadcrumbEllipsis.displayName = "BreadcrumbElipssis";
function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    DayPicker,
    {
      showOutsideDays,
      className: cn("p-3", className),
      classNames: {
        months: "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0",
        month: "space-y-4",
        caption: "flex justify-center pt-1 relative items-center",
        caption_label: "text-sm font-medium",
        nav: "space-x-1 flex items-center",
        nav_button: cn(
          buttonVariants({ variant: "outline" }),
          "h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100"
        ),
        nav_button_previous: "absolute left-1",
        nav_button_next: "absolute right-1",
        table: "w-full border-collapse space-y-1",
        head_row: "flex",
        head_cell: "text-muted-foreground rounded-md w-8 font-normal text-[0.8rem]",
        row: "flex w-full mt-2",
        cell: cn(
          "relative p-0 text-center text-sm focus-within:relative focus-within:z-20 [&:has([aria-selected])]:bg-accent [&:has([aria-selected].day-outside)]:bg-accent/50 [&:has([aria-selected].day-range-end)]:rounded-r-md",
          props.mode === "range" ? "[&:has(>.day-range-end)]:rounded-r-md [&:has(>.day-range-start)]:rounded-l-md first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md" : "[&:has([aria-selected])]:rounded-md"
        ),
        day: cn(
          buttonVariants({ variant: "ghost" }),
          "h-8 w-8 p-0 font-normal aria-selected:opacity-100"
        ),
        day_range_start: "day-range-start",
        day_range_end: "day-range-end",
        day_selected: "bg-primary text-primary-foreground hover:bg-primary hover:text-primary-foreground focus:bg-primary focus:text-primary-foreground",
        day_today: "bg-accent text-accent-foreground",
        day_outside: "day-outside text-muted-foreground aria-selected:bg-accent/50 aria-selected:text-muted-foreground",
        day_disabled: "text-muted-foreground opacity-50",
        day_range_middle: "aria-selected:bg-accent aria-selected:text-accent-foreground",
        day_hidden: "invisible",
        ...classNames
      },
      components: {
        IconLeft: ({ className: className2, ...props2 }) => /* @__PURE__ */ jsx(
          Icon,
          {
            name: "chevron-left",
            className: cn("h-4 w-4", className2),
            ...props2
          }
        ),
        IconRight: ({ className: className2, ...props2 }) => /* @__PURE__ */ jsx(
          Icon,
          {
            name: "chevron-right",
            className: cn("h-4 w-4", className2),
            ...props2
          }
        )
      },
      ...props
    }
  );
}
Calendar.displayName = "Calendar";
const Card = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  "div",
  {
    ref,
    className: cn(
      "rounded-xl border bg-card text-card-foreground shadow",
      className
    ),
    ...props
  }
));
Card.displayName = "Card";
const CardHeader = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  "div",
  {
    ref,
    className: cn("flex flex-col space-y-1.5 p-6", className),
    ...props
  }
));
CardHeader.displayName = "CardHeader";
const CardTitle = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  "div",
  {
    ref,
    className: cn("font-semibold leading-none tracking-tight", className),
    ...props
  }
));
CardTitle.displayName = "CardTitle";
const CardDescription = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  "div",
  {
    ref,
    className: cn("text-sm text-muted-foreground", className),
    ...props
  }
));
CardDescription.displayName = "CardDescription";
const CardContent = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx("div", { ref, className: cn("p-6 pt-0", className), ...props }));
CardContent.displayName = "CardContent";
const CardFooter = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  "div",
  {
    ref,
    className: cn("flex items-center p-6 pt-0", className),
    ...props
  }
));
CardFooter.displayName = "CardFooter";
const THEMES = { light: "", dark: ".dark" };
const ChartContext = React.createContext(null);
function useChart() {
  const context = React.useContext(ChartContext);
  if (!context) {
    throw new Error("useChart must be used within a <ChartContainer />");
  }
  return context;
}
const ChartContainer = React.forwardRef(
  ({ id, className, children, config, aspectRatio = "aspect-video", ...props }, ref) => {
    const uniqueId = React.useId();
    const chartId = `chart-${id || uniqueId.replace(/:/g, "")}`;
    return /* @__PURE__ */ jsx(ChartContext.Provider, { value: { config }, children: /* @__PURE__ */ jsxs(
      "div",
      {
        "data-chart": chartId,
        ref,
        className: cn(
          `flex ${aspectRatio} justify-center text-xs [&_.recharts-cartesian-axis-tick_text]:fill-muted-foreground [&_.recharts-cartesian-grid_line[stroke='#ccc']]:stroke-border/50 [&_.recharts-curve.recharts-tooltip-cursor]:stroke-border [&_.recharts-dot[stroke='#fff']]:stroke-transparent [&_.recharts-layer]:outline-none [&_.recharts-polar-grid_[stroke='#ccc']]:stroke-border [&_.recharts-radial-bar-background-sector]:fill-muted [&_.recharts-rectangle.recharts-tooltip-cursor]:fill-muted [&_.recharts-reference-line_[stroke='#ccc']]:stroke-border [&_.recharts-sector[stroke='#fff']]:stroke-transparent [&_.recharts-sector]:outline-none [&_.recharts-surface]:outline-none`,
          className
        ),
        ...props,
        children: [
          /* @__PURE__ */ jsx(ChartStyle, { id: chartId, config }),
          /* @__PURE__ */ jsx(RechartsPrimitive.ResponsiveContainer, { children })
        ]
      }
    ) });
  }
);
ChartContainer.displayName = "Chart";
const ChartStyle = ({ id, config }) => {
  const colorConfig = Object.entries(config).filter(
    ([, config2]) => config2.theme || config2.color
  );
  if (!colorConfig.length) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    "style",
    {
      dangerouslySetInnerHTML: {
        __html: Object.entries(THEMES).map(
          ([theme, prefix]) => `
${prefix} [data-chart=${id}] {
${colorConfig.map(([key, itemConfig]) => {
            var _a;
            const color = ((_a = itemConfig.theme) == null ? void 0 : _a[theme]) || itemConfig.color;
            return color ? `  --color-${key}: ${color};` : null;
          }).join("\n")}
}
`
        ).join("\n")
      }
    }
  );
};
const ChartTooltip = RechartsPrimitive.Tooltip;
const ChartTooltipContent = React.forwardRef(
  ({
    active,
    payload,
    className,
    indicator = "dot",
    hideLabel = false,
    hideIndicator = false,
    label,
    labelFormatter,
    labelClassName,
    formatter,
    color,
    nameKey,
    labelKey
  }, ref) => {
    const { config } = useChart();
    const tooltipLabel = React.useMemo(() => {
      var _a;
      if (hideLabel || !(payload == null ? void 0 : payload.length)) {
        return null;
      }
      const [item] = payload;
      const key = `${labelKey || (item == null ? void 0 : item.dataKey) || (item == null ? void 0 : item.name) || "value"}`;
      const itemConfig = getPayloadConfigFromPayload(config, item, key);
      const value = !labelKey && typeof label === "string" ? ((_a = config[label]) == null ? void 0 : _a.label) || label : itemConfig == null ? void 0 : itemConfig.label;
      if (labelFormatter) {
        return /* @__PURE__ */ jsx("div", { className: cn("font-medium", labelClassName), children: labelFormatter(value, payload) });
      }
      if (!value) {
        return null;
      }
      return /* @__PURE__ */ jsx("div", { className: cn("font-medium", labelClassName), children: value });
    }, [
      label,
      labelFormatter,
      payload,
      hideLabel,
      labelClassName,
      config,
      labelKey
    ]);
    if (!active || !(payload == null ? void 0 : payload.length)) {
      return null;
    }
    const nestLabel = payload.length === 1 && indicator !== "dot";
    return /* @__PURE__ */ jsxs(
      "div",
      {
        ref,
        className: cn(
          "grid min-w-[8rem] items-start gap-1.5 rounded-lg border border-border/50 bg-background px-2.5 py-1.5 text-xs shadow-xl",
          className
        ),
        children: [
          !nestLabel ? tooltipLabel : null,
          /* @__PURE__ */ jsx("div", { className: "grid gap-1.5", children: payload.map((item, index) => {
            const key = `${nameKey || item.name || item.dataKey || "value"}`;
            const itemConfig = getPayloadConfigFromPayload(config, item, key);
            const indicatorColor = color || item.payload.fill || item.color;
            return /* @__PURE__ */ jsx(
              "div",
              {
                className: cn(
                  "flex w-full flex-wrap items-stretch gap-2 [&>svg]:h-2.5 [&>svg]:w-2.5 [&>svg]:text-muted-foreground",
                  indicator === "dot" && "items-center"
                ),
                children: formatter && (item == null ? void 0 : item.value) !== void 0 && item.name ? formatter(item.value, item.name, item, index, item.payload) : /* @__PURE__ */ jsxs(Fragment$1, { children: [
                  (itemConfig == null ? void 0 : itemConfig.icon) ? /* @__PURE__ */ jsx(itemConfig.icon, {}) : !hideIndicator && /* @__PURE__ */ jsx(
                    "div",
                    {
                      className: cn(
                        "shrink-0 rounded-[2px] border-[--color-border] bg-[--color-bg]",
                        {
                          "h-2.5 w-2.5": indicator === "dot",
                          "w-1": indicator === "line",
                          "w-0 border-[1.5px] border-dashed bg-transparent": indicator === "dashed",
                          "my-0.5": nestLabel && indicator === "dashed"
                        }
                      ),
                      style: {
                        "--color-bg": indicatorColor,
                        "--color-border": indicatorColor
                      }
                    }
                  ),
                  /* @__PURE__ */ jsxs(
                    "div",
                    {
                      className: cn(
                        "flex flex-1 justify-between leading-none",
                        nestLabel ? "items-end" : "items-center"
                      ),
                      children: [
                        /* @__PURE__ */ jsxs("div", { className: "grid gap-1.5", children: [
                          nestLabel ? tooltipLabel : null,
                          /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: (itemConfig == null ? void 0 : itemConfig.label) || item.name })
                        ] }),
                        item.value && /* @__PURE__ */ jsx("span", { className: "font-mono font-medium tabular-nums text-foreground", children: item.value.toLocaleString() })
                      ]
                    }
                  )
                ] })
              },
              item.dataKey
            );
          }) })
        ]
      }
    );
  }
);
ChartTooltipContent.displayName = "ChartTooltip";
const ChartLegend = RechartsPrimitive.Legend;
const ChartLegendContent = React.forwardRef(
  ({ className, hideIcon = false, payload, verticalAlign = "bottom", nameKey }, ref) => {
    const { config } = useChart();
    if (!(payload == null ? void 0 : payload.length)) {
      return null;
    }
    return /* @__PURE__ */ jsx(
      "div",
      {
        ref,
        className: cn(
          "flex items-center justify-center gap-4",
          verticalAlign === "top" ? "pb-3" : "pt-3",
          className
        ),
        children: payload.map((item) => {
          const key = `${nameKey || item.dataKey || "value"}`;
          const itemConfig = getPayloadConfigFromPayload(config, item, key);
          return /* @__PURE__ */ jsxs(
            "div",
            {
              className: cn(
                "flex items-center gap-1.5 [&>svg]:h-3 [&>svg]:w-3 [&>svg]:text-muted-foreground"
              ),
              children: [
                (itemConfig == null ? void 0 : itemConfig.icon) && !hideIcon ? /* @__PURE__ */ jsx(itemConfig.icon, {}) : /* @__PURE__ */ jsx(
                  "div",
                  {
                    className: "size-2 shrink-0 rounded-[2px]",
                    style: {
                      backgroundColor: item.color
                    }
                  }
                ),
                itemConfig == null ? void 0 : itemConfig.label
              ]
            },
            item.value
          );
        })
      }
    );
  }
);
ChartLegendContent.displayName = "ChartLegend";
function getPayloadConfigFromPayload(config, payload, key) {
  if (typeof payload !== "object" || payload === null) {
    return void 0;
  }
  const payloadPayload = "payload" in payload && typeof payload.payload === "object" && payload.payload !== null ? payload.payload : void 0;
  let configLabelKey = key;
  if (key in payload && typeof payload[key] === "string") {
    configLabelKey = payload[key];
  } else if (payloadPayload && key in payloadPayload && typeof payloadPayload[key] === "string") {
    configLabelKey = payloadPayload[key];
  }
  return configLabelKey in config ? config[configLabelKey] : config[key];
}
const LineChart = RechartsPrimitive.LineChart;
const BarChart = RechartsPrimitive.BarChart;
const AreaChart = RechartsPrimitive.AreaChart;
const PieChart = RechartsPrimitive.PieChart;
const Line = RechartsPrimitive.Line;
const Bar = RechartsPrimitive.Bar;
const Area = RechartsPrimitive.Area;
const Pie = RechartsPrimitive.Pie;
const Cell = RechartsPrimitive.Cell;
const XAxis = RechartsPrimitive.XAxis;
const YAxis = RechartsPrimitive.YAxis;
const CartesianGrid = RechartsPrimitive.CartesianGrid;
const Legend = RechartsPrimitive.Legend;
const ResponsiveContainer = RechartsPrimitive.ResponsiveContainer;
const ReferenceLine = RechartsPrimitive.ReferenceLine;
const Brush = RechartsPrimitive.Brush;
const ContextMenu = ContextMenuPrimitive.Root;
const ContextMenuTrigger = ContextMenuPrimitive.Trigger;
const ContextMenuRadioGroup = ContextMenuPrimitive.RadioGroup;
const ContextMenuSub = ContextMenuPrimitive.Sub;
const ContextMenuGroup = ContextMenuPrimitive.Group;
const ContextMenuContent = React__default.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(ContextMenuPrimitive.Portal, { children: /* @__PURE__ */ jsx(
  ContextMenuPrimitive.Content,
  {
    ref,
    className: cn(
      "z-50 min-w-[15rem] overflow-hidden rounded border p-1 bg-popover text-popover-foreground shadow-md",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      className
    ),
    ...props
  }
) }));
ContextMenuContent.displayName = ContextMenuPrimitive.Content.displayName;
const ContextMenuItem = React__default.forwardRef(({ className, inset, destructive, icon, ...props }, ref) => /* @__PURE__ */ jsxs(Fragment$1, { children: [
  icon && /* @__PURE__ */ jsx(Icon, { name: icon, className: "mr-2" }),
  /* @__PURE__ */ jsx(
    ContextMenuPrimitive.Item,
    {
      ref,
      className: cn(
        "relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 data-[highlighted]:bg-accent ",
        inset && "pl-8",
        destructive && "text-destructive",
        className
      ),
      ...props
    }
  )
] }));
ContextMenuItem.displayName = ContextMenuPrimitive.ContextMenuItem.displayName;
const ContextMenuLabel = React__default.forwardRef(({ className, inset, ...props }, ref) => /* @__PURE__ */ jsx(
  ContextMenuPrimitive.Label,
  {
    ref,
    className: `${cn(
      "relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 uppercase outline-none transition-colors text-xxs",
      inset && "pl-8"
    )} ${className} text-muted`,
    ...props
  }
));
ContextMenuLabel.displayName = ContextMenuPrimitive.ContextMenuLabel.displayName;
const ContextMenuShortcut = ({
  className,
  ...props
}) => {
  return /* @__PURE__ */ jsx(
    "span",
    {
      className: cn("ml-auto text-xs tracking-widest opacity-60", className),
      ...props
    }
  );
};
ContextMenuShortcut.displayName = "ContextMenuShortcut";
const ContextMenuIcon = ({ className, name, ...props }) => {
  return /* @__PURE__ */ jsx(Icon, { name, className: cn("mr-2", className), ...props });
};
ContextMenuIcon.displayName = "ContextMenuIcon";
const ContextMenuSubTrigger = React__default.forwardRef(({ className, inset, children, ...props }, ref) => /* @__PURE__ */ jsxs(
  ContextMenuPrimitive.SubTrigger,
  {
    ref,
    className: cn(
      "flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent data-[state=open]:bg-accent data-[highlighted]:bg-accent",
      inset && "pl-8",
      className
    ),
    ...props,
    children: [
      children,
      /* @__PURE__ */ jsx(ChevronRightIcon, { className: "ml-auto size-4" })
    ]
  }
));
ContextMenuSubTrigger.displayName = ContextMenuPrimitive.SubTrigger.displayName;
const ContextMenuSubContent = React__default.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  ContextMenuPrimitive.Content,
  {
    ref,
    className: cn(
      "z-50 min-w-[15rem] overflow-hidden rounded border p-1 bg-popover text-popover-foreground shadow-md",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      className
    ),
    ...props
  }
));
ContextMenuSubContent.displayName = ContextMenuPrimitive.SubContent.displayName;
const ContextMenuSeparator = React__default.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  ContextMenuPrimitive.Separator,
  {
    ref,
    className: cn("-mx-1 my-1 h-px bg-neutral-gray-5", className),
    ...props
  }
));
ContextMenuSeparator.displayName = ContextMenuPrimitive.Separator.displayName;
const ContextMenuCheckboxItem = React__default.forwardRef(({ className, children, checked, ...props }, ref) => /* @__PURE__ */ jsxs(
  ContextMenuPrimitive.CheckboxItem,
  {
    ref,
    className: cn(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      className
    ),
    checked,
    ...props,
    children: [
      /* @__PURE__ */ jsx("span", { className: "absolute left-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ jsx(ContextMenuPrimitive.ItemIndicator, { children: /* @__PURE__ */ jsx(CheckIcon$1, { className: "size-4" }) }) }),
      children
    ]
  }
));
ContextMenuCheckboxItem.displayName = ContextMenuPrimitive.CheckboxItem.displayName;
const ContextMenuRadioItem = React__default.forwardRef(({ className, children, ...props }, ref) => /* @__PURE__ */ jsxs(
  ContextMenuPrimitive.RadioItem,
  {
    ref,
    className: cn(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      className
    ),
    ...props,
    children: [
      /* @__PURE__ */ jsx("span", { className: "absolute left-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ jsx(ContextMenuPrimitive.ItemIndicator, { children: /* @__PURE__ */ jsx(DotFilledIcon, { className: "size-4 fill-current" }) }) }),
      children
    ]
  }
));
ContextMenuRadioItem.displayName = ContextMenuPrimitive.RadioItem.displayName;
const Drawer = DialogPrimitive.Root;
const DrawerTrigger = DialogPrimitive.Trigger;
const DrawerClose = DialogPrimitive.Close;
const DrawerPortal = DialogPrimitive.Portal;
const DrawerOverlay = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  DialogPrimitive.Overlay,
  {
    className: cn(
      "fixed inset-0 z-50 bg-neutral-gray-alpha-2  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      className
    ),
    ...props,
    ref
  }
));
DrawerOverlay.displayName = DialogPrimitive.Overlay.displayName;
const drawerVariants = cva(
  "fixed z-50 gap-4 bg-background-90 p-6 shadow-lg transition ease-in-out data-[state=closed]:duration-300 data-[state=open]:duration-500 data-[state=open]:animate-in data-[state=closed]:animate-out",
  {
    variants: {
      side: {
        top: "inset-x-0 top-0 border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
        bottom: "inset-x-0 bottom-0 border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
        left: "inset-y-0 left-0 h-full w-96 border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left",
        right: "inset-y-0 right-0 h-full w-96 border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right"
      }
    },
    defaultVariants: {
      side: "right"
    }
  }
);
const DrawerContent = React.forwardRef(
  ({ side = "right", displayOverlay = true, className, children, ...props }, ref) => /* @__PURE__ */ jsxs(DrawerPortal, { container: props == null ? void 0 : props.container, children: [
    displayOverlay && /* @__PURE__ */ jsx(DrawerOverlay, {}),
    /* @__PURE__ */ jsx(
      DialogPrimitive.Content,
      {
        ref,
        className: cn(drawerVariants({ side }), className),
        ...props,
        children
      }
    )
  ] })
);
DrawerContent.displayName = DialogPrimitive.Content.displayName;
const DrawerFooter = ({
  className,
  ...props
}) => /* @__PURE__ */ jsx(
  "div",
  {
    className: cn(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
      className
    ),
    ...props
  }
);
DrawerFooter.displayName = "DrawerFooter";
const DrawerTitle = React.forwardRef(({ className, icon, ...props }, ref) => /* @__PURE__ */ jsx(
  "div",
  {
    ref,
    className: cn("text-lg font-semibold text-foreground", className),
    ...props,
    children: /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2.5", children: [
        icon && /* @__PURE__ */ jsx(Icon, { name: icon, size: 16 }),
        /* @__PURE__ */ jsx(Text$1, { as: "h4", variant: "title3", emphasized: true, children: props.children })
      ] }),
      /* @__PURE__ */ jsxs(
        DialogPrimitive.Close,
        {
          ref: null,
          className: "rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-secondary",
          children: [
            /* @__PURE__ */ jsx(Icon, { name: "cross-large", size: 20 }),
            /* @__PURE__ */ jsx("span", { className: "sr-only", children: "Close" })
          ]
        }
      )
    ] })
  }
));
DrawerTitle.displayName = DialogPrimitive.Title.displayName;
const DrawerToggle = ({
  className,
  onClick,
  side,
  isOpen,
  tooltip
}) => {
  const tooltipSide = side === "left" && isOpen || side === "right" && !isOpen ? "left" : "right";
  const button = /* @__PURE__ */ jsxs(
    "button",
    {
      className: cn(
        "width-[18px] height-[18px] relative group block hover:bg-accent rounded-xs",
        className
      ),
      onClick,
      "data-testid": "drawer-toggle",
      children: [
        /* @__PURE__ */ jsxs(
          "svg",
          {
            className: cn("hidden group-hover:block", {
              "-scale-x-100": side === "left" && isOpen || side === "right" && !isOpen
            }),
            xmlns: "http://www.w3.org/2000/svg",
            width: "18",
            height: "18",
            viewBox: "0 0 18 18",
            fill: "none",
            children: [
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M4 5C4 4.44772 4.44772 4 5 4H13C13.5523 4 14 4.44772 14 5V13C14 13.5523 13.5523 14 13 14H5C4.44772 14 4 13.5523 4 13V5Z",
                  stroke: "currentColor"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M9.26937 12.0815L12.2418 9.04077L9.26937 5.99998L8.55861 6.7271L10.3177 8.52662L5.5 8.52662L5.5 9.55492L10.3176 9.55492L8.55861 11.3544L9.26937 12.0815Z",
                  fill: "currentColor"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsxs(
          "svg",
          {
            className: cn("group-hover:hidden", {
              "-scale-x-100": side === "left" && isOpen || side === "right" && !isOpen
            }),
            xmlns: "http://www.w3.org/2000/svg",
            width: "18",
            height: "18",
            viewBox: "0 0 18 18",
            fill: "none",
            children: [
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M4 5C4 4.44772 4.44772 4 5 4H13C13.5523 4 14 4.44772 14 5V13C14 13.5523 13.5523 14 13 14H5C4.44772 14 4 13.5523 4 13V5Z",
                  stroke: "currentColor"
                }
              ),
              /* @__PURE__ */ jsx("path", { d: "M5.25 5.25H6.25V12.75H5.25V5.25Z", fill: "currentColor" })
            ]
          }
        )
      ]
    }
  );
  if (tooltip) {
    return /* @__PURE__ */ jsxs(Tooltip, { children: [
      /* @__PURE__ */ jsx(TooltipTrigger, { asChild: true, children: button }),
      /* @__PURE__ */ jsx(
        TooltipContent,
        {
          className: "flex items-center px-2 py-1",
          side: tooltipSide,
          children: /* @__PURE__ */ jsx(Text$1, { variant: "body", className: "text-sm", children: tooltip })
        }
      )
    ] });
  }
  return button;
};
const sizes = {
  small: "h-7 text-12 px-3",
  medium: "text-14 h-8 px-2.5 py-2",
  large: "text-14 h-10 px-3"
};
const styles = {
  default: "border-input",
  ghost: "border-none shadow-none p-0"
};
const inputVariants = cva(
  "flex w-full rounded border bg-transparent shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:border-muted-50 disabled:bg-muted-50",
  {
    variants: {
      size: sizes,
      variant: styles
    },
    defaultVariants: {
      size: "medium"
    }
  }
);
const Input = React.forwardRef(
  ({ className, type, hasError, hasWarning, size, variant, ...props }, ref) => {
    return /* @__PURE__ */ jsx(
      "input",
      {
        type,
        className: cn(
          inputVariants({
            size,
            variant
          }),
          {
            "border-destructive-80": hasError,
            // TODO(ralph): Followup with design on this non-standard color
            "border-[#BF8700]": hasWarning
          },
          className
        ),
        ref,
        ...props
      }
    );
  }
);
Input.displayName = "Input";
const labelVariants = cva(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
);
const Label = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  LabelPrimitive.Root,
  {
    ref,
    className: cn(labelVariants(), className),
    ...props
  }
));
Label.displayName = LabelPrimitive.Root.displayName;
const PaginationContext = React.createContext({
  size: "md",
  iconOnly: false
});
const Pagination = ({
  className,
  size = "md",
  iconOnly = false,
  ...props
}) => /* @__PURE__ */ jsx(PaginationContext.Provider, { value: { size, iconOnly }, children: /* @__PURE__ */ jsx(
  "nav",
  {
    role: "navigation",
    "data-testid": "pagination",
    "aria-label": "pagination",
    className: cn("mx-auto flex w-full justify-center", className),
    ...props
  }
) });
Pagination.displayName = "Pagination";
const PaginationContent = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  "ul",
  {
    ref,
    className: cn("flex flex-row items-center gap-1", className),
    ...props
  }
));
PaginationContent.displayName = "PaginationContent";
const PaginationItem = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx("li", { ref, className, ...props }));
PaginationItem.displayName = "PaginationItem";
const PaginationLink = ({
  className,
  isActive,
  size: itemSize,
  ...props
}) => {
  const { size: contextSize } = React.useContext(PaginationContext);
  const buttonSize = itemSize ?? (contextSize === "sm" ? "sm" : "icon-md");
  return /* @__PURE__ */ jsx(
    Button,
    {
      "aria-current": isActive ? "page" : void 0,
      variant: isActive ? "outline" : "ghost",
      size: buttonSize,
      className: cn(contextSize === "sm" && "text-sm", className),
      ...props
    }
  );
};
PaginationLink.displayName = "PaginationLink";
const PaginationPrevious = ({
  className,
  iconOnly: itemIconOnly,
  size: itemSize,
  ...props
}) => {
  const { size: contextSize, iconOnly: contextIconOnly } = React.useContext(PaginationContext);
  const size = itemSize ?? contextSize ?? "md";
  const iconOnly = itemIconOnly ?? contextIconOnly ?? false;
  return /* @__PURE__ */ jsxs(
    PaginationLink,
    {
      "aria-label": "Go to previous page",
      size: iconOnly ? size === "sm" ? "icon-sm" : "icon-md" : size,
      className: cn(
        iconOnly ? "" : "gap-1 pl-2.5",
        size === "sm" && !iconOnly && "text-sm",
        className
      ),
      ...props,
      children: [
        /* @__PURE__ */ jsx(Icon, { name: "chevron-left", size: size === "sm" ? 12 : 16 }),
        !iconOnly && /* @__PURE__ */ jsx("span", { children: "Previous" })
      ]
    }
  );
};
PaginationPrevious.displayName = "PaginationPrevious";
const PaginationNext = ({
  className,
  iconOnly: itemIconOnly,
  size: itemSize,
  ...props
}) => {
  const { size: contextSize, iconOnly: contextIconOnly } = React.useContext(PaginationContext);
  const size = itemSize ?? contextSize ?? "md";
  const iconOnly = itemIconOnly ?? contextIconOnly ?? false;
  return /* @__PURE__ */ jsxs(
    PaginationLink,
    {
      "aria-label": "Go to next page",
      size: iconOnly ? size === "sm" ? "icon-sm" : "icon-md" : size,
      className: cn(
        iconOnly ? "" : "gap-1 pr-2.5",
        size === "sm" && !iconOnly && "text-sm",
        className
      ),
      ...props,
      children: [
        !iconOnly && /* @__PURE__ */ jsx("span", { children: "Next" }),
        /* @__PURE__ */ jsx(Icon, { name: "chevron-right", size: size === "sm" ? 12 : 16 })
      ]
    }
  );
};
PaginationNext.displayName = "PaginationNext";
const PaginationEllipsis = ({
  className,
  ...props
}) => {
  const { size } = React.useContext(PaginationContext);
  return /* @__PURE__ */ jsxs(
    "span",
    {
      "aria-hidden": true,
      className: cn(
        "flex h-9 w-9 items-center justify-center",
        size === "sm" && "h-8 w-8",
        className
      ),
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          DotsHorizontalIcon,
          {
            className: cn("size-4", size === "sm" && "size-3.5")
          }
        ),
        /* @__PURE__ */ jsx("span", { className: "sr-only", children: "More pages" })
      ]
    }
  );
};
PaginationEllipsis.displayName = "PaginationEllipsis";
const RadioGroup = React.forwardRef(({ className, ...props }, ref) => {
  return /* @__PURE__ */ jsx(
    RadioGroupPrimitive.Root,
    {
      className: cn("grid gap-2", className),
      ...props,
      ref
    }
  );
});
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;
const RadioGroupItem = React.forwardRef(({ className, ...props }, ref) => {
  return /* @__PURE__ */ jsx(
    RadioGroupPrimitive.Item,
    {
      ref,
      className: cn(
        "font-sans aspect-square h-4 w-4 rounded-full border border-primary text-primary shadow focus:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
        className
      ),
      ...props,
      children: /* @__PURE__ */ jsx(RadioGroupPrimitive.Indicator, { className: "flex items-center justify-center", children: /* @__PURE__ */ jsx("div", { className: "size-2.5 shrink-0 rounded-full bg-primary" }) })
    }
  );
});
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;
const Switch = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  SwitchPrimitives.Root,
  {
    className: cn(
      "peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input",
      className
    ),
    ...props,
    ref,
    children: /* @__PURE__ */ jsx(
      SwitchPrimitives.Thumb,
      {
        className: cn(
          "pointer-events-none block h-4 w-4 rounded-full bg-white-opacity-1 shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0"
        )
      }
    )
  }
));
Switch.displayName = SwitchPrimitives.Root.displayName;
const Table = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx("div", { className: cn("relative w-full overflow-auto", className), children: /* @__PURE__ */ jsx(
  "table",
  {
    ref,
    className: cn("w-full caption-bottom text-sm", className),
    ...props
  }
) }));
Table.displayName = "Table";
const TableHeader = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  "thead",
  {
    ref,
    className: cn("group [&_tr]:border-b", className),
    ...props
  }
));
TableHeader.displayName = "TableHeader";
const TableBody = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  "tbody",
  {
    ref,
    className: cn("[&_tr:last-child]:border-0", className),
    ...props
  }
));
TableBody.displayName = "TableBody";
const TableFooter = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  "tfoot",
  {
    ref,
    className: cn(
      "border-t hover:bg-muted-50 font-medium [&>tr]:last:border-b-0",
      className
    ),
    ...props
  }
));
TableFooter.displayName = "TableFooter";
const TableRow = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  "tr",
  {
    ref,
    className: cn(
      "border-b transition-colors group-hover:bg-transparent hover:bg-muted-50 data-[state=selected]:bg-muted",
      className
    ),
    ...props
  }
));
TableRow.displayName = "TableRow";
const TableHead = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  "th",
  {
    ref,
    className: cn(
      "h-10 px-2 text-left align-middle font-medium text-muted-foreground [&>[role=checkbox]]:translate-y-0.5",
      className
    ),
    ...props
  }
));
TableHead.displayName = "TableHead";
const TableCell = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  "td",
  {
    ref,
    className: cn(
      "p-2 align-middle [&>[role=checkbox]]:translate-y-0.5",
      className
    ),
    ...props
  }
));
TableCell.displayName = "TableCell";
const TableCaption = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  "caption",
  {
    ref,
    className: cn("mt-4 text-sm text-muted-foreground", className),
    ...props
  }
));
TableCaption.displayName = "TableCaption";
const TextArea = React.forwardRef(
  ({ className, hasError, hasWarning, disableResize = false, ...props }, ref) => {
    return /* @__PURE__ */ jsx(
      "textarea",
      {
        className: cn(
          "border-input file:text-foreground placeholder:text-muted-foreground placeholder:text-base focus-visible:ring-ring disabled:bg-muted-50 disabled:border-muted-50 flex w-full rounded border bg-transparent shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none focus-visible:ring-1 disabled:cursor-not-allowed px-2.5 py-2",
          {
            "border-destructive-80": hasError,
            // TODO(ralph): Followup with design on this non-standard color
            "border-[#BF8700]": hasWarning,
            "resize-none": disableResize
          },
          className
        ),
        ref,
        ...props
      }
    );
  }
);
TextArea.displayName = "Textarea";
const Tabs = TabsPrimitive.Root;
const TabsList = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  TabsPrimitive.List,
  {
    ref,
    className: cn(
      "inline-flex h-7 p-0.5 items-center justify-center rounded-lg bg-muted-40 text-muted-foreground",
      className
    ),
    ...props
  }
));
TabsList.displayName = TabsPrimitive.List.displayName;
const TabsTrigger = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  TabsPrimitive.Trigger,
  {
    ref,
    className: cn(
      "inline-flex items-center justify-center grow min-h-6 whitespace-nowrap  rounded-xs px-2 py-1 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-primary-foreground-100 data-[state=active]:text-foreground data-[state=active]:shadow",
      className
    ),
    ...props
  }
));
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;
const TabsContent = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  TabsPrimitive.Content,
  {
    ref,
    className: cn(
      "mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      className
    ),
    ...props
  }
));
TabsContent.displayName = TabsPrimitive.Content.displayName;
const magnitudes = ["k", "m", "b", "t"];
const roundToFirstDecimal = (int) => {
  return Math.round(int * 10) / 10;
};
const roundToCharacterLimit = (int, order) => {
  const rounded = roundToFirstDecimal(int);
  const roundedString = rounded.toString();
  const initCharacters = int.toString().split(".");
  const magnitude = magnitudes[order];
  if (roundedString.length > 3) {
    const twiceRounded = Math.round(rounded);
    const twiceRoundedString = twiceRounded.toString();
    if (twiceRoundedString.length === initCharacters[0].length) {
      return twiceRoundedString + magnitude;
    } else {
      return twiceRounded / 1e3 + magnitudes[order + 1];
    }
  }
  return roundedString + magnitude;
};
const formatNumber = (int) => {
  if (int >= 1e9) {
    return roundToCharacterLimit(int / 1e9, 2);
  }
  if (int >= 1e6) {
    return roundToCharacterLimit(int / 1e6, 1);
  }
  if (int >= 1e3) {
    return roundToCharacterLimit(int / 1e3, 0);
  }
  return int.toString();
};
function FilterValidationTabs({
  filteredCounts,
  totalCounts,
  isLoading,
  disabled,
  onTabChange,
  activeTab
}) {
  var _a;
  const countData = useMemo(() => {
    if (activeTab === "error") {
      return { count: filteredCounts == null ? void 0 : filteredCounts.error, label: "Invalid" };
    }
    if (activeTab === "valid") {
      return { count: filteredCounts == null ? void 0 : filteredCounts.valid, label: "Valid" };
    }
    return { count: filteredCounts == null ? void 0 : filteredCounts.total, label: "Records" };
  }, [filteredCounts, activeTab]);
  return /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
    /* @__PURE__ */ jsx("div", { className: "flex items-center gap-1", children: /* @__PURE__ */ jsx("div", { className: "relative flex items-center justify-center gap-1", children: isLoading ? /* @__PURE__ */ jsx(Spinner, { size: 12 }) : /* @__PURE__ */ jsxs(Fragment$1, { children: [
      /* @__PURE__ */ jsx(
        Text$1,
        {
          className: "animate-in fade-in",
          color: (countData == null ? void 0 : countData.label) === "errors" && (countData == null ? void 0 : countData.count) > 0 ? "destructive" : "muted-foreground-80",
          variant: "subheadline",
          children: ((_a = countData == null ? void 0 : countData.count) == null ? void 0 : _a.toLocaleString()) ?? 0
        }
      ),
      /* @__PURE__ */ jsx(
        Text$1,
        {
          color: (countData == null ? void 0 : countData.label) === "errors" ? "destructive" : "muted-foreground-80",
          className: "text-xs",
          variant: "subheadline",
          children: countData == null ? void 0 : countData.label
        }
      )
    ] }) }) }),
    totalCounts && /* @__PURE__ */ jsx(
      TabsComponent,
      {
        disabled,
        filteredCounts,
        onTabChange,
        isLoading,
        activeTab
      }
    )
  ] });
}
const TabsComponent = ({
  filteredCounts,
  onTabChange,
  isLoading,
  disabled,
  activeTab
}) => {
  const handleTabChange = (value) => {
    onTabChange == null ? void 0 : onTabChange(value);
  };
  return /* @__PURE__ */ jsx(
    Tabs,
    {
      value: activeTab ?? "none",
      onValueChange: handleTabChange,
      className: cn("w-fit bg-accent rounded-sm"),
      children: /* @__PURE__ */ jsxs(TabsList, { children: [
        /* @__PURE__ */ jsx(TabsTrigger, { className: "w-24", value: "none", disabled, children: /* @__PURE__ */ jsx(
          TabWithoutCount,
          {
            label: "All",
            isLoading,
            active: activeTab === "none"
          }
        ) }),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: cn(
              "w-[1px] h-4 bg-accent opacity-0 transition-opacity duration-300",
              {
                "opacity-100": activeTab === "error"
              }
            )
          }
        ),
        /* @__PURE__ */ jsx(TabsTrigger, { className: "w-24", value: "valid", disabled, children: (filteredCounts == null ? void 0 : filteredCounts.valid) > 0 ? /* @__PURE__ */ jsx(
          TabWithCount,
          {
            label: "Valid",
            isLoading,
            color: "primary",
            count: filteredCounts == null ? void 0 : filteredCounts.valid
          }
        ) : /* @__PURE__ */ jsx(
          TabWithoutCount,
          {
            label: "Valid",
            isLoading,
            color: "primary"
          }
        ) }),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: cn(
              "w-[1px] h-4 bg-accent opacity-0 transition-opacity duration-300",
              {
                "opacity-100": activeTab === "none"
              }
            )
          }
        ),
        /* @__PURE__ */ jsx(TabsTrigger, { className: "w-24", value: "error", disabled, children: (filteredCounts == null ? void 0 : filteredCounts.error) > 0 ? /* @__PURE__ */ jsx(
          TabWithCount,
          {
            label: "Invalid",
            isLoading,
            color: "destructive",
            active: activeTab === "error",
            count: filteredCounts == null ? void 0 : filteredCounts.error
          }
        ) : /* @__PURE__ */ jsx(
          TabWithoutCount,
          {
            label: "Invalid",
            isLoading,
            color: "primary"
          }
        ) })
      ] })
    }
  );
};
const TabWithCount = ({
  label,
  count: count2,
  isLoading,
  color,
  active
}) => {
  const badgeBgColor = color === "destructive" ? "bg-destructive-30" : "bg-accent-90";
  return /* @__PURE__ */ jsxs("div", { className: "relative flex items-center gap-1", children: [
    /* @__PURE__ */ jsx(Text$1, { emphasized: active, color, children: label }),
    /* @__PURE__ */ jsxs("div", { className: "relative flex h-[15px] items-center justify-start", children: [
      /* @__PURE__ */ jsx(
        "div",
        {
          className: cn(
            "absolute w-full inset-0 flex items-center justify-center transition-opacity duration-300",
            isLoading ? "opacity-100" : "opacity-0"
          ),
          children: /* @__PURE__ */ jsx(Spinner, { size: 12 })
        }
      ),
      /* @__PURE__ */ jsx(
        "div",
        {
          className: cn(
            "flex items-center justify-center transition-opacity duration-300",
            isLoading ? "opacity-0" : "opacity-100"
          ),
          children: /* @__PURE__ */ jsx(
            Badge,
            {
              className: cn(
                "text-xxs min-w-4 items-center flex h-4 px-1 justify-center shadow-none",
                badgeBgColor
              ),
              radius: "full",
              children: /* @__PURE__ */ jsx(Text$1, { variant: "caption1", color, children: count2 > 0 ? formatNumber(count2) : "0" })
            }
          )
        }
      )
    ] })
  ] });
};
const TabWithoutCount = ({
  label,
  isLoading,
  color,
  active
}) => {
  return /* @__PURE__ */ jsxs("div", { className: "relative flex h-[15px] items-center justify-center px-3", children: [
    /* @__PURE__ */ jsx(
      Text$1,
      {
        emphasized: active,
        color,
        className: cn(
          "absolute inset-0 flex items-center justify-center transition-opacity duration-300",
          isLoading ? "opacity-0" : "opacity-100"
        ),
        children: label
      }
    ),
    /* @__PURE__ */ jsx(
      "div",
      {
        className: cn(
          "absolute inset-0 flex items-center justify-center transition-opacity duration-300",
          isLoading ? "opacity-100" : "opacity-0"
        ),
        children: /* @__PURE__ */ jsx(Spinner, { size: 12 })
      }
    )
  ] });
};
function FieldFilterDropdown({
  children,
  disabled,
  onOpenChange,
  onFieldSelected,
  options,
  footerActions
}) {
  const [open, setOpen] = useState(false);
  const handleOpenChange = (open2) => {
    setOpen(open2);
    onOpenChange == null ? void 0 : onOpenChange(open2);
  };
  const handleSelect = (key) => {
    onFieldSelected(key);
    setOpen(false);
  };
  const handleSecondaryAction = (e, option) => {
    if (!option.secondaryAction) return;
    e.stopPropagation();
    option.secondaryAction.onClick(option.key);
  };
  return /* @__PURE__ */ jsxs(Popover, { open, onOpenChange: handleOpenChange, children: [
    /* @__PURE__ */ jsx(PopoverTrigger, { disabled, asChild: true, children }),
    /* @__PURE__ */ jsx(PopoverContent, { className: "min-w-80 p-0", align: "start", children: /* @__PURE__ */ jsxs(Command, { className: "flex flex-col", children: [
      /* @__PURE__ */ jsx(CommandInput, { placeholder: "Search...", className: "h-9" }),
      /* @__PURE__ */ jsxs(CommandList, { className: "flex-1 overflow-y-auto", children: [
        /* @__PURE__ */ jsx(CommandEmpty, { children: "No results found." }),
        options.map((group, index) => /* @__PURE__ */ jsxs(React__default.Fragment, { children: [
          /* @__PURE__ */ jsx(CommandGroup, { heading: group.label, children: group.options.map((option) => /* @__PURE__ */ jsx(
            CommandItem,
            {
              value: option.key,
              onSelect: () => handleSelect(option.key),
              className: "cursor-pointer",
              children: /* @__PURE__ */ jsx(
                OptionItem,
                {
                  option,
                  onClick: handleSecondaryAction
                }
              )
            },
            option.key
          )) }),
          index < options.length - 1 && /* @__PURE__ */ jsx(CommandSeparator, {})
        ] }, group.label))
      ] }),
      footerActions && /* @__PURE__ */ jsx(
        FilterFooterActions,
        {
          footerActions,
          setOpen
        }
      )
    ] }) })
  ] });
}
const OptionItem = ({
  option,
  onClick
}) => {
  const btnRef = useRef(null);
  return /* @__PURE__ */ jsxs("div", { className: "flex w-full items-center justify-between", children: [
    /* @__PURE__ */ jsx(Text$1, { children: option.label }),
    option.badge && /* @__PURE__ */ jsx(
      Badge,
      {
        className: "max-h-4 rounded-full px-1.5",
        variant: option.badge.variant,
        children: option.badge.label
      }
    ),
    option.secondaryAction && /* @__PURE__ */ jsxs(Tooltip, { children: [
      /* @__PURE__ */ jsx(TooltipTrigger, { asChild: true, children: /* @__PURE__ */ jsx(
        Button,
        {
          variant: "ghost",
          size: "icon-sm",
          onClick: (e) => onClick(e, option),
          ref: btnRef,
          icon: option.secondaryAction.icon
        }
      ) }),
      option.secondaryAction.tooltip && /* @__PURE__ */ jsx(TooltipContent, { side: "right", className: "z-1200", children: /* @__PURE__ */ jsx(Text$1, { color: "base-white", variant: "subheadline", children: option.secondaryAction.tooltip }) })
    ] })
  ] });
};
const FilterFooterActions = ({
  footerActions,
  setOpen
}) => {
  return /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsx("div", { className: "px-2", children: /* @__PURE__ */ jsx(Separator, {}) }),
    /* @__PURE__ */ jsx("ul", { className: "flex flex-col p-1", children: footerActions.map((action, index) => /* @__PURE__ */ jsxs(
      "li",
      {
        className: "flex cursor-pointer items-center gap-2 p-2",
        onClick: () => {
          action.onClick();
          setOpen(false);
        },
        role: "menuitem",
        children: [
          /* @__PURE__ */ jsx(Icon, { name: action.icon, size: 16, color: "muted" }),
          /* @__PURE__ */ jsx(Text$1, { children: action.label })
        ]
      },
      index
    )) })
  ] });
};
const FilterFieldElement = ({
  query,
  truncate = false
}) => {
  const truncateClass = truncate ? "max-w-16 truncate" : "";
  return /* @__PURE__ */ jsx("div", { className: "flex items-center gap-2 rounded-l-xs bg-primary-10 py-1 pl-2 pr-1.5", children: /* @__PURE__ */ jsx(Text$1, { variant: "callout", className: truncateClass, children: query.queryField }) });
};
const getOptionByKey = (groups, key) => {
  if (!groups || groups.length === 0) return void 0;
  for (const group of groups) {
    if (!group.options) continue;
    const option = group.options.find((opt) => (opt == null ? void 0 : opt.key) === key);
    if (option) return option;
  }
  return void 0;
};
const FilterOperationElement = ({
  query,
  options,
  interactive,
  onUpdateQueryOperation,
  onOperationOpenChange,
  truncate = false
}) => {
  const [isOpen, setIsOpen] = React__default.useState(false);
  const selectedOperation = useMemo(
    () => getOptionByKey(options, query.queryOperation),
    [options, query.queryOperation]
  );
  const handleOptionSelect = (key) => {
    onUpdateQueryOperation(key);
    onOperationOpenChange == null ? void 0 : onOperationOpenChange(false);
    setIsOpen(false);
  };
  const handleOperationOpen = (change) => {
    setIsOpen(change);
    onOperationOpenChange == null ? void 0 : onOperationOpenChange(change);
  };
  return /* @__PURE__ */ jsx(Fragment$1, { children: interactive ? /* @__PURE__ */ jsxs(Popover, { open: isOpen, onOpenChange: handleOperationOpen, children: [
    /* @__PURE__ */ jsx(PopoverTrigger, { asChild: true, children: /* @__PURE__ */ jsxs("button", { className: "flex items-center gap-0.5 bg-primary-10 px-1.5 py-1", children: [
      /* @__PURE__ */ jsx(
        Text$1,
        {
          variant: "callout",
          color: "muted",
          className: cn({ "block max-w-12 truncate": truncate }),
          children: selectedOperation == null ? void 0 : selectedOperation.label
        }
      ),
      /* @__PURE__ */ jsx(Icon, { size: 12, color: "muted", name: "chevron-down-small" })
    ] }) }),
    /* @__PURE__ */ jsx(PopoverContent, { className: "mt-2 w-32 p-0", align: "start", children: /* @__PURE__ */ jsx("div", { className: "flex flex-col", children: options.map((group, index) => /* @__PURE__ */ jsxs(React__default.Fragment, { children: [
      (group == null ? void 0 : group.label) && /* @__PURE__ */ jsx("div", { className: "px-2 py-1.5 text-xs font-medium text-muted-foreground", children: group == null ? void 0 : group.label }),
      /* @__PURE__ */ jsx("ul", { children: (Array.isArray(group == null ? void 0 : group.options) ? group.options : []).map(
        (option, opIndex) => /* @__PURE__ */ jsx(
          "li",
          {
            onClick: () => handleOptionSelect(option == null ? void 0 : option.key),
            className: "hover:text-accent-foreground flex cursor-pointer whitespace-nowrap px-2 py-1.5 text-sm hover:bg-accent",
            role: "option",
            tabIndex: 0,
            children: /* @__PURE__ */ jsx(Text$1, { children: option == null ? void 0 : option.label })
          },
          opIndex
        )
      ) }),
      index < options.length - 1 && /* @__PURE__ */ jsx("hr", { className: "m-1 border-border" })
    ] }, index)) }) })
  ] }) : /* @__PURE__ */ jsx(
    Text$1,
    {
      className: cn("bg-primary-10 flex items-center gap-1 px-1.5 py-1", {
        "block max-w-12 truncate": truncate
      }),
      color: "muted",
      variant: "callout",
      children: /* @__PURE__ */ jsx("span", { className: cn({ "block max-w-12 truncate": truncate }), children: selectedOperation == null ? void 0 : selectedOperation.label })
    }
  ) });
};
const FilterValueDisplayElement = ({
  query
}) => {
  var _a;
  return /* @__PURE__ */ jsx(Fragment$1, { children: ((_a = query.queryValues) == null ? void 0 : _a.length) > 0 && /* @__PURE__ */ jsx("div", { className: "flex items-center gap-2 rounded-r-sm bg-primary-10 px-1.5 py-1", children: /* @__PURE__ */ jsx("div", { className: "flex items-center", children: query.queryValues.length === 1 ? /* @__PURE__ */ jsx(
    Text$1,
    {
      variant: "callout",
      color: "muted",
      className: "block max-w-[150px] truncate",
      children: query.queryValues[0]
    }
  ) : /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsx(
      Text$1,
      {
        variant: "callout",
        color: "muted",
        className: "block max-w-[100px] truncate",
        children: query.queryValues[0]
      }
    ),
    /* @__PURE__ */ jsx(
      Text$1,
      {
        variant: "callout",
        color: "muted",
        className: "ml-1 whitespace-nowrap",
        children: ` +${query.queryValues.length - 1} more`
      }
    )
  ] }) }) }) });
};
const MultiSelectContent = ({
  query,
  valueOptions,
  operationOptions,
  searchValue,
  onOpenOperation,
  onSearchValueChange,
  onUpdateQueryValue,
  onUpdateQueryOperation,
  isLoadingOptions,
  activeIndex,
  setActiveIndex,
  handleClearInput
}) => {
  var _a;
  const totalCount = valueOptions.length;
  const handleOptionHover = useCallback(
    (index) => setActiveIndex(index),
    [setActiveIndex]
  );
  const onOptionChange = useCallback(
    (value, checked) => {
      const currentValues = query.queryValues || [];
      if (checked) {
        onUpdateQueryValue([...currentValues, value]);
      } else {
        onUpdateQueryValue(currentValues.filter((v) => v !== value));
      }
    },
    [query.queryValues, onUpdateQueryValue]
  );
  const valuesByline = useMemo(() => {
    if (isLoadingOptions) {
      return /* @__PURE__ */ jsx(Spinner, { size: 16 });
    }
    if (valueOptions.length === 0) {
      return /* @__PURE__ */ jsx(Text$1, { className: "text-muted-80", children: "No values found" });
    }
    return /* @__PURE__ */ jsxs(Text$1, { className: "text-muted-80", children: [
      "Showing ",
      totalCount,
      " option",
      valueOptions.length === 1 ? "" : "s"
    ] });
  }, [valueOptions, isLoadingOptions, totalCount]);
  const unselectedOptions = useMemo(
    () => valueOptions.filter((value) => {
      var _a2;
      return !((_a2 = query.queryValues) == null ? void 0 : _a2.includes(value.key));
    }),
    [valueOptions, query.queryValues]
  );
  return /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsxs("div", { className: "flex h-9 items-center border-b px-1", children: [
      /* @__PURE__ */ jsx(
        "input",
        {
          className: "grow bg-transparent pl-2 text-[13px] leading-9 outline-none",
          type: "text",
          placeholder: "Search...",
          onChange: onSearchValueChange,
          value: searchValue ?? ""
        }
      ),
      /* @__PURE__ */ jsx(
        "button",
        {
          className: "h-full border-0 bg-transparent px-2 text-muted-80 hover:text-foreground",
          onClick: handleClearInput,
          children: /* @__PURE__ */ jsx(Icon, { name: "cross-small" })
        }
      )
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "flex items-center p-2", children: [
      /* @__PURE__ */ jsx(FilterFieldElement, { query, truncate: true }),
      /* @__PURE__ */ jsx(
        FilterOperationElement,
        {
          query,
          options: operationOptions,
          onUpdateQueryOperation,
          onOperationOpenChange: onOpenOperation,
          interactive: true,
          truncate: true
        }
      ),
      /* @__PURE__ */ jsx(FilterValueDisplayElement, { query })
    ] }),
    /* @__PURE__ */ jsx("div", { className: "px-2", children: /* @__PURE__ */ jsx(Separator, {}) }),
    ((_a = query.queryValues) == null ? void 0 : _a.length) > 0 && /* @__PURE__ */ jsx("div", { className: "flex max-h-36 flex-col overflow-y-auto p-1", children: query.queryValues.map((value, index) => /* @__PURE__ */ jsxs(
      Text$1,
      {
        as: "label",
        onMouseEnter: () => handleOptionHover(index),
        className: cn(
          "flex items-center gap-2 p-2 text-base rounded-sm",
          {
            "bg-accent": activeIndex === index
          }
        ),
        children: [
          /* @__PURE__ */ jsx(
            Checkbox,
            {
              checked: true,
              value,
              onCheckedChange: () => onOptionChange(value, false)
            }
          ),
          value
        ]
      },
      value
    )) }),
    /* @__PURE__ */ jsxs("div", { className: "flex h-7 items-center justify-between px-3 text-xs text-muted", children: [
      /* @__PURE__ */ jsx(Text$1, { children: "Values" }),
      valuesByline
    ] }),
    unselectedOptions.length > 0 && /* @__PURE__ */ jsxs("div", { className: "flex max-h-36 flex-col overflow-y-auto p-1", children: [
      unselectedOptions.map((value, index) => {
        var _a2;
        return /* @__PURE__ */ jsxs(
          Text$1,
          {
            as: "label",
            onMouseEnter: () => {
              var _a3;
              return handleOptionHover(index + (((_a3 = query.queryValues) == null ? void 0 : _a3.length) || 0));
            },
            className: cn(
              "flex items-center gap-2 p-2 text-base rounded-sm",
              {
                "bg-accent": activeIndex === index + (((_a2 = query.queryValues) == null ? void 0 : _a2.length) || 0)
              }
            ),
            children: [
              /* @__PURE__ */ jsx(
                Checkbox,
                {
                  checked: false,
                  value: value.key,
                  onCheckedChange: () => onOptionChange(value.key, true)
                }
              ),
              value.label
            ]
          },
          value.key
        );
      }),
      isLoadingOptions && /* @__PURE__ */ jsx("div", { className: "flex justify-center py-2", children: /* @__PURE__ */ jsx(Spinner, { size: 16 }) })
    ] })
  ] });
};
const InputContent = ({
  query,
  operationOptions,
  onSubmit,
  onUpdateQueryOperation,
  onOpenOperation
}) => {
  var _a;
  const [inputValue, setInputValue] = React__default.useState(
    ((_a = query.queryValues) == null ? void 0 : _a[0]) || ""
  );
  const inputRef = useRef(null);
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };
  const handleSubmitValue = () => {
    onSubmit(inputValue);
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSubmitValue();
    }
  };
  React__default.useEffect(() => {
    var _a2;
    setInputValue(((_a2 = query.queryValues) == null ? void 0 : _a2[0]) || "");
  }, [query.queryValues]);
  React__default.useEffect(() => {
    const timer = setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 50);
    return () => clearTimeout(timer);
  }, []);
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-2 p-2", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-center", children: [
      /* @__PURE__ */ jsx(FilterFieldElement, { query, truncate: true }),
      /* @__PURE__ */ jsx(
        FilterOperationElement,
        {
          query,
          options: operationOptions,
          onUpdateQueryOperation,
          onOperationOpenChange: onOpenOperation,
          interactive: true,
          truncate: true
        }
      ),
      /* @__PURE__ */ jsx(FilterValueDisplayElement, { query })
    ] }),
    /* @__PURE__ */ jsx("div", { className: "px-2", children: /* @__PURE__ */ jsx(Separator, {}) }),
    /* @__PURE__ */ jsx(
      Input,
      {
        ref: inputRef,
        className: "mt-1 w-full",
        placeholder: "Enter value...",
        value: inputValue,
        onChange: handleInputChange,
        onBlur: handleSubmitValue,
        onKeyDown: handleKeyDown
      }
    )
  ] });
};
const FilterValueElement = ({
  query,
  isActive,
  valueOptions,
  operationOptions,
  onRemoveQuery,
  onUpdateQueryValue,
  onUpdateQueryOperation,
  onQueryValueSelected,
  onQueryDeactivated,
  searchValue,
  onSearchValueChange,
  isLoadingOptions,
  entryMode = "multi-select"
}) => {
  const filterValueRef = useRef(null);
  const [activeIndex, setActiveIndex] = React__default.useState(-1);
  const [operationsOpen, setOperationsOpen] = React__default.useState(false);
  useEffect(() => {
    const handleClickOutside = (event) => {
      var _a;
      if (isActive && !operationsOpen && filterValueRef.current && !filterValueRef.current.contains(event.target)) {
        if (!((_a = query.queryValues) == null ? void 0 : _a.length)) {
          onRemoveQuery(query.id);
        }
        onSearchValueChange("");
        onQueryDeactivated();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [
    isActive,
    onRemoveQuery,
    query.id,
    query.queryValues,
    onQueryDeactivated,
    operationsOpen
  ]);
  const handleInputValueChange = useCallback(
    (value) => {
      onUpdateQueryValue([value]);
      onQueryDeactivated();
      onSearchValueChange("");
    },
    [onUpdateQueryValue, onQueryDeactivated]
  );
  const handleSearchValueChange = useCallback(
    (event) => {
      onSearchValueChange(event.target.value);
    },
    [onSearchValueChange]
  );
  const handleOpenOperation = useCallback((change) => {
    setOperationsOpen(change);
  }, []);
  const handleClearInput = useCallback(() => {
    onSearchValueChange("");
  }, [onSearchValueChange]);
  const renderTriggerContent = () => {
    var _a, _b;
    if (entryMode === "input") {
      return /* @__PURE__ */ jsx(
        Text$1,
        {
          variant: "callout",
          color: "muted",
          className: "block max-w-[100px] truncate",
          children: ((_a = query.queryValues) == null ? void 0 : _a[0]) || "Enter value..."
        }
      );
    } else {
      if (((_b = query.queryValues) == null ? void 0 : _b.length) > 0) {
        if (query.queryValues.length === 1) {
          return /* @__PURE__ */ jsx(
            Text$1,
            {
              variant: "callout",
              color: "muted",
              className: "block max-w-[100px] truncate",
              children: query.queryValues[0]
            }
          );
        } else {
          return /* @__PURE__ */ jsxs("div", { className: "flex items-center", children: [
            /* @__PURE__ */ jsx(
              Text$1,
              {
                variant: "callout",
                color: "muted",
                className: "block max-w-[100px] truncate",
                children: query.queryValues[0]
              }
            ),
            /* @__PURE__ */ jsx(
              Text$1,
              {
                variant: "callout",
                color: "muted",
                className: "whitespace-nowrap",
                children: ` +${query.queryValues.length - 1} more`
              }
            )
          ] });
        }
      }
      return /* @__PURE__ */ jsx(Text$1, { variant: "callout", color: "muted", children: "Select values..." });
    }
  };
  return /* @__PURE__ */ jsxs(Popover, { open: isActive, children: [
    /* @__PURE__ */ jsx(PopoverTrigger, { asChild: true, children: /* @__PURE__ */ jsx(
      "button",
      {
        onClick: onQueryValueSelected,
        className: "flex grow items-center gap-2 bg-primary-10 px-1.5 py-1 outline-none",
        children: renderTriggerContent()
      }
    ) }),
    /* @__PURE__ */ jsx(PopoverContent, { className: "mt-2 w-[336px] p-0", align: "start", children: /* @__PURE__ */ jsx("div", { ref: filterValueRef, className: "flex flex-col", children: entryMode === "input" ? /* @__PURE__ */ jsx(
      InputContent,
      {
        query,
        operationOptions,
        onSubmit: handleInputValueChange,
        onUpdateQueryOperation,
        onOpenOperation: handleOpenOperation
      }
    ) : /* @__PURE__ */ jsx(
      MultiSelectContent,
      {
        query,
        valueOptions,
        operationOptions,
        searchValue,
        onSearchValueChange: handleSearchValueChange,
        onUpdateQueryValue,
        onUpdateQueryOperation,
        isLoadingOptions,
        activeIndex,
        setActiveIndex,
        handleClearInput,
        onOpenOperation: handleOpenOperation
      }
    ) }) })
  ] });
};
const FilterBlock = ({
  query,
  className,
  searchValue,
  isActive,
  operationOptions,
  onQueryUpdate,
  onQueryActivate,
  onRemoveQuery,
  valueOptions,
  onSearchValueChange,
  isLoadingValueOptions
}) => {
  const noValueRequiredOperation = query.queryOperation === "is empty" || query.queryOperation === "not empty" || query.queryOperation === "is error" || query.queryOperation === "is valid";
  const isInputMode = query.queryOperation === "ilike" || query.queryOperation === "gt" || query.queryOperation === "lt";
  const handleDeleteQuery = (e) => {
    e.stopPropagation();
    onRemoveQuery(query.id);
    if (isActive) {
      onQueryActivate(void 0);
    }
  };
  const handleUpdateQueryOperation = (operation) => {
    onQueryUpdate({
      ...query,
      queryOperation: operation
    });
  };
  const handleUpdateQueryValue = (value) => {
    onQueryUpdate({
      ...query,
      queryValues: value
    });
  };
  const handleQueryValueSelected = () => {
    onQueryActivate(query.id);
  };
  const handleQueryDeactivated = () => {
    onQueryActivate(void 0);
  };
  return /* @__PURE__ */ jsxs("div", { className: cn("flex items-center gap-0.5", className), children: [
    /* @__PURE__ */ jsxs(
      "div",
      {
        onClick: handleQueryValueSelected,
        className: "flex cursor-pointer items-center",
        children: [
          /* @__PURE__ */ jsx(FilterFieldElement, { query }),
          /* @__PURE__ */ jsx(
            FilterOperationElement,
            {
              query,
              options: operationOptions,
              onUpdateQueryOperation: handleUpdateQueryOperation,
              interactive: noValueRequiredOperation
            }
          ),
          !noValueRequiredOperation && /* @__PURE__ */ jsx(
            FilterValueElement,
            {
              query,
              isActive,
              valueOptions,
              operationOptions,
              onRemoveQuery,
              onUpdateQueryValue: handleUpdateQueryValue,
              onUpdateQueryOperation: handleUpdateQueryOperation,
              onQueryValueSelected: handleQueryValueSelected,
              onQueryDeactivated: handleQueryDeactivated,
              onSearchValueChange,
              isLoadingOptions: isLoadingValueOptions,
              searchValue,
              entryMode: isInputMode ? "input" : "multi-select"
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsx(
      "button",
      {
        onClick: handleDeleteQuery,
        className: "flex items-center gap-2 rounded-r-xs bg-primary-10 px-1.5 py-[5.5px]",
        children: /* @__PURE__ */ jsx(Icon, { size: 12, name: "cross-small" })
      }
    )
  ] });
};
const reservedValues$1 = ["error", "valid", ""];
const AtomicCollection = ({
  queryCollection,
  searchValue,
  isPending,
  activeQueryId,
  filterOperations,
  valueOptionsList,
  onUpdateCollectionQuery,
  onQueryActivate,
  onCollectionActivate,
  onRemoveCollection,
  onSearchValueChange
}) => {
  const query = queryCollection.queries[0];
  const onRemoveQuery = () => {
    onRemoveCollection(queryCollection.id);
  };
  const handleQueryUpdated = (query2) => {
    if (query2.queryOperation === "is empty" || query2.queryOperation === "not empty") {
      onUpdateCollectionQuery(queryCollection.id, {
        ...query2,
        queryValues: [""]
      });
    } else if (query2.queryOperation === "is error" || query2.queryOperation === "is valid") {
      const value = query2.queryOperation === "is error" ? "error" : "valid";
      onUpdateCollectionQuery(queryCollection.id, {
        ...query2,
        queryValues: [value]
      });
    } else {
      const cleanQueryValues = query2.queryValues.filter(
        (value) => !reservedValues$1.includes(value)
      );
      onUpdateCollectionQuery(queryCollection.id, {
        ...query2,
        queryValues: cleanQueryValues
      });
    }
  };
  const handleQueryActivated = (queryId) => {
    onQueryActivate(queryId);
    onCollectionActivate(queryCollection.id);
  };
  return /* @__PURE__ */ jsx(
    FilterBlock,
    {
      query,
      searchValue,
      isActive: query.id === activeQueryId,
      isLoadingValueOptions: isPending,
      operationOptions: filterOperations,
      valueOptions: valueOptionsList ?? [],
      onQueryUpdate: handleQueryUpdated,
      onQueryActivate: handleQueryActivated,
      onRemoveQuery,
      onSearchValueChange
    },
    query.id
  );
};
const FilterJoinElement = ({
  query,
  isFirst,
  onSelectPrefix
}) => {
  const { joinPrefix } = query;
  const [isOpen, setIsOpen] = React__default.useState(false);
  const joinOptions = [
    { key: "and", label: "and" },
    { key: "or", label: "or" }
  ];
  const handleOptionSelect = (key) => {
    onSelectPrefix(key);
    setIsOpen(false);
  };
  return /* @__PURE__ */ jsx(Fragment$1, { children: isFirst ? /* @__PURE__ */ jsx("div", { className: "rounded-l-sm py-0.5", children: /* @__PURE__ */ jsx(Text$1, { children: "Where" }) }) : /* @__PURE__ */ jsxs(Popover, { open: isOpen, onOpenChange: setIsOpen, children: [
    /* @__PURE__ */ jsx(PopoverTrigger, { asChild: true, children: /* @__PURE__ */ jsx("button", { className: "flex w-10 justify-center gap-1 rounded-sm bg-primary-10 px-2 py-0.5", children: /* @__PURE__ */ jsx(Text$1, { color: "muted", children: joinPrefix }) }) }),
    /* @__PURE__ */ jsx(PopoverContent, { className: "mt-2 w-20 p-0", align: "start", children: /* @__PURE__ */ jsx(Command, { children: /* @__PURE__ */ jsx(CommandList, { children: joinOptions.map((option) => /* @__PURE__ */ jsx(
      "button",
      {
        onClick: () => handleOptionSelect(option.key),
        className: cn(
          "flex w-full items-center px-2 py-1.5 text-sm outline-none hover:bg-accent hover:text-accent-foreground",
          joinPrefix === option.key && "bg-accent text-accent-foreground"
        ),
        children: /* @__PURE__ */ jsx(Text$1, { children: option.label })
      },
      option.key
    )) }) }) })
  ] }) });
};
const reservedValues = ["error", "valid", ""];
const AdvancedCollections = (props) => {
  const {
    searchValue,
    activeQueryId,
    activeCollectionId,
    queryCollection,
    valueOptionsList,
    filterOperations,
    fieldOptionGroups,
    onRemoveCollection,
    onAddCollectionQuery,
    onRemoveQuery,
    onUpdateCollectionQuery,
    onQueryActivate,
    onCollectionActivate,
    onSearchValueChange,
    onUpdateCollection
  } = props;
  const [open, setOpen] = useState(
    () => activeCollectionId === queryCollection.id
  );
  const containerRef = useRef(null);
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 5
      }
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates
    })
  );
  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (over && active.id !== over.id && onUpdateCollection) {
      const oldIndex = queryCollection.queries.findIndex(
        (item) => item.id === active.id
      );
      const newIndex = queryCollection.queries.findIndex(
        (item) => item.id === over.id
      );
      const newQueries = arrayMove(queryCollection.queries, oldIndex, newIndex);
      onUpdateCollection(queryCollection.id, { queries: newQueries });
    }
  };
  const handleDeleteCollection = (e) => {
    e.stopPropagation();
    onRemoveCollection(props.queryCollection.id);
  };
  const handleSelectQueryField = (field) => {
    const newQuery = {
      queryField: field,
      queryOperation: "eq",
      queryValues: [],
      joinPrefix: "and"
    };
    onAddCollectionQuery(props.queryCollection.id, newQuery);
  };
  const handleRemoveQuery = (queryId) => {
    onRemoveQuery(props.queryCollection.id, queryId);
  };
  const handleCollectionActivate = () => {
    onCollectionActivate(queryCollection.id);
  };
  const handleUpdateQuery = (query) => {
    if (query.queryOperation === "is empty" || query.queryOperation === "not empty") {
      onUpdateCollectionQuery(queryCollection.id, {
        ...query,
        queryValues: [""]
      });
    } else if (query.queryOperation === "is error" || query.queryOperation === "is valid") {
      const value = query.queryOperation === "is error" ? "error" : "valid";
      onUpdateCollectionQuery(queryCollection.id, {
        ...query,
        queryValues: [value]
      });
    } else {
      const cleanQueryValues = query.queryValues.filter(
        (value) => !reservedValues.includes(value)
      );
      onUpdateCollectionQuery(queryCollection.id, {
        ...query,
        queryValues: cleanQueryValues
      });
    }
  };
  const handleUpdateQueryPrefix = (queryId, prefix) => {
    const query = queryCollection.queries.find((query2) => query2.id === queryId);
    if (!query) return;
    onUpdateCollectionQuery(queryCollection.id, {
      ...query,
      joinPrefix: prefix
    });
  };
  const handleOpenChange = (open2) => {
    setOpen(open2);
    if (!open2) {
      onCollectionActivate(void 0);
      onQueryActivate(void 0);
    }
  };
  const queryFieldsDisplay = () => {
    const queries = queryCollection.queries;
    const distinctQueryFields = queries.reduce((queryFields, query) => {
      if (!queryFields.includes(query.queryField)) {
        return [...queryFields, query.queryField];
      }
      return queryFields;
    }, []);
    const firstQueryField = distinctQueryFields[0];
    const additionalQueryFields = distinctQueryFields.length - 1;
    if (distinctQueryFields.length === 0) {
      return null;
    } else if (distinctQueryFields.length === 1) {
      return /* @__PURE__ */ jsx(Text$1, { color: "muted-foreground", children: firstQueryField });
    } else {
      return /* @__PURE__ */ jsxs(Text$1, { color: "muted-foreground", children: [
        firstQueryField,
        " +",
        additionalQueryFields
      ] });
    }
  };
  return /* @__PURE__ */ jsxs(Popover, { open, onOpenChange: handleOpenChange, children: [
    /* @__PURE__ */ jsx(PopoverTrigger, { children: /* @__PURE__ */ jsxs("div", { className: "flex shrink-0 items-center gap-0.5", children: [
      /* @__PURE__ */ jsxs(
        "div",
        {
          onClick: handleCollectionActivate,
          className: "flex items-center gap-2 rounded-l-sm bg-primary-10 py-0.5 pl-2 pr-1",
          children: [
            /* @__PURE__ */ jsx(Icon, { name: "settings-slider-three" }),
            /* @__PURE__ */ jsx(Text$1, { children: "Filter" }),
            /* @__PURE__ */ jsx(Text$1, { color: "muted-foreground", children: queryFieldsDisplay() })
          ]
        }
      ),
      /* @__PURE__ */ jsx(
        "div",
        {
          onClick: handleDeleteCollection,
          className: "flex items-center gap-2 rounded-r-sm bg-primary-10 px-1 py-0.5",
          children: /* @__PURE__ */ jsx(Icon, { name: "cross-small" })
        }
      )
    ] }) }),
    /* @__PURE__ */ jsxs(PopoverContent, { className: "mt-2 w-auto min-w-72 p-0", align: "start", children: [
      /* @__PURE__ */ jsxs(
        "div",
        {
          ref: containerRef,
          className: "flex max-h-[300px] flex-col gap-3 overflow-y-auto overflow-x-hidden p-3",
          children: [
            queryCollection.queries.length > 0 && /* @__PURE__ */ jsx(
              DndContext,
              {
                sensors,
                collisionDetection: closestCenter,
                onDragEnd: handleDragEnd,
                modifiers: [restrictToParentElement, restrictToWindowEdges],
                children: /* @__PURE__ */ jsx(
                  SortableContext,
                  {
                    items: queryCollection.queries.map((query) => query.id),
                    strategy: verticalListSortingStrategy,
                    children: queryCollection.queries.map((query, index) => /* @__PURE__ */ jsx(
                      SortableQueryItem,
                      {
                        query,
                        index,
                        activeQueryId,
                        searchValue,
                        valueOptionsList,
                        filterOperations,
                        onQueryUpdate: handleUpdateQuery,
                        onQueryActivate,
                        onRemoveQuery: handleRemoveQuery,
                        onSearchValueChange,
                        onUpdateQueryPrefix: handleUpdateQueryPrefix
                      },
                      query.id
                    ))
                  }
                )
              }
            ),
            /* @__PURE__ */ jsx(
              FieldFilterDropdown,
              {
                onFieldSelected: handleSelectQueryField,
                options: fieldOptionGroups,
                children: /* @__PURE__ */ jsx(
                  Button,
                  {
                    className: "w-full justify-start px-0",
                    variant: "ghost",
                    icon: "plus-small",
                    size: "sm",
                    children: "Add condition"
                  }
                )
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ jsx("div", { className: "flex flex-row gap-2 border-t p-3", children: /* @__PURE__ */ jsx(
        Button,
        {
          className: "w-full justify-start px-0",
          variant: "ghost",
          icon: "trash-can-2",
          size: "sm",
          onClick: handleDeleteCollection,
          children: "Delete Filter"
        }
      ) })
    ] })
  ] });
};
const SortableQueryItem = ({
  query,
  index,
  activeQueryId,
  searchValue,
  valueOptionsList,
  filterOperations,
  onQueryUpdate,
  onQueryActivate,
  onRemoveQuery,
  onSearchValueChange,
  onUpdateQueryPrefix
}) => {
  const {
    attributes,
    listeners: listeners2,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id: query.id });
  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1
  };
  return /* @__PURE__ */ jsxs("div", { ref: setNodeRef, style, className: "flex flex-row gap-2", children: [
    /* @__PURE__ */ jsx(
      FilterJoinElement,
      {
        query,
        isFirst: index === 0,
        onSelectPrefix: (prefix) => onUpdateQueryPrefix(query.id, prefix)
      }
    ),
    /* @__PURE__ */ jsx(
      FilterBlock,
      {
        className: "grow",
        query,
        searchValue,
        isActive: activeQueryId === query.id,
        isLoadingValueOptions: false,
        operationOptions: filterOperations,
        valueOptions: valueOptionsList,
        onQueryUpdate,
        onQueryActivate,
        onRemoveQuery,
        onSearchValueChange
      },
      query.id
    ),
    /* @__PURE__ */ jsx(
      "div",
      {
        ...attributes,
        ...listeners2,
        className: "cursor-grab self-center rounded-sm hover:bg-gray-100 active:cursor-grabbing",
        children: /* @__PURE__ */ jsx(
          Icon,
          {
            name: "dot-grid-2-3",
            className: cn("size-4 text-muted cursor-move", {
              "text-foreground": isDragging
            })
          }
        )
      }
    )
  ] });
};
const FilterCollection = (props) => {
  if (props.queryCollection.type === "atomic") {
    return /* @__PURE__ */ jsx(AtomicCollection, { ...props });
  } else if (props.queryCollection.type === "advanced") {
    return /* @__PURE__ */ jsx(AdvancedCollections, { ...props });
  }
  return null;
};
const SimpleSearchBar = forwardRef(
  ({
    searchTerm,
    onSearchChange,
    className,
    placeholder,
    icon = "magnifying-glass",
    size = "md",
    ...props
  }, ref) => {
    return /* @__PURE__ */ jsxs("div", { className: cn("relative", className), ...props, ref, children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          icon,
          size: size === "sm" ? "sm" : "md",
          variant: "ghost",
          className: "absolute top-1/2 -translate-y-1/2"
        }
      ),
      /* @__PURE__ */ jsx(
        Input,
        {
          placeholder,
          className: cn(
            "w-full border !pl-9",
            size === "sm" ? "text-sm h-8 py-1" : ""
          ),
          value: searchTerm,
          onChange: (e) => onSearchChange(e.target.value)
        }
      ),
      !!searchTerm.length && /* @__PURE__ */ jsx(
        Button,
        {
          onClick: () => onSearchChange(""),
          variant: "ghost",
          size: size === "sm" ? "sm" : "md",
          className: "absolute right-0 top-1/2 -translate-y-1/2",
          children: "×"
        }
      )
    ] });
  }
);
SimpleSearchBar.displayName = "SearchBar";
const isTrayHeader = createComponentDisplayNameFilter("TrayHeader");
const isTrayFooter = createComponentDisplayNameFilter("TrayFooter");
const isTrayTab = createComponentDisplayNameFilter("TrayTab");
const Tray = ({ className, children }) => {
  const childrenArray = Children.toArray(children).flatMap(
    (child) => isValidElement(child) && isFragment(child) ? Children.toArray(child.props.children) : child
  );
  const header = childrenArray.find(isTrayHeader);
  const footer = childrenArray.find(isTrayFooter);
  const tabs = childrenArray.filter(isTrayTab);
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const setActiveTab = useCallback((index) => {
    setActiveTabIndex(index);
  }, []);
  let content;
  if (tabs.length > 0) {
    const names = tabs.map(
      (tab) => tab.props.title
    );
    content = /* @__PURE__ */ jsxs(Fragment$1, { children: [
      /* @__PURE__ */ jsx("div", { className: "flex gap-2 px-5", children: names.map((name, index) => /* @__PURE__ */ jsx(
        "button",
        {
          className: cn("h-7 px-3 rounded-xs", {
            "bg-accent": index === activeTabIndex
          }),
          onClick: () => setActiveTab(index),
          children: /* @__PURE__ */ jsx(Text$1, { variant: "body", emphasized: true, children: name })
        },
        name
      )) }),
      tabs[activeTabIndex]
    ] });
  } else {
    content = childrenArray.filter(
      (child) => !isTrayTab(child) && !isTrayHeader(child) && !isTrayFooter(child)
    );
  }
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: cn(
        "bg-popover w-96 border border-neutral-gray-3 rounded-sm pt-5 flex flex-col gap-4",
        className
      ),
      children: [
        header,
        content,
        footer
      ]
    }
  );
};
const TrayHeader = ({ className, children, onClose }) => /* @__PURE__ */ jsxs("div", { className: cn("px-5 flex items-start", className), children: [
  /* @__PURE__ */ jsx(Text$1, { className: "grow", variant: "title2", children }),
  onClose && /* @__PURE__ */ jsx("button", { type: "button", onClick: onClose, children: /* @__PURE__ */ jsx(Icon, { name: "cross-large", size: 12 }) })
] });
TrayHeader.displayName = "TrayHeader";
const TrayFooter = ({ children, className }) => /* @__PURE__ */ jsx("div", { className: cn("px-5 py-4 border-t border-neutral-gray-3", className), children });
TrayFooter.displayName = "TrayFooter";
const TrayTab = ({ children, className }) => /* @__PURE__ */ jsx("div", { className: cn("px-5", className), children });
TrayTab.displayName = "TrayTab";
const Progress = React.forwardRef(({ className, value, ...props }, ref) => /* @__PURE__ */ jsx(
  ProgressPrimitive.Root,
  {
    ref,
    className: cn(
      "relative h-2 w-full overflow-hidden rounded-full bg-primary/20",
      className
    ),
    ...props,
    children: /* @__PURE__ */ jsx(
      ProgressPrimitive.Indicator,
      {
        className: "size-full flex-1 bg-primary transition-all",
        style: { transform: `translateX(-${100 - value}%)` }
      }
    )
  }
));
Progress.displayName = ProgressPrimitive.Root.displayName;
const useProgressTimer = (durationInSeconds) => {
  const [progress, setProgress] = React.useState(0);
  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress >= 100) {
          clearInterval(timer);
          return 100;
        }
        return oldProgress + 100 / durationInSeconds;
      });
    }, 1e3);
    return () => {
      clearInterval(timer);
    };
  }, [durationInSeconds]);
  return progress;
};
const AutoProgress = React.forwardRef(({ durationInSeconds = 60, ...props }, ref) => {
  const progress = useProgressTimer(durationInSeconds);
  return /* @__PURE__ */ jsx(Progress, { ref, value: progress, ...props });
});
const AutoProgressHairline = React.forwardRef(({ durationInSeconds = 60, className, ...props }, ref) => {
  const progress = useProgressTimer(durationInSeconds);
  return /* @__PURE__ */ jsx(
    "div",
    {
      ref,
      className: cn("h-px bg-primary transition-all", className),
      style: { width: `${progress}%` },
      ...props
    }
  );
});
AutoProgressHairline.displayName = "AutoProgressHairline";
AutoProgress.displayName = "AutoProgress";
const Filter = ({
  buttonText,
  icon,
  filters,
  variant
}) => {
  return /* @__PURE__ */ jsxs(DropdownMenu, { children: [
    /* @__PURE__ */ jsx(DropdownMenuTrigger, { asChild: true, children: /* @__PURE__ */ jsxs(Button, { variant: variant ?? "outline", className: "mr-2 leading-none", children: [
      /* @__PURE__ */ jsx(Icon, { name: icon || "filter-1" }),
      buttonText || "Filter"
    ] }) }),
    /* @__PURE__ */ jsx(DropdownMenuContent, { className: "w-56", children: filters.map((filter, i) => {
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsxs(DropdownMenuGroup, { children: [
          /* @__PURE__ */ jsx(DropdownMenuLabel, { children: filter.label }),
          /* @__PURE__ */ jsx(DropdownMenuSeparator, {}, "separator-1"),
          /* @__PURE__ */ jsx(
            DropdownMenuRadioGroup,
            {
              onValueChange: filter.onSelectFilter,
              value: filter.currentValue,
              children: filter.options.map((option, i2) => {
                return /* @__PURE__ */ jsx(
                  DropdownMenuRadioItem,
                  {
                    value: option.value,
                    children: option.label
                  },
                  `${option.value}-${i2}`
                );
              })
            }
          )
        ] }, `${filter.label}-${i}`),
        i !== filters.length - 1 && /* @__PURE__ */ jsx(DropdownMenuSeparator, {})
      ] }, `${filter.label}-${i}`);
    }) })
  ] });
};
const Accordion = AccordionPrimitive.Root;
const AccordionItem = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  AccordionPrimitive.Item,
  {
    ref,
    className: cn("border-b", className),
    ...props
  }
));
AccordionItem.displayName = "AccordionItem";
const AccordionTrigger = React.forwardRef(
  ({
    className,
    children,
    chevronPosition = "right",
    showChevron = true,
    ...props
  }, ref) => {
    const chevron = showChevron ? /* @__PURE__ */ jsx(ChevronDownIcon, { className: "size-4 shrink-0 text-muted-foreground-80 transition-transform duration-200" }) : null;
    return /* @__PURE__ */ jsx(AccordionPrimitive.Header, { className: "flex overflow-visible", children: /* @__PURE__ */ jsxs(
      AccordionPrimitive.Trigger,
      {
        ref,
        className: cn(
          "AccordionTrigger",
          "flex flex-1 items-center py-4 text-sm font-medium transition-all hover:underline [&[data-state=open]>svg]:rotate-180",
          chevronPosition === "right" ? "justify-between" : "justify-start gap-2",
          className
        ),
        ...props,
        children: [
          chevronPosition === "left" && chevron,
          children,
          chevronPosition === "right" && chevron
        ]
      }
    ) });
  }
);
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName;
const AccordionContent = React.forwardRef(({ className, children, contentClassName, ...props }, ref) => /* @__PURE__ */ jsx(
  AccordionPrimitive.Content,
  {
    ref,
    className: cn(
      "data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down overflow-hidden text-sm",
      contentClassName
    ),
    ...props,
    children: /* @__PURE__ */ jsx("div", { className: cn("pt-0 pb-4", className), children })
  }
));
AccordionContent.displayName = AccordionPrimitive.Content.displayName;
const Collapsible = CollapsiblePrimitive.Root;
const CollapsibleTrigger = React.forwardRef(({ className, children, ...props }, ref) => /* @__PURE__ */ jsx(
  CollapsiblePrimitive.Trigger,
  {
    ref,
    className: cn("flex items-center", className),
    ...props,
    children
  }
));
CollapsibleTrigger.displayName = CollapsiblePrimitive.Trigger.displayName;
const CollapsibleContent = React.forwardRef(({ className, children, ...props }, ref) => /* @__PURE__ */ jsx(
  CollapsiblePrimitive.Content,
  {
    ref,
    className: cn(
      "data-[state=closed]:animate-collapsible-up data-[state=open]:animate-collapsible-down overflow-hidden",
      className
    ),
    ...props,
    children
  }
));
CollapsibleContent.displayName = CollapsiblePrimitive.Content.displayName;
const ProgressBar = ({ statuses, currentStatus }) => {
  const statusIndex = statuses.findIndex(
    (status) => status.key === currentStatus
  );
  const currentStepIndex = statusIndex !== -1 ? statusIndex : 0;
  return /* @__PURE__ */ jsx("div", { className: "flex items-center gap-2", children: statuses.map((status, index) => /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Status,
      {
        label: status.label,
        complete: currentStepIndex > index,
        active: currentStepIndex === index,
        stepNumber: index + 1,
        isLast: index === statuses.length - 1
      }
    ),
    index < statuses.length - 1 && /* @__PURE__ */ jsx(ChevronRightIcon, {})
  ] }, status.key)) });
};
const Status = ({
  label,
  complete,
  active,
  stepNumber,
  isLast
}) => {
  const getTextColor = () => {
    if (complete) return "green-9";
    if (active && isLast) return "green-9";
    if (active) return "primary";
    return "muted-foreground-100";
  };
  return /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
    /* @__PURE__ */ jsx(StatusIcon, { complete, active, stepNumber }),
    /* @__PURE__ */ jsx(Text$1, { color: getTextColor(), children: label })
  ] });
};
const StatusIcon = ({ complete, active, stepNumber }) => {
  if (complete || active) {
    return /* @__PURE__ */ jsx(Icon, { name: "circle-check", color: "green-9", variant: "filled", size: 16 });
  }
  return /* @__PURE__ */ jsx("div", { className: "flex size-4 items-center justify-center rounded-full bg-muted-foreground-100", children: /* @__PURE__ */ jsx(Text$1, { color: "white-opacity-1 leading-none", variant: "footnote", children: stepNumber }) });
};
const SheetTabs = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  TabsPrimitive.Root,
  {
    ref,
    className: cn("flex flex-col", className),
    ...props
  }
));
SheetTabs.displayName = TabsPrimitive.Root.displayName;
const SheetTabsList = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  TabsPrimitive.List,
  {
    ref,
    className: cn(
      "gap-1 inline-flex items-center bg-background-80 text-muted-foreground",
      className
    ),
    ...props
  }
));
SheetTabsList.displayName = TabsPrimitive.List.displayName;
const SheetTabsTrigger = React.forwardRef(({ className, children, iconName = "table", ...props }, ref) => /* @__PURE__ */ jsxs(
  TabsPrimitive.Trigger,
  {
    ref,
    className: cn(
      "gap-1 border border-transparent inline-flex items-center justify-center whitespace-nowrap px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
      "data-[state=active]:text-foreground data-[state=active]:shadow-sm data-[state=active]:border-border-100 data-[state=active]:rounded-sm data-[state=active]:bg-base-white data-[state=active]:font-semibold",
      className
    ),
    ...props,
    children: [
      /* @__PURE__ */ jsx(Icon, { name: iconName, size: 16 }),
      children
    ]
  }
));
SheetTabsTrigger.displayName = TabsPrimitive.Trigger.displayName;
const SheetTabsContent = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  TabsPrimitive.Content,
  {
    ref,
    className: cn(
      "ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      className
    ),
    ...props
  }
));
SheetTabsContent.displayName = TabsPrimitive.Content.displayName;
const MappingRow = ({
  sourceField,
  destinationField,
  className,
  destinationOptions,
  onDestinationFieldChange,
  onAccept,
  onReject
}) => {
  const [open, setOpen] = useState(false);
  const dropdownOptions = destinationOptions == null ? void 0 : destinationOptions.map((option) => ({
    key: option,
    label: option,
    value: option
  }));
  const handleOptionSelect = (option) => {
    setOpen(false);
    onDestinationFieldChange == null ? void 0 : onDestinationFieldChange(option.value);
  };
  return /* @__PURE__ */ jsxs("div", { className: cn("flex bg-card rounded-sm p-3 w-full gap-4", className), children: [
    /* @__PURE__ */ jsxs("div", { className: "flex basis-1/2 items-center justify-between", children: [
      /* @__PURE__ */ jsx(
        Text$1,
        {
          variant: "body",
          className: "rounded-xs border border-card px-2 py-1",
          children: sourceField
        }
      ),
      /* @__PURE__ */ jsx(Icon, { name: "arrow-right", size: 16 })
    ] }),
    /* @__PURE__ */ jsx("div", { className: "flex basis-1/2 items-center justify-between", children: destinationOptions && destinationOptions.length > 1 ? /* @__PURE__ */ jsxs(DropdownMenu, { open, onOpenChange: setOpen, children: [
      /* @__PURE__ */ jsx(DropdownMenuTrigger, { asChild: true, children: /* @__PURE__ */ jsxs(
        Button,
        {
          variant: "outline",
          className: "w-full justify-between rounded-xs",
          children: [
            destinationField,
            /* @__PURE__ */ jsx(
              Icon,
              {
                name: "chevron-down-small",
                className: `ml-2 size-4 opacity-50 transition-transform ${open ? "rotate-180" : ""}`
              }
            )
          ]
        }
      ) }),
      /* @__PURE__ */ jsx(DropdownMenuContent, { className: "w-[var(--radix-dropdown-menu-trigger-width)] rounded-xs p-0", children: /* @__PURE__ */ jsx(
        DropdownSearchContent,
        {
          options: dropdownOptions ?? [],
          onOptionSelect: handleOptionSelect,
          placeholder: "Select a destination"
        }
      ) })
    ] }) : /* @__PURE__ */ jsxs(Fragment$1, { children: [
      /* @__PURE__ */ jsx(Text$1, { variant: "body", className: "rounded-xs border px-2 py-1", children: destinationField }),
      /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-1", children: [
        /* @__PURE__ */ jsx(
          "button",
          {
            onClick: onReject,
            className: cn(
              "size-5 rounded-xs border border-transparent flex items-center justify-center",
              "hover:border-gray-3"
            ),
            children: /* @__PURE__ */ jsx(Icon, { name: "cross-large", size: 8 })
          }
        ),
        /* @__PURE__ */ jsx(
          "button",
          {
            onClick: onAccept,
            className: cn(
              "flex size-5 items-center justify-center rounded-xs border border-transparent text-green-9",
              "hover:bg-green-9 hover:text-card"
            ),
            children: /* @__PURE__ */ jsx(Icon, { name: "checkmark", size: 8 })
          }
        )
      ] })
    ] }) })
  ] });
};
const ToastProvider = ToastPrimitives.Provider;
const ToastViewport = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  ToastPrimitives.Viewport,
  {
    ref,
    className: cn(
      "fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]",
      className
    ),
    ...props
  }
));
ToastViewport.displayName = ToastPrimitives.Viewport.displayName;
const toastVariants = cva(
  "group pointer-events-auto relative flex w-full items-center justify-between space-x-2 overflow-hidden rounded-md border p-4 pr-6 shadow-lg transition-all data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full",
  {
    variants: {
      variant: {
        default: "border bg-background-90 text-foreground",
        destructive: "destructive group border-destructive-100 bg-background-90 text-destructive-100"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
const Toast = React.forwardRef(({ className, variant, ...props }, ref) => {
  return /* @__PURE__ */ jsx(
    ToastPrimitives.Root,
    {
      ref,
      className: cn(toastVariants({ variant }), className),
      ...props
    }
  );
});
Toast.displayName = ToastPrimitives.Root.displayName;
const ToastAction = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  ToastPrimitives.Action,
  {
    ref,
    className: cn(
      "inline-flex h-8 shrink-0 items-center justify-center rounded-md border bg-transparent px-3 text-sm font-medium transition-colors hover:bg-secondary focus:outline-none focus:ring-1 focus:ring-ring disabled:pointer-events-none disabled:opacity-50 group-[.destructive]:border-muted/40 group-[.destructive]:hover:border-destructive/30 group-[.destructive]:hover:bg-destructive group-[.destructive]:hover:text-destructive-foreground group-[.destructive]:focus:ring-destructive",
      className
    ),
    ...props
  }
));
ToastAction.displayName = ToastPrimitives.Action.displayName;
const ToastClose = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  ToastPrimitives.Close,
  {
    ref,
    className: cn(
      "absolute right-1 top-1 rounded-md p-1 text-foreground/50 opacity-0 transition-opacity hover:text-foreground focus:opacity-100 focus:outline-none focus:ring-1 group-hover:opacity-100 group-[.destructive]:text-red-300 group-[.destructive]:hover:text-red-50 group-[.destructive]:focus:ring-red-400 group-[.destructive]:focus:ring-offset-red-600",
      className
    ),
    "toast-close": "",
    ...props,
    children: /* @__PURE__ */ jsx(Icon, { name: "cross-small", size: 12 })
  }
));
ToastClose.displayName = ToastPrimitives.Close.displayName;
const ToastTitle = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  ToastPrimitives.Title,
  {
    ref,
    className: cn("text-sm font-semibold [&+div]:text-xs", className),
    ...props
  }
));
ToastTitle.displayName = ToastPrimitives.Title.displayName;
const ToastDescription = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  ToastPrimitives.Description,
  {
    ref,
    className: cn("text-sm opacity-90", className),
    ...props
  }
));
ToastDescription.displayName = ToastPrimitives.Description.displayName;
const TOAST_LIMIT = 1;
const TOAST_REMOVE_DELAY = 1e6;
let count = 0;
function genId() {
  count = (count + 1) % Number.MAX_SAFE_INTEGER;
  return count.toString();
}
const toastTimeouts = /* @__PURE__ */ new Map();
const addToRemoveQueue = (toastId) => {
  if (toastTimeouts.has(toastId)) {
    return;
  }
  const timeout = setTimeout(() => {
    toastTimeouts.delete(toastId);
    dispatch({
      type: "REMOVE_TOAST",
      toastId
    });
  }, TOAST_REMOVE_DELAY);
  toastTimeouts.set(toastId, timeout);
};
const reducer = (state, action) => {
  switch (action.type) {
    case "ADD_TOAST":
      return {
        ...state,
        toasts: [action.toast, ...state.toasts].slice(0, TOAST_LIMIT)
      };
    case "UPDATE_TOAST":
      return {
        ...state,
        toasts: state.toasts.map(
          (t) => t.id === action.toast.id ? { ...t, ...action.toast } : t
        )
      };
    case "DISMISS_TOAST": {
      const { toastId } = action;
      if (toastId) {
        addToRemoveQueue(toastId);
      } else {
        state.toasts.forEach((toast2) => {
          addToRemoveQueue(toast2.id);
        });
      }
      return {
        ...state,
        toasts: state.toasts.map(
          (t) => t.id === toastId || toastId === void 0 ? {
            ...t,
            open: false
          } : t
        )
      };
    }
    case "REMOVE_TOAST":
      if (action.toastId === void 0) {
        return {
          ...state,
          toasts: []
        };
      }
      return {
        ...state,
        toasts: state.toasts.filter((t) => t.id !== action.toastId)
      };
  }
};
const listeners = [];
let memoryState = { toasts: [] };
function dispatch(action) {
  memoryState = reducer(memoryState, action);
  listeners.forEach((listener) => {
    listener(memoryState);
  });
}
function toast({ ...props }) {
  const id = genId();
  const update = (props2) => dispatch({
    type: "UPDATE_TOAST",
    toast: { ...props2, id }
  });
  const dismiss = () => dispatch({ type: "DISMISS_TOAST", toastId: id });
  dispatch({
    type: "ADD_TOAST",
    toast: {
      ...props,
      id,
      open: true,
      onOpenChange: (open) => {
        if (!open) dismiss();
      }
    }
  });
  return {
    id,
    dismiss,
    update
  };
}
function useToast() {
  const [state, setState] = React.useState(memoryState);
  React.useEffect(() => {
    listeners.push(setState);
    return () => {
      const index = listeners.indexOf(setState);
      if (index > -1) {
        listeners.splice(index, 1);
      }
    };
  }, [state]);
  return {
    ...state,
    toast,
    dismiss: (toastId) => dispatch({ type: "DISMISS_TOAST", toastId })
  };
}
function Toaster() {
  const { toasts } = useToast();
  return /* @__PURE__ */ jsxs(ToastProvider, { children: [
    toasts.map(function({ id, title, description, action, ...props }) {
      return /* @__PURE__ */ jsxs(Toast, { ...props, children: [
        /* @__PURE__ */ jsxs("div", { className: "grid gap-1", children: [
          title && /* @__PURE__ */ jsx(ToastTitle, { children: title }),
          description && /* @__PURE__ */ jsx(ToastDescription, { children: description })
        ] }),
        action,
        /* @__PURE__ */ jsx(ToastClose, {})
      ] }, id);
    }),
    /* @__PURE__ */ jsx(ToastViewport, {})
  ] });
}
const VisuallyHidden = VisuallyHiddenPrimative.Root;
VisuallyHidden.displayName = VisuallyHiddenPrimative.Root.displayName;
const usePaginate = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const onChangePage = useCallback(
    (page) => {
      const newPage = typeof page === "string" ? Number.parseInt(page) : page;
      if (!isNaN(newPage)) {
        setCurrentPage(newPage);
      }
    },
    [setCurrentPage, currentPage]
  );
  return { onChangePage, currentPage, setCurrentPage };
};
const range = (start, end) => {
  const length = end - start + 1;
  return Array.from({ length }, (_, idx) => idx + start);
};
const buildDisplayRange = (currentPage, rangeSize, totalPageCount) => {
  if (currentPage <= 2) {
    return range(2, rangeSize + 1);
  }
  if (currentPage >= totalPageCount - 1) {
    return range(totalPageCount - rangeSize, totalPageCount - 1);
  }
  return range(currentPage - 1, currentPage + rangeSize - 2);
};
const usePagination = ({
  totalCount,
  displayedPages = 5,
  pageSize = 10,
  currentPage
}) => {
  const pagination = useMemo(() => {
    const totalPageCount = Math.ceil(totalCount / pageSize);
    const variableRangeSize = displayedPages - 2;
    const maxPages = displayedPages > 5 ? displayedPages : 5;
    if (maxPages >= totalPageCount) {
      return { displayRange: range(1, totalPageCount), totalPageCount };
    }
    const displayRange = [1, totalPageCount];
    const midRange = buildDisplayRange(
      currentPage,
      variableRangeSize,
      totalPageCount
    );
    displayRange.splice(1, 0, ...midRange);
    if (!midRange.includes(2)) {
      displayRange.splice(1, 0, "...");
    }
    if (!midRange.includes(totalPageCount - 1)) {
      displayRange.splice(displayRange.length - 1, 0, "...");
    }
    return { displayRange, totalPageCount };
  }, [totalCount, pageSize, displayedPages, currentPage]);
  return pagination;
};
const useSort = ({
  data = []
}) => {
  const [currentSortKey, setCurrentSortKey] = useState("");
  const [currentSortDirection, setCurrentSortDirection] = useState("none");
  const handleSort = useCallback(
    (key, direction) => {
      setCurrentSortKey(key);
      setCurrentSortDirection(direction);
      return direction === "none" ? data : [...data].sort((a, b) => {
        var _a, _b;
        const valA = (_a = a[key]) == null ? void 0 : _a.toLowerCase();
        const valB = (_b = b[key]) == null ? void 0 : _b.toLowerCase();
        if (valA < valB) return direction === "asc" ? -1 : 1;
        if (valA > valB) return direction === "asc" ? 1 : -1;
        return 0;
      });
    },
    [data]
  );
  const sortedData = useMemo(
    () => data ? handleSort(currentSortKey, currentSortDirection) : [],
    [data, currentSortKey, currentSortDirection]
  );
  const SortButton = useCallback(
    ({ sortKey, sortType, ...props }) => /* @__PURE__ */ jsx(
      SortButtonElement,
      {
        handleSort,
        sortType,
        sortKey,
        direction: currentSortKey === sortKey ? currentSortDirection : "none",
        ...props
      }
    ),
    [handleSort, currentSortKey, currentSortDirection]
  );
  return {
    SortButton,
    sortedData
  };
};
const nextDirection = {
  none: "asc",
  asc: "desc",
  desc: "none"
};
const sortIcon = {
  asc: {
    alphabetical: "filter-ascending",
    numeric: "filter-asc"
  },
  desc: {
    alphabetical: "filter-descending",
    numeric: "filter-desc"
  },
  none: {
    alphabetical: "arrow-top-bottom",
    numeric: "arrow-top-bottom"
  }
};
const SortButtonElement = ({
  sortKey,
  sortType,
  handleSort,
  direction,
  iconSize,
  children,
  ...props
}) => {
  const handleClick = () => {
    const newDirection = nextDirection[direction];
    handleSort(sortKey, newDirection);
  };
  return /* @__PURE__ */ jsxs(Button, { onClick: handleClick, variant: "outline", ...props, children: [
    /* @__PURE__ */ jsx(Icon, { name: sortIcon[direction][sortType], size: iconSize }),
    children
  ] });
};
export {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Alert,
  AlertDescription,
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  AlertDialogPortal,
  AlertDialogTitle,
  AlertDialogTrigger,
  AlertTitle,
  Area,
  AreaChart,
  AutoProgress,
  AutoProgressHairline,
  Avatar,
  AvatarFallback,
  AvatarImage,
  Badge,
  Bar,
  BarChart,
  BoundedDialogContainer,
  Breadcrumb,
  BreadcrumbEllipsis,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Brush,
  Button,
  Calendar,
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
  CartesianGrid,
  Cell,
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
  ChatInput,
  Checkbox,
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  CommandSeparator,
  ContextMenu,
  ContextMenuCheckboxItem,
  ContextMenuContent,
  ContextMenuGroup,
  ContextMenuIcon,
  ContextMenuItem,
  ContextMenuLabel,
  ContextMenuRadioGroup,
  ContextMenuRadioItem,
  ContextMenuSeparator,
  ContextMenuShortcut,
  ContextMenuSub,
  ContextMenuSubContent,
  ContextMenuSubTrigger,
  ContextMenuTrigger,
  Dialog,
  DialogClose,
  DialogCloseButton,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogTitle,
  DialogTrigger,
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerFooter,
  DrawerOverlay,
  DrawerPortal,
  DrawerTitle,
  DrawerToggle,
  DrawerTrigger,
  DropdownInput,
  DropdownListContent,
  DropdownMenu,
  DropdownMenuArrow,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuPortal,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
  DropdownSearchContent,
  FieldFilterDropdown,
  Filter,
  FilterBlock,
  FilterByValue,
  FilterCollection,
  FilterFieldElement,
  FilterOperationElement,
  FilterValidationTabs,
  FilterValueElement,
  ICON_LIST,
  Icon,
  Input,
  Label,
  Legend,
  Line,
  LineChart,
  MappingRow,
  MultiSelect,
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
  Pie,
  PieChart,
  Popover,
  PopoverAnchor,
  PopoverContent,
  PopoverTrigger,
  Progress,
  ProgressBar,
  RadioGroup,
  RadioGroupItem,
  ReferenceLine,
  ResponsiveContainer,
  RichMentionsAutocomplete,
  RichMentionsContext,
  RichMentionsInput,
  RichMentionsProvider,
  Separator,
  SheetTabs,
  SheetTabsContent,
  SheetTabsList,
  SheetTabsTrigger,
  SimpleSearchBar,
  Spinner,
  Switch,
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableFooter,
  TableHead,
  TableHeader,
  TableRow,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
  Text$1 as Text,
  TextArea,
  Toast,
  ToastAction,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
  Toaster,
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
  Tray,
  TrayFooter,
  TrayHeader,
  TrayTab,
  VisuallyHidden,
  XAxis,
  YAxis,
  buttonVariants,
  cn,
  processMentionsInHTML,
  textVariants,
  toast,
  usePaginate,
  usePagination,
  useSort,
  useToast
};
